/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/alt-text */
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import PaymentIcon from "@mui/icons-material/Payment";
import {
  Box,
  IconButton,
  Modal,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tabs,
  Tab,
  MenuItem,
  Select,
  Button,
  ListItemIcon,
  TextField,
  Checkbox,
  ListItemText,
  Drawer,
  Typography,
  FormControl,
  InputLabel,
  RadioGroup,
  FormControlLabel,
  Radio,
  Tooltip,
  Stack,
} from "@mui/material";
import SearchBar from "../../components/SearchBar";
import FilterListIcon from "@mui/icons-material/FilterList";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import UploadFileOutlinedIcon from "@mui/icons-material/UploadFileOutlined";
import SmartToyOutlinedIcon from "@mui/icons-material/SmartToyOutlined";
import AccountBalanceWalletOutlinedIcon from "@mui/icons-material/AccountBalanceWalletOutlined";
import TimelineOutlinedIcon from "@mui/icons-material/TimelineOutlined";
import PaymentsOutlinedIcon from "@mui/icons-material/PaymentsOutlined";
import MessageOutlinedIcon from "@mui/icons-material/MessageOutlined";
import SendIcon from "@mui/icons-material/Send";
import MailOutlineIcon from "@mui/icons-material/MailOutline";
import SmsOutlinedIcon from "@mui/icons-material/SmsOutlined";
import NotificationsNoneIcon from "@mui/icons-material/NotificationsNone";
import NoteAddOutlinedIcon from "@mui/icons-material/NoteAddOutlined";
import FlagOutlinedIcon from "@mui/icons-material/FlagOutlined";
import HourglassTopOutlinedIcon from "@mui/icons-material/HourglassTopOutlined";
import AttachMoneyOutlinedIcon from "@mui/icons-material/AttachMoneyOutlined";
import AccessTimeOutlinedIcon from "@mui/icons-material/AccessTimeOutlined";
import EventOutlinedIcon from "@mui/icons-material/EventOutlined";
import CheckCircleOutlineOutlinedIcon from "@mui/icons-material/CheckCircleOutlineOutlined";
import BlockOutlinedIcon from "@mui/icons-material/BlockOutlined";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import PersonAddAltIcon from "@mui/icons-material/PersonAddAlt";
import GroupsIcon from "@mui/icons-material/Groups";
import RejectReasonModal from "../../Modals/rejectReason";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import Menu from "@mui/material/Menu";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import AddIcon from "@mui/icons-material/Add";
import GetAppIcon from "@mui/icons-material/GetApp";
import IosShareIcon from "@mui/icons-material/IosShare";
import TagIcon from "@mui/icons-material/Tag";
import CloseIcon from "@mui/icons-material/Close";
import GpsFixedIcon from "@mui/icons-material/GpsFixed";
import SwitchToggle from "../../components/SwitchToggle";
import PendingActionsIcon from "@mui/icons-material/PendingActions";
import ReportProblemIcon from "@mui/icons-material/ReportProblem";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import FavoriteIcon from "@mui/icons-material/Favorite";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import StarIcon from "@mui/icons-material/Star";
import CurrencyExchangeIcon from "@mui/icons-material/CurrencyExchange";
import Inventory2Icon from "@mui/icons-material/Inventory2";
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";
import PersonSearchIcon from "@mui/icons-material/PersonSearch";
import AutorenewIcon from "@mui/icons-material/Autorenew";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import WorkspacePremiumIcon from "@mui/icons-material/WorkspacePremium";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import PersonOffIcon from "@mui/icons-material/PersonOff";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import HistoryIcon from "@mui/icons-material/History";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import BlockIcon from "@mui/icons-material/Block";
import LifecycleOverview from "../../Modals/lifecycle_overview";
import AddMilestone from "../../Modals/addMilestone";
import SendPayout from "../../Modals/sendPayout";
import CreateSegment from "../../Modals/createSegment";
import ViewHealthScores from "../../Modals/viewHealthScores";
import BulkNotify from "../../Modals/bulkNotify";
import AddVendorCommunications from "../../Modals/addVendorCommunications";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}
function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <>{children}</>}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}
const ManageVendors = () => {
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState("");
  const [valueTabs, setValueTabs] = useState(0);
  const handleChangeTabs = (event: React.SyntheticEvent, newValue: number) => {
    setValueTabs(newValue);
  };
  const [enabled, setEnabled] = useState(false);

  const [valueTabs1, setValueTabs1] = useState(0);
  const handleChangeTabs1 = (event: React.SyntheticEvent, newValue: number) => {
    setValueTabs1(newValue);
  };
  const [valueTabs2, setValueTabs2] = useState(0);
  const handleChangeTabs2 = (event: React.SyntheticEvent, newValue: number) => {
    setValueTabs2(newValue);
  };
  const [selected, setSelected] = useState<string[]>([]);
  const [expandedRow, setExpandedRow] = useState<string | null>(null);
  const [sortByAI, setSortByAI] = useState(false);
  const [expandedAI, setExpandedAI] = useState<{ [key: string]: boolean }>({});
  const [timeFilter, setTimeFilter] = useState("30d");
  const [customDateRange, setCustomDateRange] = useState({ from: "", to: "" });
  const [selectedCategory, setSelectedCategory] = useState("All");
  const [selectedTier, setSelectedTier] = useState("All");

  const vendorColumns = [
    "Select",
    "Business Details",
    "Vendor Details",
    "Status",
    "Health Score",
    "Subscription",
    "Onboarding Date",
    "Revenue",
    "Indicators",
    "AI Insights",
    "Suspend",
    "Contract",
    "Actions",
  ];

  const applicationColumns = [
    "Select",
    "Business Details",
    "Vendor Details",
    "Category",
    "Type",
    "Risk",
    "Quality",
    "Compliance",
    "Revenue Potential",
    "Pending Duration",
    "Application Status",
    "Applied On",
    "Actions",
  ];

  const performanceColumns = [
    "Vendor Details",
    "Business Details",
    "Period",
    "Orders",
    "Completed",
    "GMV",
    "Commission",
    "Net to Vendor",
    "Revenue",
    "Rating",
    "On-Time %",
    "Health",
    "AI Insights",
    "Actions",
  ];

  const productColumns = [
    "Select",
    "Product",
    "Vendor Details",
    "Business Details",
    "Category",
    "Price",
    "Stock",
    "Sales",
    "Listing Status",
    "Sale Status",
    "AI Risk Level",
    "Recommended AI Action",
    "Why AI recommends this",
    "Actions",
  ];

  const vendorCommunicationColumns = [
    "CHANNEL",
    "SUBJECT",
    "TYPE",
    "SEGMENT / AUDIENCE",
    "RECIPIENTS",
    "DELIVERED",
    "OPENED / CTR",
    "STATUS",
    "SENT AT",
    "ACTIONS",
  ];

  const subscriptionManagementColumns = [
    "Select",
    "Business Details",
    "Vendor Details",
    "Subscription Name",
    "Status",
    "Usage Level",
    "Revenue",
    "AI Cost Impact",
    "Actions",
  ];

  const documentColumns = [
    "Sr. No.",
    "Business Details",
    "Vendor Details",
    "Document Name",
    "Document Upload Date",
    "View Document",
    "Document Expiry Date",
    "Suspend Document",
  ];

  const payoutColumns = [
    "Vendor Details",
    "Business Details",
    "Period",
    "Net Amount",
    "Status",
    "AI Recommendation",
    "Why AI recommends this",
    "Action",
  ];

  const lifecycleColumns = [
    "Vendor",
    "From",
    "To",
    "Reason",
    "Trigger",
    "Date",
    "Actions",
  ];

  const [visibleVendorColumns, setVisibleVendorColumns] =
    useState<string[]>(vendorColumns);
  const [visibleApplicationColumns, setVisibleApplicationColumns] =
    useState<string[]>(applicationColumns);
  const [visiblePerformanceColumns, setVisiblePerformanceColumns] =
    useState<string[]>(performanceColumns);
  const [visibleProductColumns, setVisibleProductColumns] =
    useState<string[]>(productColumns);
  const [visibleCommColumns, setVisibleCommColumns] = useState<string[]>(
    vendorCommunicationColumns,
  );
  const [visibleSubscriptionColumns, setVisibleSubscriptionColumns] =
    useState<string[]>(subscriptionManagementColumns);
  const [visibleDocumentColumns, setVisibleDocumentColumns] =
    useState<string[]>(documentColumns);
  const [visiblePayoutColumns, setVisiblePayoutColumns] =
    useState<string[]>(payoutColumns);
  const [visibleLifecycleColumns, setVisibleLifecycleColumns] =
    useState<string[]>(lifecycleColumns);

  // Vendor Communications state (mirrors manage-customers communications)
  const [vendorChannelTab, setVendorChannelTab] = useState(0);
  const handleVendorChannelTab = (_: any, val: number) =>
    setVendorChannelTab(val);
  const [openVendorComm, setOpenVendorComm] = useState(false);
  const [selectedVendorComm, setSelectedVendorComm] = useState<any>(null);
  const [openVendorCommDetails, setOpenVendorCommDetails] = useState(false);
  const handleCloseVendorCommDetails = () => setOpenVendorCommDetails(false);


  const vendorCommunicationData = [
    {
      id: 1,
      channel: "Email",
      subject: "Tier Upgrade Offer for Top Vendors",
      type: "Marketing",
      segment: "Vendors ready for tier upgrade",
      recipients: 780,
      delivered: 742,
      ctr: "18% / 4.2%",
      status: "active",
      sentAt: "2025-01-10",
      failed: 38,
      consentIssues: 22,
      revenueInfluenced: "AED 185K",
    },
    {
      id: 2,
      channel: "SMS",
      subject: "Fulfillment SLA Alert",
      type: "Service / Alert",
      segment: "Low Fulfillment SLA Vendors",
      recipients: 340,
      delivered: 326,
      ctr: "—",
      status: "warning",
      sentAt: "2025-01-12",
      failed: 14,
      consentIssues: 9,
      revenueInfluenced: "—",
    },
    {
      id: 3,
      channel: "Push",
      subject: "New Promo Tools Available",
      type: "Marketing",
      segment: "All Active Vendors",
      recipients: 980,
      delivered: 901,
      ctr: "12% / 2.1%",
      status: "active",
      sentAt: "2025-01-15",
      failed: 79,
      consentIssues: 0,
      revenueInfluenced: "AED 62K",
    },
  ];

  const toggleSelect = (id: string) => {
    setSelected((prev) =>
      prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id],
    );
  };

  const [selectedProducts, setSelectedProducts] = useState<number[]>([]);
  const [openProductDrawer, setOpenProductDrawer] = useState(false);
  const [selectedProductDetails, setSelectedProductDetails] =
    useState<any>(null);
  const [selectedPayout, setSelectedPayout] = useState<any>(null);
  const [openPayoutDrawer, setOpenPayoutDrawer] = useState(false);
  const [payoutSearchTerm, setPayoutSearchTerm] = useState("");
  const [payoutStatusFilter, setPayoutStatusFilter] = useState("All");
  const [payoutRiskFilter, setPayoutRiskFilter] = useState("All");

  const toggleProductSelect = (id: number) => {
    setSelectedProducts((prev) =>
      prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id],
    );
  };

  const toggleExpand = (id: string) => {
    setExpandedRow((prev) => (prev === id ? null : id));
  };

  const isAutoApproved = (v: any) =>
    v.riskScore < 20 &&
    v.documentsVerified &&
    !v.duplicateCheck &&
    v.aiScore > 90;

  const [vendorData, setVendorData] = useState([
    {
      id: "VND-001",
      name: "Fashion House Dubai",
      email: "contact@fashionhouse.ae",
      phone: "+971501234567",
      type: "Fashion",
      applicationtype: "New vendor",
      status: "Under Review",
      date: "12-06-2024",
      stores: "6",
      health: 92.5,
      indicator: "⚠ Declining performance",
      tier: "Enterprise",
      revenue: "AED 1,250,000",
      // ✅ NEW
      riskScore: 18, // 0–100
      qualityScore: 92,
      complianceReady: true,
      revenuePotential: "High",
      pendingDays: 2,
      aiScore: 94,
      documentsVerified: true,
      duplicateCheck: false,
      systemApproved: true,
      blockReason: null,
      blockingRole: null,
      unblockActions: null,
      fastTrackSuggestion:
        "Fast-track this vendor by skipping basic training and moving directly to listing review.",
    },
    {
      id: "VND-002",
      name: "TechGadgets UAE",
      email: "info@techgadgets.ae",
      phone: "+971502345678",
      applicationtype: "Product Addition",
      type: "Electronics",
      status: "Blocked",
      date: "01-06-2024",
      stores: "1",
      health: 92.5,
      indicator: "⚠ Declining performance",
      tier: "Enterprise",
      revenue: "AED 1,250,000",

      riskScore: 42,
      qualityScore: 71,
      complianceReady: false,
      revenuePotential: "Medium",
      pendingDays: 14,
      aiScore: 68,
      documentsVerified: false,
      duplicateCheck: false,
      systemApproved: false,
      blockReason: "Compliance violation: Incomplete documentation",
      blockingRole: "System",
      unblockActions:
        "Submit missing VAT certificate and complete platform training",
      fastTrackSuggestion: null,
    },
  ]);



  const vendorPerformanceData = [
    {
      id: "1",
      name: "Sports Zone",
      periodStart: "11/11/2025",
      periodEnd: "17/11/2025",
      orders: 160,
      completed: 154,
      gmv: "AED 48,000",
      commission: "AED 7,200",
      netToVendor: "AED 40,800",
      revenue: "AED 7,200",
      rating: 3,
      onTime: 83.7,
      health: 71,
      riskScore: 29,
      healthMetrics: {
        fulfillment: 85,
        onTime: 84,
        completion: 96,
        complaints: 2,
        returnRate: 4,
      },
      performanceBreakdown: {
        completed: { delivered: 154, cancelled: 4, returned: 2 },
        gmv: {
          products: "AED 44,000",
          shipping: "AED 3,000",
          vat: "AED 1,000",
        },
        commission: { base: "AED 6,800", adjust: "AED 400" },
        revenue: { base: "AED 7,200", ads: "AED 0" },
        onTime: { early: "45%", justInTime: "39%", delayed: "16%" },
        netToVendor: { gmv: "AED 48,000", deductions: "AED 7,200" },
      },
      aiInsight:
        "Delivery delays increased by 14% vs last period. Risk of customer complaints rising.",
      aiRecommendation: {
        action: "Send warning",
        reason: "On-time delivery < 85% for 2 consecutive periods",
      },
    },
    {
      id: "2",
      name: "Beauty Palace",
      periodStart: "11/11/2025",
      periodEnd: "17/11/2025",
      orders: 101,
      completed: 84,
      gmv: "AED 15,150",
      commission: "AED 2,272",
      netToVendor: "AED 12,878",
      revenue: "AED 2,272",
      rating: 3,
      onTime: 75.0,
      health: 91,
      riskScore: 9,
      healthMetrics: {
        fulfillment: 95,
        onTime: 75,
        completion: 83,
        complaints: 0,
        returnRate: 2,
      },
      performanceBreakdown: {
        completed: { delivered: 84, cancelled: 12, returned: 5 },
        gmv: { products: "AED 13,000", shipping: "AED 1,500", vat: "AED 650" },
        commission: { base: "AED 2,100", adjust: "AED 172" },
        revenue: { base: "AED 2,272", ads: "AED 0" },
        onTime: { early: "40%", justInTime: "35%", delayed: "25%" },
        netToVendor: { gmv: "AED 15,150", deductions: "AED 2,272" },
      },
      aiInsight:
        "Consistent high margins. Recommended for Preferred Vendor status.",
      aiRecommendation: {
        action: "Promote to Preferred",
        reason: "Health > 90 and completion > 95% historically",
      },
    },
    {
      id: "3",
      name: "Home Essentials",
      periodStart: "11/11/2025",
      periodEnd: "17/11/2025",
      orders: 71,
      completed: 52,
      gmv: "AED 21,300",
      commission: "AED 3,195",
      netToVendor: "AED 18,105",
      revenue: "AED 3,195",
      rating: 3,
      onTime: 73.2,
      health: 75,
      riskScore: 25,
      healthMetrics: {
        fulfillment: 78,
        onTime: 73,
        completion: 73,
        complaints: 5,
        returnRate: 8,
      },
      performanceBreakdown: {
        completed: { delivered: 52, cancelled: 14, returned: 5 },
        gmv: { products: "AED 19,000", shipping: "AED 1,500", vat: "AED 800" },
        commission: { base: "AED 3,000", adjust: "AED 195" },
        revenue: { base: "AED 3,195", ads: "AED 0" },
        onTime: { early: "30%", justInTime: "43%", delayed: "27%" },
        netToVendor: { gmv: "AED 21,300", deductions: "AED 3,195" },
      },
      aiInsight: "High complaints on last 5 orders. Quality check required.",
      aiRecommendation: {
        action: "Request PIP",
        reason: "Health < 75 and Complaints > 3",
      },
    },
    {
      id: "4",
      name: "Fashion House Dubai",
      periodStart: "11/11/2025",
      periodEnd: "17/11/2025",
      orders: 157,
      completed: 149,
      gmv: "AED 78,500",
      commission: "AED 11,775",
      netToVendor: "AED 66,725",
      revenue: "AED 11,775",
      rating: 3,
      onTime: 87.2,
      health: 81,
      riskScore: 19,
      healthMetrics: {
        fulfillment: 92,
        onTime: 87,
        completion: 95,
        complaints: 1,
        returnRate: 3,
      },
      performanceBreakdown: {
        completed: { delivered: 149, cancelled: 5, returned: 3 },
        gmv: {
          products: "AED 72,000",
          shipping: "AED 4,000",
          vat: "AED 2,500",
        },
        commission: { base: "AED 11,000", adjust: "AED 775" },
        revenue: { base: "AED 11,775", ads: "AED 0" },
        onTime: { early: "55%", justInTime: "32%", delayed: "13%" },
        netToVendor: { gmv: "AED 78,500", deductions: "AED 11,775" },
      },
      aiInsight: "Stable performance. Strong growth potential.",
      aiRecommendation: {
        action: "N/A",
        reason: "Maintain current status",
      },
    },
  ];
  const productData = [
    {
      id: 1,
      productId: "SKU-1001",
      productName: "Sports Zone Jacket",
      vendorName: "Sports Zone",
      category: "Fashion",
      price: 149.99,
      stock: 8,
      sales: 12,
      listingStatus: "Approved",
      saleStatus: "Active",
      aiaction: "Accept",
      aiWhy:
        "Vendor trust score is high (92) and price matches category median.",
      aiRiskLevel: "Low",
      approvalScore: 88,
      scoreBreakdown: {
        trust: 30,
        risk: 18,
        quality: 15,
        price: 12,
        stock: 13,
      },
      description: "Breathable windbreaker jacket for all seasons.",
      images: ["/static/images/p1.jpg"],
    },
    {
      id: 2,
      productId: "SKU-1002",
      productName: "Beauty Glow Serum",
      vendorName: "Beauty Place",
      category: "Beauty",
      price: 89.5,
      stock: 42,
      sales: 45,
      listingStatus: "Pending Review",
      saleStatus: "Paused",
      aiaction: "Request Changes",
      aiWhy: "Main product image quality is below 600px threshold.",
      aiRiskLevel: "Medium",
      approvalScore: 72,
      scoreBreakdown: {
        trust: 25,
        risk: 15,
        quality: 10,
        price: 12,
        stock: 10,
      },
      description: "Advanced vitamin C serum for radiant skin.",
      images: ["/static/images/p2.jpg"],
    },
    {
      id: 3,
      productId: "SKU-1003",
      productName: "Home Essentials Lamp",
      vendorName: "Home Essentials",
      category: "Home & Living",
      price: 199.0,
      stock: 3,
      sales: 2,
      listingStatus: "Rejected",
      saleStatus: "Suspended",
      aiaction: "Reject",
      aiWhy:
        "Vendor health score < 75 and multiple customer complaints on this category.",
      aiRiskLevel: "High",
      approvalScore: 45,
      scoreBreakdown: { trust: 15, risk: 5, quality: 10, price: 10, stock: 5 },
      description: "Minimalist desk lamp with adjustable brightness.",
      images: ["/static/images/p3.jpg"],
    },
    {
      id: 4,
      productId: "SKU-1004",
      productName: "TechGadgets Wireless Earbuds",
      vendorName: "TechGadgets UAE",
      category: "Electronics",
      price: 249.99,
      stock: 55,
      aiaction: "Reject",

      sales: 0,
      status: "active",
    },
    {
      id: 5,
      productId: "SKU-1005",
      productName: "Fashion House Dress",
      vendorName: "Fashion House Dubai",
      category: "Fashion",
      price: 329.0,
      stock: 12,
      aiaction: "Accept",

      sales: 0,
      status: "active",
    },
    {
      id: 6,
      productId: "SKU-1006",
      productName: "Kitchen Pro Blender",
      vendorName: "Home Essentials",
      category: "Kitchen",
      price: 399.0,
      stock: 6,
      aiaction: "Reject",

      sales: 0,
      status: "low_stock",
    },
    {
      id: 7,
      productId: "SKU-1007",
      productName: "Luxury Skincare Kit",
      vendorName: "Beauty Place",
      category: "Beauty",
      price: 499.99,
      stock: 28,
      aiaction: "Reject",

      sales: 0,
      status: "active",
    },
    {
      id: 8,
      productId: "SKU-1008",
      productName: "Smart Fitness Watch",
      vendorName: "TechGadgets UAE",
      category: "Electronics",
      aiaction: "Accept",

      price: 699.0,
      stock: 4,
      sales: 0,
      status: "low_stock",
    },
    {
      id: 9,
      productId: "SKU-1009",
      productName: "Office Comfort Chair",
      vendorName: "Home Essentials",
      category: "Furniture",
      price: 899.0,
      stock: 15,
      aiaction: "Reject",

      sales: 0,
      status: "active",
    },
    {
      id: 10,
      productId: "SKU-1010",
      productName: "Men's Running Shoes",
      vendorName: "Sports Zone",
      category: "Footwear",
      price: 279.0,
      stock: 9,
      aiaction: "Reject",

      sales: 0,
      status: "low_stock",
    },
    {
      id: 11,
      productId: "SKU-1011",
      productName: "Women Handbag Classic",
      vendorName: "Fashion House Dubai",
      category: "Accessories",
      price: 359.0,
      stock: 18,
      aiaction: "Accept",

      sales: 0,
      status: "active",
    },
    {
      id: 12,
      productId: "SKU-1012",
      productName: "Air Purifier Plus",
      vendorName: "TechGadgets UAE",
      category: "Home Appliances",
      price: 799.0,
      stock: 2,
      aiaction: "Reject",
      sales: 0,
      status: "low_stock",
    },
  ];
  const totalProducts = productData.length;
  const activeProducts = productData.filter(
    (p) => p.status === "active",
  ).length;
  const outOfStock = productData.filter((p) => p.stock === 0).length;
  const lowStock = productData.filter(
    (p) => p.stock > 0 && p.stock < 10,
  ).length;
  const HealthBar = ({ value }: { value: number }) => {
    const color = value >= 85 ? "#22c55e" : value >= 70 ? "#f59e0b" : "#ef4444";

    return (
      <div className="health_bar">
        <span style={{ background: color, width: `${value}%` }} />
        <small>{value}</small>
      </div>
    );
  };
  const [open, setOpen] = useState(false);
  const handleCloseModal = () => {
    setOpen(false);
  };
  const [open1, setOpen1] = useState(false);
  const handleCloseModal1 = () => {
    setOpen1(false);
  };
  const [open2, setOpen2] = useState(false);
  const handleCloseModal2 = () => {
    setOpen2(false);
  };
  const [open3, setOpen3] = useState(false);
  const handleCloseModal3 = () => {
    setOpen3(false);
  };
  const [open5, setOpen5] = useState(false);
  const handleCloseModal5 = () => {
    setOpen5(false);
  };
  const [open6, setOpen6] = useState(false);
  const handleCloseModal6 = () => {
    setOpen6(false);
  };
  const [open7, setOpen7] = useState(false);
  const handleCloseModal7 = () => {
    setOpen7(false);
  };
  const [tierFilter, setTierFilter] = useState<string>("");
  const [healthScoreMin, setHealthScoreMin] = useState<string>("");
  const [healthScoreMax, setHealthScoreMax] = useState<string>("");
  const [revenueMin, setRevenueMin] = useState<string>("");
  const [revenueMax, setRevenueMax] = useState<string>("");
  const [statusFilter, setStatusFilter] = useState<string>("");
  const [vendorTypeFilter, setVendorTypeFilter] = useState<string>("");
  const handleTierChange = (e: any) => setTierFilter(e.target.value);
  const handleStatusChange = (e: any) => setStatusFilter(e.target.value);
  const handleVendorTypeChange = (e: any) =>
    setVendorTypeFilter(e.target.value);

  const handleHealthMinChange = (e: any) => setHealthScoreMin(e.target.value);
  const handleHealthMaxChange = (e: any) => setHealthScoreMax(e.target.value);

  const handleRevenueMinChange = (e: any) => setRevenueMin(e.target.value);
  const handleRevenueMaxChange = (e: any) => setRevenueMax(e.target.value);

  const [menuAnchor, setMenuAnchor] = useState<HTMLElement | null>(null);
  const lifecycleData = [
    {
      name: "Fake Products Inc",
      from: "active",
      to: "suspended",
      description: "Policy violation: Counterfeit products detected",
      date: "12/12/2023",
      tag: "manual",
      tagType: "danger",
      level: "danger",
      icon: <BlockIcon />,
      // NEW FIELDS
      healthIndicator: "Critical", // 🔴 Critical
      keyDrivers: {
        health: 45,
        revenue: "AED 0",
        complaints: 12,
      },
      suggestedActions: [
        "Require compliance documents",
        "Manual review checklist",
      ],
      aiDecision: {
        summary: "Counterfeit products detected multiple times.",
        confidence: "High",
        recommendedAction: "Keep suspended until compliance verification",
        reason: "Policy violation detected",
      },
      prediction: "Vendor will remain suspended indefinitely without action.",
    },
    {
      name: "Budget Deals Store",
      from: "active",
      to: "at risk",
      description: "Multiple customer complaints and high return rate",
      date: "12/12/2023",
      tag: "automatic",
      tagType: "warning",
      level: "warning",
      icon: <WarningAmberIcon />,
      healthIndicator: "Watch", // 🟡 Watch
      keyDrivers: {
        health: 68,
        revenue: "AED 12,500",
        complaints: 8,
      },
      suggestedActions: [
        "Send warning notice",
        "Start performance improvement plan (PIP)",
      ],
      aiDecision: {
        summary: "Customer complaints increased by 15% this week.",
        confidence: "High",
        recommendedAction: "Monitor for 7 days or initiate warning",
        reason: "Customer complaints increased",
      },
      prediction:
        "If performance does not improve in 14 days, vendor is likely to be suspended.",
    },
    {
      name: "Sports Zone",
      from: "active",
      to: "at risk",
      description: "Health score dropped below 75",
      date: "12/12/2023",
      tag: "automatic",
      tagType: "warning",
      level: "warning",
      icon: <WarningAmberIcon />,
      healthIndicator: "Watch", // 🟡 Watch
      keyDrivers: {
        health: 74,
        revenue: "AED 45,000",
        complaints: 3,
      },
      suggestedActions: ["Offer incentive", "Assign account manager"],
      aiDecision: {
        summary: "On-time delivery dropped from 92% → 83%.",
        confidence: "Medium",
        recommendedAction: "Send performance reminder",
        reason: "Order completion fell below threshold",
      },
      prediction: "Risk of churn if health score drops below 70.",
    },
    {
      name: "Vintage Collectibles",
      from: "growing",
      to: "established",
      description: "Maintained high performance for 90+ days",
      date: "11/12/2023",
      tag: "automatic",
      tagType: "success",
      level: "success",
      icon: <TrendingUpIcon />,
      healthIndicator: "Stable", // 🟢 Stable
      keyDrivers: {
        health: 96,
        revenue: "AED 150,000",
        complaints: 0,
      },
      suggestedActions: ["Enable priority support", "Reduce commission"],
      aiDecision: {
        summary: "Consistently high performance for 3 months.",
        confidence: "High",
        recommendedAction: "Promote to Established tier",
        reason: "Growth targets met",
      },
      prediction: "Projected revenue growth of 20% next quarter.",
    },
    {
      name: "Premium Electronics Co",
      from: "onboarding",
      to: "active",
      description: "Completed accelerated onboarding",
      date: "11/12/2023",
      tag: "system",
      tagType: "info",
      level: "info",
      icon: <CheckCircleIcon />,
      healthIndicator: "Stable",
      keyDrivers: {
        health: 88,
        revenue: "AED 5,000",
        complaints: 0,
      },
      suggestedActions: ["Suggest marketing campaign"],
      aiDecision: {
        summary: "Fast onboarding completion.",
        confidence: "High",
        recommendedAction: "Monitor early sales performance",
        reason: "Onboarding success",
      },
      prediction: "Likely to become Growing vendor in 30 days.",
    },
    {
      name: "Quick Mart Online",
      from: "onboarding",
      to: "churned",
      description: "Vendor withdrew citing business closure",
      date: "10/12/2023",
      tag: "manual",
      tagType: "danger",
      level: "danger",
      icon: <PersonOffIcon />,
      healthIndicator: "Critical",
      keyDrivers: {
        health: 0,
        revenue: "AED 0",
        complaints: 0,
      },
      suggestedActions: ["Archive account"],
      aiDecision: {
        summary: "Vendor requested account closure.",
        confidence: "High",
        recommendedAction: "Close account",
        reason: "User request",
      },
      prediction: "No further activity expected.",
    },
  ];

  const lifecycleTableData = [
    {
      id: "V001",
      name: "Fake Products Inc",
      from: "Active",
      to: "Suspended",
      reason: "Policy violation: Counterfeit products detected",
      trigger: "manual",
      date: "12/20/2025",
    },
    {
      id: "V002",
      name: "Budget Deals Store",
      from: "Active",
      to: "At risk",
      reason: "Multiple customer complaints and high return rate",
      trigger: "automatic",
      date: "12/19/2025",
    },
    {
      id: "V003",
      name: "Sports Zone",
      from: "Active",
      to: "At risk",
      reason: "Health score dropped below 75",
      trigger: "automatic",
      date: "12/17/2025",
    },
    {
      id: "V004",
      name: "Vintage Collectibles",
      from: "Growing",
      to: "Established",
      reason: "Maintained high performance for 90+ days",
      trigger: "automatic",
      date: "12/17/2025",
    },
    {
      id: "V005",
      name: "Gourmet Delights",
      from: "Active",
      to: "Growing",
      reason: "Exceeded monthly targets by 200%",
      trigger: "automatic",
      date: "12/14/2025",
    },
  ];
  const documentsData = [
    {
      id: 1,
      // START NEW
      businessName: "Fashion House Dubai",
      type: "Fashion",
      stores: "6",
      vendorId: "VND-001",
      email: "contact@fashionhouse.ae",
      phone: "+971501234567",
      // END NEW
      licenseName: "Trade License - TL-27834",
      uploadedDate: "2024-10-05",
      docUrl: "/static/images/placeholder.png",
      expiryDate: "2025-12-30",
    },
    {
      id: 2,
      // START NEW
      businessName: "TechGadgets UAE",
      type: "Electronics",
      stores: "1",
      vendorId: "VND-002",
      email: "info@techgadgets.ae",
      phone: "+971502345678",
      // END NEW
      licenseName: "MOA - MOA-98345",
      uploadedDate: "2024-08-11",
      docUrl: "/static/images/placeholder.png",
      expiryDate: "2025-08-15",
    },
    {
      id: 3,
      // START NEW
      businessName: "Home Essentials",
      type: "Home & Living",
      stores: "3",
      vendorId: "VND-003",
      email: "support@homeessentials.ae",
      phone: "+971503456789",
      // END NEW
      licenseName: "MOA  - MOA-55219",
      uploadedDate: "2024-09-21",
      docUrl: "/static/images/placeholder.png",
      expiryDate: "2026-01-10",
    },
    {
      id: 4,
      // START NEW
      businessName: "Beauty Palace",
      type: "Beauty",
      stores: "4",
      vendorId: "VND-004",
      email: "hello@beautypalace.ae",
      phone: "+971504567890",
      // END NEW
      licenseName: "Trade License - TL-66102",
      uploadedDate: "2024-07-30",
      docUrl: "/static/images/placeholder.png",
      expiryDate: "2025-11-05",
    },
    {
      id: 5,
      // START NEW
      businessName: "Sports Zone",
      type: "Sports",
      stores: "2",
      vendorId: "VND-005",
      email: "sales@sportszone.ae",
      phone: "+971505678901",
      // END NEW
      licenseName: "MOA  - MOA-11987",
      uploadedDate: "2024-11-13",
      docUrl: "/static/images/placeholder.png",
      expiryDate: "2026-03-18",
    },
  ];
  const milestoneData = [
    {
      title: "$50,000 Revenue",
      vendor: "Premium Electronics Co",
      description: "Crossed $50k revenue milestone in first month",
      value: "$50,000",
      date: "Dec 17, 2025",
      type: "Revenue",
      icon: "📈",
    },
    {
      title: "6 Months Active",
      vendor: "Vintage Collectibles",
      description: "Successfully active on platform for 6 months",
      value: "180 Days",
      date: "Dec 12, 2025",
      type: "Engagement",
      icon: "📅",
    },
    {
      title: "5-Star Rating",
      vendor: "Fashion House Dubai",
      description: "Maintained 5-star rating with 500+ reviews",
      value: "★★★★★",
      date: "Dec 12, 2025",
      type: "Quality",
      icon: "⭐",
    },
    {
      title: "$250,000 Revenue",
      vendor: "Home Essentials",
      description: "Quarter million in sales achieved",
      value: "$250,000",
      date: "Dec 7, 2025",
      type: "Revenue",
      icon: "💰",
    },
    {
      title: "Fast Shipper",
      vendor: "Gourmet Delights",
      description: "Ships all orders within 24 hours",
      value: "24 hrs",
      date: "Dec 7, 2025",
      type: "Logistics",
      icon: "🚚",
    },
    {
      title: "First Sale",
      vendor: "Premium Electronics Co",
      description: "Completed first successful sale",
      value: "$599.99",
      date: "Dec 4, 2025",
      type: "Onboarding",
      icon: "🛒",
    },
  ];
  const engagementData = [
    {
      icon: "📞",
      type: "Call",
      title: "Welcome Call",
      vendor: "Fashion House Dubai",
      description: "Initial welcome call with vendor success team",
      value: "Outcome: Vendor excited to start, discussed growth plans",
      date: "12/22/2025",
      conductedBy: "Sarah Johnson",
    },
    {
      icon: "🎯",
      type: "Training",
      title: "Advanced Listing Training",
      vendor: "Fashion House Dubai",
      description: "Training on SEO and product optimization",
      value: "Outcome: Completed successfully",
      date: "12/22/2025",
      conductedBy: "Mike Chen",
    },
    {
      icon: "📉",
      type: "Call",
      title: "Performance Concern Call",
      vendor: "Sports Zone",
      description: "Discussion about declining performance metrics",
      value: "Outcome: Vendor agreed to improvement plan",
      date: "12/22/2025",
      conductedBy: "Sarah Johnson",
    },
    {
      icon: "🤝",
      type: "Discussion",
      title: "Partnership Discussion",
      vendor: "Premium Electronics Co",
      description: "Exploring exclusive partnership opportunities",
      value: "Outcome: Follow-up scheduled",
      date: "12/22/2025",
      conductedBy: "Alex Brown",
    },
  ];

  const [payoutData, setPayoutData] = useState([
    {
      id: "PAY-001",
      vendorId: "VND-001",
      vendorName: "Fashion House Dubai",
      period: "Jan 1-31, 2025",
      subscriptionType: "Premium",
      isVatRegistered: true,
      orders: 18,
      grossAmount: 3200,
      refundDeductions: 150,
      chargebacks: 0,
      disputesHeld: 200,
      manualAdjustments: 50,
      adjustmentNote: "Courier reimbursement",
      previousBalance: 0,
      commissionRate: 10,
      commissionValue: 320,
      vatOnSale: 160,
      vatOnCommission: 16,
      netAmount: 2624,
      status: "Approved",
      statusClass: "success",
      bankDetails: {
        bankName: "Emirates NBD",
        accountNumber: "**** **** 4590",
        iban: "AE** **** **** **** **** 1234",
        beneficiary: "Fashion House LLC",
      },
      aiRecommendation: "Approve",
      aiRiskScore: 12,
      aiWhy: "Consistent volume, low refund rate, verified documents.",
      auditTrail: [
        { action: "Initiated", by: "System", date: "Feb 01, 2025 09:00 AM" },
        {
          action: "Approved",
          by: "Admin Sarah",
          date: "Feb 01, 2025 11:30 AM",
        },
      ],
      holdReason: null,
      releaseConditions: null,
    },
    {
      id: "PAY-002",
      vendorId: "VND-003",
      vendorName: "Home Essentials",
      period: "Jan 1-31, 2025",
      subscriptionType: "Standard",
      isVatRegistered: false,
      orders: 42,
      grossAmount: 14500,
      refundDeductions: 1200,
      chargebacks: 500,
      disputesHeld: 1500,
      manualAdjustments: -100,
      adjustmentNote: "Penalty for late delivery",
      previousBalance: 500,
      commissionRate: 15,
      commissionValue: 2175,
      vatOnSale: 0,
      vatOnCommission: 108.75,
      netAmount: 9516.25,
      status: "Pending Review",
      statusClass: "warning",
      bankDetails: {
        bankName: "ADCB",
        accountNumber: "**** **** 9921",
        iban: "AE** **** **** **** **** 8876",
        beneficiary: "Home Essentials Trading",
      },
      aiRecommendation: "Review",
      aiRiskScore: 68,
      aiWhy: "Refund rate increased 3x this period. High dispute count.",
      auditTrail: [
        { action: "Initiated", by: "System", date: "Feb 01, 2025 09:00 AM" },
      ],
      holdReason: "High Refund Rate",
      releaseConditions: "Requires manual verification of last 5 returns.",
    },
    {
      id: "PAY-003",
      vendorId: "VND-005",
      vendorName: "Sports Zone",
      period: "Jan 1-31, 2025",
      subscriptionType: "Basic",
      isVatRegistered: true,
      orders: 12,
      grossAmount: 2800,
      refundDeductions: 0,
      chargebacks: 0,
      disputesHeld: 0,
      manualAdjustments: 0,
      previousBalance: 0,
      commissionRate: 10,
      commissionValue: 280,
      vatOnSale: 140,
      vatOnCommission: 14,
      netAmount: 2506,
      status: "Hold",
      statusClass: "danger",
      bankDetails: {
        bankName: "Mashreq Bank",
        accountNumber: "**** **** 1122",
        iban: "AE** **** **** **** **** 5544",
        beneficiary: "Sports Zone Retail",
      },
      aiRecommendation: "Hold",
      aiRiskScore: 85,
      aiWhy:
        "Bank details changed recently. Anomalous payout detected (+240% vs avg).",
      auditTrail: [
        { action: "Initiated", by: "System", date: "Feb 01, 2025 09:00 AM" },
        {
          action: "Auto-Hold",
          by: "AI System",
          date: "Feb 01, 2025 09:01 AM",
          note: "Security Trigger: Bank Details Changed",
        },
      ],
      holdReason: "Security: Bank Details Change",
      releaseConditions: "Verification of bank letter by Finance Head.",
    },
  ]);

  const totalPayoutAmount = payoutData.reduce(
    (acc, curr) => acc + curr.netAmount,
    0,
  );
  const completedPayoutsCount = payoutData.filter(
    (p) => p.status === "Completed",
  ).length;
  const pendingPayoutsCount = payoutData.filter(
    (p) => p.status === "Pending Review" || p.status === "Hold",
  ).length;

  const scheduledPayouts = [
    {
      id: "SCH-001",
      vendor: "ABC Electronics",
      subscriptionType: "Premium",
      plan: "Weekly Payout",
      commissionRate: 8,
      amount: "AED 400",
      expiry: "2025-12-31",
      status: "Pending",
    },
    {
      id: "SCH-002",
      vendor: "Fashion Hub",
      subscriptionType: "Standard",
      plan: "Monthly Payout",
      commissionRate: 10,
      amount: "AED 400",
      expiry: "2025-06-30",
      status: "Pending",
    },
  ];

  // Top Vendors by Revenue Data
  const topVendorsByRevenue = [
    {
      id: "VND-001",
      name: "LuxeStyle Fashion",
      revenue: "AED 1,250,000",
      orders: 1250,
      avgOrderValue: "AED 1,000",
      tier: "Enterprise",
      health: 92.5,
    },
    {
      id: "VND-002",
      name: "TechGadgets UAE",
      revenue: "AED 890,000",
      orders: 890,
      avgOrderValue: "AED 1,000",
      tier: "Pro",
      health: 78.3,
    },
    {
      id: "VND-003",
      name: "Beauty Essentials",
      revenue: "AED 650,000",
      orders: 650,
      avgOrderValue: "AED 1,000",
      tier: "Standard",
      health: 85.2,
    },
    {
      id: "VND-004",
      name: "Home Decor Plus",
      revenue: "AED 580,000",
      orders: 580,
      avgOrderValue: "AED 1,000",
      tier: "Pro",
      health: 88.7,
    },
    {
      id: "VND-005",
      name: "Sports Zone",
      revenue: "AED 450,000",
      orders: 450,
      avgOrderValue: "AED 1,000",
      tier: "Standard",
      health: 82.1,
    },
  ];

  const vendorBalances = [
    {
      id: "BAL-001",
      vendorId: "VND-1001",
      vendorName: "ABC Electronics",
      subscriptionType: "Premium",
      commissionRate: "8%",
      pendingAmount: "AED 4,250.00",
      lastPayout: "AED 12,800.00",
      lastPayoutDate: "15 Mar 2025",
      status: "Pending",
      statusClass: "warning",
    },
    {
      id: "BAL-002",
      vendorId: "VND-1002",
      vendorName: "Fashion Hub",
      subscriptionType: "Standard",
      commissionRate: "10%",
      pendingAmount: "AED 0.00",
      lastPayout: "AED 9,500.00",
      lastPayoutDate: "10 Mar 2025",
      status: "Settled",
      statusClass: "success",
    },
  ];

  const segmentData = [
    // Revenue & Growth Segments
    {
      title: "High-Value Vendors",
      type: "Dynamic",
      category: "Revenue & Growth",
      description: "Vendors with lifetime value > AED 5000",
      count: 850,
      status: "Active",
      icon: "💎",
      useCase: "Eligible for reduced commission",
      purpose: "Incentives",
      isPredictive: false,
    },
    {
      title: "Low Conversion Vendors",
      type: "Dynamic",
      category: "Revenue & Growth",
      description: "Vendors with conversion rate < 2%",
      count: 1240,
      status: "Active",
      icon: "📉",
      useCase: "Used for incentives",
      purpose: "Incentives",
      isPredictive: false,
    },
    {
      title: "High Cart Drop Rate Vendors",
      type: "Dynamic",
      category: "Revenue & Growth",
      description: "Vendors with cart abandonment > 60%",
      count: 980,
      status: "Active",
      icon: "🛒",
      useCase: "Used for incentives",
      purpose: "Incentives",
      isPredictive: false,
    },
    {
      title: "Low Sell-Through Vendors",
      type: "Dynamic",
      category: "Revenue & Growth",
      description: "Vendors with sell-through rate < 30%",
      count: 1560,
      status: "Active",
      icon: "📊",
      useCase: "Used for incentives",
      purpose: "Incentives",
      isPredictive: false,
    },
    {
      title: "Low Checkout Completion Vendors",
      type: "Dynamic",
      category: "Revenue & Growth",
      description: "Vendors with checkout completion < 40%",
      count: 1120,
      status: "Active",
      icon: "💳",
      useCase: "Used for incentives",
      purpose: "Incentives",
      isPredictive: false,
    },
    {
      title: "Fast-growing Vendors (30d)",
      type: "Dynamic",
      category: "Revenue & Growth",
      description: "Vendors with >50% growth in last 30 days",
      count: 320,
      status: "Active",
      icon: "🚀",
      useCase: "Feed pricing, commission, and promo strategy",
      purpose: "Analytics",
      isPredictive: false,
    },
    {
      title: "Fast-growing Vendors (90d)",
      type: "Dynamic",
      category: "Revenue & Growth",
      description: "Vendors with >50% growth in last 90 days",
      count: 450,
      status: "Active",
      icon: "📈",
      useCase: "Feed pricing, commission, and promo strategy",
      purpose: "Analytics",
      isPredictive: false,
    },
    {
      title: "Declining Vendors",
      type: "Dynamic",
      category: "Revenue & Growth",
      description: "Vendors with declining orders > 20%",
      count: 680,
      status: "Active",
      icon: "📉",
      useCase: "Feed pricing, commission, and promo strategy",
      purpose: "Analytics",
      isPredictive: false,
    },
    {
      title: "High GMV, Low Margin Vendors",
      type: "Dynamic",
      category: "Revenue & Growth",
      description: "Vendors with GMV > AED 100K, margin < 15%",
      count: 240,
      status: "Active",
      icon: "💰",
      useCase: "Feed pricing, commission, and promo strategy",
      purpose: "Analytics",
      isPredictive: false,
    },
    {
      title: "Low GMV, High Margin Vendors",
      type: "Dynamic",
      category: "Revenue & Growth",
      description: "Vendors with GMV < AED 50K, margin > 30%",
      count: 890,
      status: "Active",
      icon: "💎",
      useCase: "Feed pricing, commission, and promo strategy",
      purpose: "Analytics",
      isPredictive: false,
    },
    // Risk & Compliance Segments (CRITICAL)
    {
      title: "Vendors with Policy Violations",
      type: "Dynamic",
      category: "Risk & Compliance",
      description: "Vendors with active policy violations",
      count: 45,
      status: "Active",
      icon: "🚨",
      useCase: "Used for risk monitoring",
      purpose: "Risk Monitoring",
      isPredictive: false,
    },
    {
      title: "Vendors with High Refund Rates",
      type: "Dynamic",
      category: "Risk & Compliance",
      description: "Vendors with refund rate > 10%",
      count: 120,
      status: "Active",
      icon: "↩️",
      useCase: "Used for risk monitoring",
      purpose: "Risk Monitoring",
      isPredictive: false,
    },
    {
      title: "Vendors with Counterfeit Flags",
      type: "Dynamic",
      category: "Risk & Compliance",
      description: "Vendors flagged for counterfeit products",
      count: 8,
      status: "Active",
      icon: "⚠️",
      useCase: "Used for risk monitoring",
      purpose: "Risk Monitoring",
      isPredictive: false,
    },
    {
      title: "Vendors with Delayed Shipments",
      type: "Dynamic",
      category: "Risk & Compliance",
      description: "Vendors with >15% delayed shipments",
      count: 180,
      status: "Active",
      icon: "⏰",
      useCase: "Used for risk monitoring",
      purpose: "Risk Monitoring",
      isPredictive: false,
    },
    // Operational Quality Segments
    {
      title: "Low Fulfillment SLA Vendors",
      type: "Dynamic",
      category: "Operational Quality",
      description: "Vendors with SLA breach > 5%",
      count: 340,
      status: "Active",
      icon: "📦",
      useCase: "Connect directly to Vendor Lifecycle",
      purpose: "Analytics",
      isPredictive: false,
    },
    {
      title: "High Cancellation Vendors",
      type: "Dynamic",
      category: "Operational Quality",
      description: "Vendors with cancellation rate > 8%",
      count: 210,
      status: "Active",
      icon: "❌",
      useCase: "Connect directly to Vendor Lifecycle",
      purpose: "Analytics",
      isPredictive: false,
    },
    {
      title: "Low Rating Vendors",
      type: "Dynamic",
      category: "Operational Quality",
      description: "Vendors with rating < 3.5",
      count: 95,
      status: "Active",
      icon: "⭐",
      useCase: "Connect directly to Vendor Lifecycle",
      purpose: "Analytics",
      isPredictive: false,
    },
    {
      title: "High Dispute Vendors",
      type: "Dynamic",
      category: "Operational Quality",
      description: "Vendors with dispute rate > 5%",
      count: 150,
      status: "Active",
      icon: "⚖️",
      useCase: "Connect directly to Vendor Lifecycle",
      purpose: "Analytics",
      isPredictive: false,
    },
    // Static Segments
    {
      title: "UAE Vendors",
      type: "Static",
      category: "Geographic",
      description: "Vendors based in UAE",
      count: 12500,
      status: "Active",
      icon: "🇦🇪",
      useCase: "Used for communication",
      purpose: "Communication",
      isPredictive: false,
    },
    {
      title: "Fashion Vendors",
      type: "Static",
      category: "Category",
      description: "Fashion category vendors",
      count: 5600,
      status: "Active",
      icon: "👗",
      useCase: "Used for communication",
      purpose: "Communication",
      isPredictive: false,
    },
    {
      title: "New Signups",
      type: "Dynamic",
      category: "Onboarding",
      description: "Recently registered vendors",
      count: 890,
      status: "Active",
      icon: "✨",
      useCase: "Used for communication",
      purpose: "Communication",
      isPredictive: false,
    },
    // Predictive Segments
    {
      title: "Lapsed Vendors",
      type: "Predictive",
      category: "Predictive",
      description: "Inactive vendors",
      count: 2300,
      status: "Active",
      icon: "⚠️",
      useCase: "Used for risk monitoring",
      purpose: "Risk Monitoring",
      isPredictive: true,
      aiReason: "Declining orders, inactivity",
      confidence: "High",
      suggestedAction: "Send re-engagement campaign",
    },
  ];

  // AI Suggested Segments
  const aiSuggestedSegments = [
    {
      title: "Vendors likely to churn in 30 days",
      type: "Predictive",
      description: "AI-predicted churn risk based on activity patterns",
      count: 145,
      status: "Active",
      icon: "🔮",
      useCase: "Used for risk monitoring",
      purpose: "Risk Monitoring",
      isPredictive: true,
      aiReason: "Declining orders, reduced activity, low engagement",
      confidence: "High",
      suggestedAction: "Apply retention incentives, assign account manager",
    },
    {
      title: "Vendors ready for tier upgrade",
      type: "Predictive",
      description: "Vendors meeting criteria for next subscription tier",
      count: 78,
      status: "Active",
      icon: "⬆️",
      useCase: "Used for incentives",
      purpose: "Incentives",
      isPredictive: true,
      aiReason:
        "High growth rate, consistent performance, revenue threshold met",
      confidence: "Medium",
      suggestedAction: "Send upgrade offer, schedule consultation",
    },
    {
      title: "Vendors suitable for co-marketing",
      type: "Predictive",
      description: "Vendors with high engagement and brand alignment",
      count: 92,
      status: "Active",
      icon: "🤝",
      useCase: "Used for communication",
      purpose: "Communication",
      isPredictive: true,
      aiReason:
        "High customer satisfaction, strong brand presence, active engagement",
      confidence: "Medium",
      suggestedAction: "Reach out for co-marketing opportunities",
    },
  ];
  const [selectedFields, setSelectedFields] = useState<string[]>([]);
  const exportFields = [
    "Business Details",
    "Vendor Details",
    "Short Name",
    "Status",
    "Age",
    "Nationality",
    "No. of Stores",
    "Store Names",
    "License Number",
    "Bio",
    "Health Score",
    "Subscription",
    "Onboarding Date",
    "Revenue",
    "Last Order",
    "Suspend",
  ];
  const [bulkData, setbulkData] = useState([
    {
      id: "VND-001",
      businessName: "Fashion House Dubai",
      shortName: "FHD",
      email: "contact@fashionhouse.ae",
      phone: "+971501234567",
      status: "Active",
      age: 6,
      nationality: "UAE",
      storesCount: 6,
      storeNames: "Dubai Mall, Mall of Emirates, City Walk",
      licenseNumber: "LIC-DXB-459812",
      bio: "Premium fashion retailer specializing in luxury apparel.",
      health: 92.5,
      tier: "Enterprise",
      onboardingDate: "12-06-2024",
      revenue: "AED 1,250,000",
      lastOrder: "05-01-2026",
      suspended: false,
    },
    {
      id: "VND-002",
      businessName: "TechGadgets UAE",
      shortName: "TG UAE",
      email: "info@techgadgets.ae",
      phone: "+971502345678",
      status: "Active",
      age: 3,
      nationality: "India",
      storesCount: 1,
      storeNames: "Deira City Centre",
      licenseNumber: "LIC-DXB-998211",
      bio: "Consumer electronics and accessories vendor.",
      health: 78.3,
      tier: "Pro",
      onboardingDate: "18-03-2024",
      revenue: "AED 456,000",
      lastOrder: "02-01-2026",
      suspended: false,
    },
  ]);


  const subscriptionManagementData = [
    {
      id: "SUB-001",
      vendorId: "VND-001",
      businessName: "Fashion House Dubai",
      vendorEmail: "contact@fashionhouse.ae",
      vendorPhone: "+971501234567",
      subscriptionName: "Scale+",
      startDate: "2025-01-01",
      endDate: "2025-12-31",
      status: "Active",
      billingCycle: "Annual",
      usageLevel: 85,
      revenueContribution: "High",
      aiCostImpact: "Medium",
      aiFeatures: ["Product Optimizer", "Auto-Chat", "Smart Inventory"],
      history: [
        { plan: "Pro", date: "2024-01-01", action: "Upgrade", by: "Admin" },
      ],
    },
    {
      id: "SUB-002",
      vendorId: "VND-002",
      businessName: "TechGadgets UAE",
      vendorEmail: "info@techgadgets.ae",
      vendorPhone: "+971502345678",
      subscriptionName: "Pro",
      startDate: "2025-01-15",
      endDate: "2026-01-14",
      status: "Trial",
      billingCycle: "Monthly",
      usageLevel: 20,
      revenueContribution: "Medium",
      aiCostImpact: "Low",
      aiFeatures: ["Basic Analytics"],
      history: [],
    },
    {
      id: "SUB-003",
      vendorId: "VND-003",
      businessName: "Home Essentials",
      vendorEmail: "support@homeessentials.ae",
      vendorPhone: "+971503456789",
      subscriptionName: "Standard",
      startDate: "2024-06-01",
      endDate: "2025-05-31",
      status: "Expired",
      billingCycle: "Annual",
      usageLevel: 95,
      revenueContribution: "Low",
      aiCostImpact: "High",
      aiFeatures: [],
      history: [],
    },
  ];

  const [usageFilter, setUsageFilter] = useState("all");
  const [revenueFilter, setRevenueFilter] = useState("all");
  const [subStatusFilter, setSubStatusFilter] = useState("all");
  const [aiCostFilter, setAiCostFilter] = useState("all");

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const openMenu = Boolean(anchorEl);

  const handleOpen = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const [openDrawer, setOpenDrawer] = React.useState(false);

  const toggleDrawer = (newOpen: boolean) => () => {
    setOpenDrawer(newOpen);
  };
  return (
    <>
      {/* Tabs Section */}
      <Box className="custom_tabs">
        <Tabs
          value={valueTabs1}
          onChange={handleChangeTabs1}
          className="custom_tabs_links"
        >
          <Tab label="All Vendors" {...a11yProps(0)} />
          <Tab label="Vendor Applications" {...a11yProps(1)} />
          <Tab label="Vendor Onboarding" {...a11yProps(2)} />
          <Tab label="Legal & Documents" {...a11yProps(3)} />
          <Tab label="Lifecycle" {...a11yProps(4)} />
          <Tab label="Performance" {...a11yProps(5)} />
          <Tab label="Products" {...a11yProps(6)} />
          <Tab label="Payouts" {...a11yProps(7)} />
          <Tab label="Vendor Segments" {...a11yProps(8)} />
          <Tab label="Vendor Analytics" {...a11yProps(9)} />
          <Tab label="Vendor Communications" {...a11yProps(10)} />
          <Tab label="Bulk Export" {...a11yProps(11)} />
          <Tab label="Subcription Management" {...a11yProps(12)} />
        </Tabs>
      </Box>
      <CustomTabPanel value={valueTabs1} index={0}>
        <div className="main_title d_flex">
          <div className="left_s">
            <h1>Manage Vendors</h1>
            <p>
              <button onClick={() => navigate("/dashboard")}>Dashboard</button>{" "}
              - Manage Vendors
            </p>
          </div>
          <div className="right_s form">
            <input type="date" />
          </div>
        </div>
        <div className="stats_boxes gap_m">
          {/* NEW VENDORS */}
          <a href="/manage-customers?filter=new" className="cards">
            <div className="data_top">
              <h2>
                56
                <p>New Vendors</p>
              </h2>
              <figure className="active_order">
                <PersonAddAltIcon fontSize="large" />
              </figure>
            </div>

            <div className="ai_insight positive">
              <span>▲ +12%</span>
              <small>from last month</small>
            </div>
          </a>

          {/* ACTIVE VENDORS */}
          <a href="/manage-customers?filter=active" className="cards">
            <div className="data_top">
              <h2>
                1,120
                <p>Active Vendors</p>
              </h2>
              <figure className="sucess">
                <CheckCircleIcon fontSize="large" />
              </figure>
            </div>

            <div className="ai_insight info">
              <span>84.0%</span>
              <small>of total vendors</small>
            </div>
          </a>

          {/* INACTIVE VENDORS */}
          <a href="/manage-customers?filter=inactive" className="cards">
            <div className="data_top">
              <h2>
                125
                <p>Inactive Vendors</p>
              </h2>
              <figure className="danger">
                <BlockIcon fontSize="large" />
              </figure>
            </div>

            <div className="ai_insight negative">
              <span>▼ -6%</span>
              <small>from last month</small>
            </div>
          </a>

          {/* PENDING APPROVAL */}
          <a href="/manage-customers" className="cards">
            <div className="data_top">
              <h2>
                92
                <p>Pending Approval Vendors</p>
              </h2>
              <figure className="blue">
                <GroupsIcon fontSize="large" />
              </figure>
            </div>

            <div className="ai_insight warning">
              <span>▲ +8%</span>
              <small>from last month</small>
            </div>
          </a>

          {/* TOTAL VENDORS */}
          <a href="/manage-customers" className="cards">
            <div className="data_top">
              <h2>
                1,301
                <p>Total Vendors</p>
              </h2>
              <figure className="blue">
                <GroupsIcon fontSize="large" />
              </figure>
            </div>

            <div className="ai_insight info">
              <span>100%</span>
              <small>vendor base</small>
            </div>
          </a>
        </div>
        <div className="table_flex mt_20">
          <div className="lt">
            <div className="cards">
              <div className="table_header">
                <div className="left_s">
                  <Box className="search_box">
                    <SearchBar
                      searchTerm={searchTerm}
                      setDebouncedSearchTerm={setSearchTerm}
                      placeholder="Search vendors..."
                    />
                  </Box>
                  <div className="form">
                    <div className="control_group">
                      <input type="date" />
                    </div>

                    <div className="form">
                      <Select defaultValue="All" size="small" fullWidth>
                        <MenuItem value="All">All Categories</MenuItem>
                        <MenuItem value="Fashion">Fashion</MenuItem>
                        <MenuItem value="Electronics">Electronics</MenuItem>
                        <MenuItem value="Beauty">Beauty</MenuItem>
                      </Select>
                    </div>

                    <div className="form">
                      <Select defaultValue="All" size="small" fullWidth>
                        <MenuItem value="All">All Status</MenuItem>
                        <MenuItem value="Active">Active</MenuItem>
                        <MenuItem value="Under Review">Under Review</MenuItem>
                        <MenuItem value="Suspended">Suspended</MenuItem>
                      </Select>
                    </div>

                    <div className="form">
                      <Select defaultValue="All" size="small" fullWidth>
                        <MenuItem value="All">All Tiers</MenuItem>
                        <MenuItem value="Free">Free</MenuItem>
                        <MenuItem value="Pro">Pro</MenuItem>
                        <MenuItem value="Enterprise">Enterprise</MenuItem>
                      </Select>
                    </div>
                    <div
                      className="filter_icon cr_pt"
                      onClick={toggleDrawer(true)}
                    >
                      <FilterListIcon />
                    </div>
                  </div>
                </div>
                <div className="right_s">
                  {selected.length > 0 && (
                    <>
                      <Button className="btn " variant="outlined">
                        Bulk Suspend
                      </Button>
                      <Button
                        className="btn "
                        variant="outlined"
                        onClick={() => setOpen7(true)}
                      >
                        Bulk Notify
                      </Button>
                    </>
                  )}
                  <Button className="btn " variant="outlined">
                    <IosShareIcon />
                    Import
                  </Button>
                  <div className="form">
                    <Select
                      multiple
                      displayEmpty
                      value={visibleVendorColumns}
                      onChange={(e) =>
                        setVisibleVendorColumns(e.target.value as string[])
                      }
                      size="small"
                      renderValue={(selected) =>
                        selected.length === vendorColumns.length
                          ? "All Columns Selected"
                          : `${selected.length} columns visible`
                      }
                      sx={{ minWidth: 200 }}
                    >
                      {vendorColumns.map((col) => (
                        <MenuItem key={col} value={col}>
                          <Checkbox
                            checked={visibleVendorColumns.includes(col)}
                          />
                          <ListItemText primary={col} />
                        </MenuItem>
                      ))}
                    </Select>
                  </div>
                  <Button
                    className="btn btn_primary"
                    onClick={() => navigate("add-vendor")}
                  >
                    <AddIcon />
                    Add Vendor
                  </Button>
                </div>
              </div>

              <TableContainer className="table_container">
                <Table>
                  <TableHead>
                    <TableRow>
                      {vendorColumns.map((col, i) => (
                        <TableCell key={i}>
                          {col === "Select" ? (
                            <Checkbox
                              checked={
                                vendorData.length > 0 &&
                                selected.length === vendorData.length
                              }
                              indeterminate={
                                selected.length > 0 &&
                                selected.length < vendorData.length
                              }
                              onChange={(e) => {
                                if (e.target.checked) {
                                  setSelected(vendorData.map((v) => v.id));
                                } else {
                                  setSelected([]);
                                }
                              }}
                            />
                          ) : (
                            col
                          )}
                        </TableCell>
                      ))}
                    </TableRow>
                  </TableHead>

                  <TableBody>
                    {vendorData.map((vendor, index) => (
                      <TableRow key={vendor.id} hover>
                        {/* SELECT */}
                        <TableCell padding="checkbox">
                          <Checkbox
                            checked={selected.includes(vendor.id)}
                            onChange={() => toggleSelect(vendor.id)}
                          />
                        </TableCell>
                        
                        {/* BUSINESS INFO */}
                        <TableCell>
                          <div className="user_block">
                            <p>
                              <b>{vendor.name}</b>
                              <span>
                                {vendor.email}{" "}
                                {vendor.documentsVerified && (
                                  <img
                                    src="/static/images/tick_icon.svg"
                                    alt="verified"
                                  />
                                )}
                              </span>
                              <span
                                className="badge1 neutral"
                                style={{ fontSize: "10px", marginTop: "4px" }}
                              >
                                {vendor.type} • {vendor.stores} Stores
                              </span>
                            </p>
                          </div>
                        </TableCell>

                        {/* VENDOR DETAILS */}
                        <TableCell>
                          <div className="user_block">
                            <p>
                              <b>{vendor.name} Head</b>
                              <span>{vendor.phone}</span>
                              <small className="vendor_id">{vendor.id}</small>
                            </p>
                          </div>
                        </TableCell>

                        {/* STATUS */}
                        <TableCell>
                          <span
                            className={`status_chip ${vendor.status.toLowerCase()}`}
                          >
                            {vendor.status}
                          </span>
                        </TableCell>

                        {/* HEALTH */}
                        <TableCell
                          onClick={() => setOpen6(true)}
                          className="cr_pt"
                        >
                          <HealthBar value={vendor.health} />
                        </TableCell>

                        {/* SUBSCRIPTION */}
                        <TableCell>
                          <span
                            className={`tier_chip ${vendor.tier.toLowerCase()}`}
                          >
                            {vendor.tier}
                          </span>
                        </TableCell>

                        {/* DATE */}
                        <TableCell>{vendor.date}</TableCell>

                        {/* REVENUE */}
                        <TableCell>{vendor.revenue}</TableCell>

                        {/* INDICATORS */}
                        <TableCell>
                          <span className="status_chip">
                            {vendor.indicator}
                          </span>
                        </TableCell>

                        {/* AI INSIGHTS */}
                        <TableCell style={{ minWidth: "200px" }}>
                          {vendor.fastTrackSuggestion && (
                            <small
                              style={{
                                display: "block",
                                color: "#16a34a",
                                lineHeight: "1.4",
                              }}
                            >
                              ✨ {vendor.fastTrackSuggestion}
                            </small>
                          )}
                          {vendor.unblockActions && (
                            <small
                              style={{
                                display: "block",
                                color: "#ea580c",
                                lineHeight: "1.4",
                              }}
                            >
                              ⚠️ {vendor.unblockActions}
                            </small>
                          )}
                          {!vendor.fastTrackSuggestion &&
                            !vendor.unblockActions &&
                            "-"}
                        </TableCell>

                        {/* SUSPEND */}
                        <TableCell>
                          <SwitchToggle
                            checked={enabled}
                            onChange={(e) => {
                              const isChecked = e.target.checked;
                              setEnabled(isChecked);

                              if (isChecked) {
                                setOpen1(true); // open modal when ON
                              }
                            }}
                          />
                        </TableCell>
                        <TableCell>
                          {" "}
                          <Button
                            className="btn btn_primary sm"
                            onClick={() => navigate("/vendor-comtracts/view")}
                          >
                            Contract
                          </Button>{" "}
                        </TableCell>
                        {/* ACTIONS */}
                        <TableCell>
                          <div className="table_actions v2">
                            <IconButton
                              onClick={() =>
                                navigate("/manage-vendors/view-vendor")
                              }
                            >
                              <img src="/static/images/eye_icon.svg" />
                            </IconButton>
                            <IconButton>
                              <img src="/static/images/edit2_icon.svg" />
                            </IconButton>
                            <IconButton onClick={handleOpen}>
                              <MoreVertIcon />
                            </IconButton>
                            <Menu
                              anchorEl={anchorEl}
                              open={Boolean(anchorEl)}
                              onClose={handleClose}
                              anchorOrigin={{
                                vertical: "bottom",
                                horizontal: "right",
                              }}
                              transformOrigin={{
                                vertical: "top",
                                horizontal: "right",
                              }}
                              className="table_menu"
                            >
                              <MenuItem onClick={handleClose}>
                                <ListItemIcon>
                                  <TimelineOutlinedIcon fontSize="small" />
                                </ListItemIcon>
                                View Lifecycle
                              </MenuItem>

                              <MenuItem onClick={handleClose}>
                                <ListItemIcon>
                                  <PaymentsOutlinedIcon fontSize="small" />
                                </ListItemIcon>
                                View Payouts
                              </MenuItem>

                              <MenuItem onClick={handleClose}>
                                <ListItemIcon>
                                  <MessageOutlinedIcon fontSize="small" />
                                </ListItemIcon>
                                Send Message
                              </MenuItem>

                              <MenuItem onClick={handleClose}>
                                <ListItemIcon>
                                  <NoteAddOutlinedIcon fontSize="small" />
                                </ListItemIcon>
                                Add Internal Note
                              </MenuItem>

                              <MenuItem onClick={handleClose}>
                                <ListItemIcon>
                                  <FlagOutlinedIcon fontSize="small" />
                                </ListItemIcon>
                                Flag for Review
                              </MenuItem>
                            </Menu>
                          </div>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </div>
          </div>
          <div className="rt">
            <div className="ai_panel">
              <h4>AI Insights</h4>

              <div className="ai_alert warning">
                <span className="icon">⚠️</span>
                <p>
                  <b>7 SKUs</b> need immediate attention
                </p>
              </div>

              <div className="ai_alert danger">
                <span className="icon">⛔</span>
                <p>
                  <b>3 SKUs</b> have zero sales in 30 days
                </p>
              </div>

              <small className="ai_update">
                Next updated ETA: <b>May 5, 2024</b>
              </small>

              <div className="ai_sku_list">
                <div className="ai_sku_row">
                  <div className="ai_sku_info">
                    <h5>#PRD_002</h5>
                    <p>Likely to go out of stock by May</p>
                  </div>
                  <button className="ai_action_btn">Actions ▾</button>
                </div>

                <div className="ai_sku_row">
                  <div className="ai_sku_info">
                    <h5>#PRD_010</h5>
                    <p>Likely to go out of stock by May</p>
                  </div>
                  <button className="ai_action_btn">Actions ▾</button>
                </div>
              </div>

              {/* <div className="ai_create">
                                    + Create AI Insights
                                </div> */}
            </div>
          </div>
        </div>
      </CustomTabPanel>
      <CustomTabPanel value={valueTabs1} index={1}>
        <div className="main_title d_flex">
          <div className="left_s">
            <h1>Vendor Applications</h1>
            <p>
              <button onClick={() => navigate("/dashboard")}>Dashboard</button>{" "}
              - Manage Vendor Applications
            </p>
          </div>
          <div className="right_s form">
            <input type="date" />
          </div>
        </div>
        <div className="stats_boxes gap_m">
          {/* TOTAL APPLICATIONS */}
          <a href="/applications" className="cards">
            <div className="data_top">
              <h2>
                16
                <p>Total Applications</p>
              </h2>
              <figure className="blue">
                <DescriptionOutlinedIcon fontSize="large" />
              </figure>
            </div>

            <div className="ai_insight info">
              <span>All time</span>
            </div>
          </a>

          {/* SUBMITTED */}
          <a href="/applications?status=submitted" className="cards">
            <div className="data_top">
              <h2>
                6<p>Submitted</p>
              </h2>
              <figure className="active_order">
                <UploadFileOutlinedIcon fontSize="large" />
              </figure>
            </div>

            <div className="ai_insight info">
              <span>Awaiting review</span>
            </div>
          </a>

          {/* UNDER REVIEW */}
          <a href="/applications?status=review" className="cards">
            <div className="data_top">
              <h2>
                4<p>Under Review</p>
              </h2>
              <figure className="warning">
                <HourglassTopOutlinedIcon fontSize="large" />
              </figure>
            </div>

            <div className="ai_insight warning">
              <span>In progress</span>
            </div>
          </a>

          {/* APPROVED */}
          <a href="/applications?status=approved" className="cards">
            <div className="data_top">
              <h2>
                4<p>Approved</p>
              </h2>
              <figure className="sucess">
                <CheckCircleOutlineOutlinedIcon fontSize="large" />
              </figure>
            </div>

            <div className="ai_insight positive">
              <span>✔ Approved</span>
            </div>
          </a>

          {/* REJECTED */}
          <a href="/applications?status=rejected" className="cards">
            <div className="data_top">
              <h2>
                2<p>Rejected</p>
              </h2>
              <figure className="danger">
                <BlockOutlinedIcon fontSize="large" />
              </figure>
            </div>

            <div className="ai_insight negative">
              <span>✖ Rejected</span>
            </div>
          </a>
        </div>

        <div className="table_flex mt_20">
          <div className="lt">
            {selected.length > 0 && (
              <div className="bulk_action_bar">
                <span>{selected.length} selected</span>

                <Button color="success">Approve selected</Button>
                <Button color="error">Reject selected</Button>
              </div>
            )}
            <div className="cards">
              <div className="table_header">
                <div className="left_s">
                  <Box className="search_box">
                    <SearchBar
                      searchTerm={searchTerm}
                      setDebouncedSearchTerm={setSearchTerm}
                      placeholder="Search vendors..."
                    />
                  </Box>
                  <div className=" form">
                    <Select
                      multiple
                      displayEmpty
                      value={visibleApplicationColumns}
                      onChange={(e) =>
                        setVisibleApplicationColumns(e.target.value as string[])
                      }
                      size="small"
                      renderValue={(selected) =>
                        selected.length === applicationColumns.length
                          ? "All Columns Selected"
                          : `${selected.length} columns visible`
                      }
                      sx={{ minWidth: 200 }}
                    >
                      {applicationColumns.map((col) => (
                        <MenuItem key={col} value={col}>
                          <Checkbox
                            checked={visibleApplicationColumns.includes(col)}
                          />
                          <ListItemText primary={col} />
                        </MenuItem>
                      ))}
                    </Select>

                    <Select value="Pending" size="small" fullWidth>
                      <MenuItem value="Pending">All Status</MenuItem>
                      <MenuItem value="Accepted">Submitted</MenuItem>
                      <MenuItem value="Rejected">Under Review</MenuItem>
                      <MenuItem value="Rejected">Approved</MenuItem>
                      <MenuItem value="Rejected">Rejected</MenuItem>
                    </Select>

                    <div className="control_group">
                      <input type="date" />
                    </div>
                  </div>
                </div>
              </div>

              <TableContainer className="table_container">
                <Table>
                  <TableHead>
                    <TableRow>
                      {applicationColumns.map((col, i) => (
                        <TableCell key={i}>{col}</TableCell>
                      ))}
                    </TableRow>
                  </TableHead>

                  <TableBody>
                    {vendorData.map((vendor) => (
                      <>
                        {/* MAIN ROW */}
                        <TableRow
                          key={vendor.id}
                          hover
                          className="cr_pt"
                          onClick={() => toggleExpand(vendor.id)}
                        >
                          {/* SELECT */}
                          <TableCell padding="checkbox">
                            <Checkbox
                              checked={selected.includes(vendor.id)}
                              onChange={() => toggleSelect(vendor.id)}
                            />
                          </TableCell>

                          {/* BUSINESS */}
                          <TableCell>
                            <div className="user_block">
                              <p>
                                <b>{vendor.name}</b>
                                <span
                                  className="badge1 neutral"
                                  style={{ fontSize: "10px", marginTop: "4px" }}
                                >
                                  {vendor.type}
                                </span>
                              </p>
                            </div>
                          </TableCell>

                          {/* VENDOR DETAILS */}
                          <TableCell>
                            <div className="user_block">
                              <p>
                                <b>Contact HQ</b>
                                <span>{vendor.email}</span>
                                <small className="vendor_id">{vendor.id}</small>
                              </p>
                            </div>
                          </TableCell>

                          <TableCell>{vendor.type}</TableCell>
                          <TableCell>{vendor.applicationtype}</TableCell>

                          {/* RISK */}
                          <TableCell>
                            <span
                              className={`risk ${vendor.riskScore < 25 ? "low" : "high"}`}
                            >
                              {vendor.riskScore}%
                            </span>
                          </TableCell>

                          {/* QUALITY */}
                          <TableCell>{vendor.qualityScore}%</TableCell>

                          {/* COMPLIANCE */}
                          <TableCell>
                            {vendor.complianceReady ? "✅ Ready" : "❌ Missing"}
                          </TableCell>

                          {/* REVENUE */}
                          <TableCell>{vendor.revenuePotential}</TableCell>

                          {/* PENDING */}
                          <TableCell>
                            <span
                              className={`pending_chip ${vendor.pendingDays > 7 ? "danger" : "warning"
                                }`}
                            >
                              ⏱️ {vendor.pendingDays} days
                            </span>
                          </TableCell>

                          {/* STATUS */}
                          <TableCell className="form">
                            <Select
                              value={vendor.status}
                              size="small"
                              fullWidth
                            >
                              <MenuItem value="Submitted">Submitted</MenuItem>
                              <MenuItem value="Needs Info">
                                🟡 Needs Info
                              </MenuItem>
                              <MenuItem value="Under Review">
                                🟠 Under Review
                              </MenuItem>
                              <MenuItem value="Approved">Approved</MenuItem>
                              <MenuItem value="Rejected">Rejected</MenuItem>
                              <MenuItem value="Blocked (compliance)">
                                🔴 Blocked
                              </MenuItem>
                              <MenuItem value="Auto-approved (system)">
                                🤖 Auto-approved
                              </MenuItem>
                            </Select>
                          </TableCell>

                          {/* DATE */}
                          <TableCell>{vendor.date}</TableCell>

                          {/* ACTIONS */}
                          <TableCell>
                            <IconButton>
                              <CheckCircleOutlineOutlinedIcon />
                            </IconButton>
                            <IconButton onClick={() => setOpen1(true)}>
                              <BlockOutlinedIcon />
                            </IconButton>
                          </TableCell>
                        </TableRow>

                        {/* EXPANDED ROW */}
                        {expandedRow === vendor.id && (
                          <TableRow>
                            <TableCell colSpan={applicationColumns.length}>
                              <div className="expand_panel">
                                <h4>📄 Documents Checklist</h4>
                                <ul>
                                  <li>Trade License ✅</li>
                                  <li>Bank Details ✅</li>
                                  <li>VAT Certificate ❌</li>
                                </ul>

                                <h4>🤖 AI Recommendation</h4>
                                <p>
                                  AI Score: <b>{vendor.aiScore}</b> –{" "}
                                  {isAutoApproved(vendor)
                                    ? "Auto-approval recommended"
                                    : "Manual review required"}
                                </p>

                                <h4>🚩 Risk Flags</h4>
                                <p>
                                  {vendor.riskScore < 25
                                    ? "Low risk category"
                                    : "Potential compliance risk"}
                                </p>

                                <div className="quick_actions">
                                  <Button color="success">Quick Approve</Button>
                                  <Button color="error">Reject</Button>
                                </div>
                              </div>
                            </TableCell>
                          </TableRow>
                        )}
                      </>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </div>
          </div>
          <div className="rt">
            <div className="ai_panel">
              <h4>AI Insights</h4>

              <div className="ai_alert warning">
                <span className="icon">⚠️</span>
                <p>
                  <b>7 SKUs</b> need immediate attention
                </p>
              </div>

              <div className="ai_alert danger">
                <span className="icon">⛔</span>
                <p>
                  <b>3 SKUs</b> have zero sales in 30 days
                </p>
              </div>

              <small className="ai_update">
                Next updated ETA: <b>May 5, 2024</b>
              </small>

              <div className="ai_sku_list">
                <div className="ai_sku_row">
                  <div className="ai_sku_info">
                    <h5>#PRD_002</h5>
                    <p>Likely to go out of stock by May</p>
                  </div>
                  <button className="ai_action_btn">Actions ▾</button>
                </div>

                <div className="ai_sku_row">
                  <div className="ai_sku_info">
                    <h5>#PRD_010</h5>
                    <p>Likely to go out of stock by May</p>
                  </div>
                  <button className="ai_action_btn">Actions ▾</button>
                </div>
              </div>

              {/* <div className="ai_create">
                                    + Create AI Insights
             
                                </div> */}
            </div>
          </div>
        </div>
      </CustomTabPanel>
      <CustomTabPanel value={valueTabs1} index={2}>
        <div className="main_title d_flex">
          <div className="left_s">
            <h1>Vendor OnBoarding</h1>
            <p>
              <button onClick={() => navigate("/dashboard")}>Dashboard</button>{" "}
              - Manage Vendor Onboardings
            </p>
          </div>
          <div className="right_s form">
            <input type="date" />
          </div>
        </div>
        <div className="stats_boxes gap_m onboarding_stats">
          <a className="cards">
            <div className="data_top">
              <h2>
                6<p>In Progress</p>
              </h2>
              <figure className="info">
                <PersonAddAltIcon />
              </figure>
            </div>
          </a>

          <a className="cards">
            <div className="data_top">
              <h2>
                2<p>Completed</p>
              </h2>
              <figure className="success">
                <GroupsIcon />
              </figure>
            </div>
          </a>

          <a className="cards">
            <div className="data_top">
              <h2>
                1<p>Blocked</p>
              </h2>
              <figure className="danger">
                <BlockIcon />
              </figure>
            </div>
          </a>

          <a className="cards">
            <div className="data_top">
              <h2>
                7<p>Pending Tasks</p>
              </h2>
              <figure className="warning">
                <PendingActionsIcon />
              </figure>
            </div>
          </a>

          <a className="cards">
            <div className="data_top">
              <h2>
                4<p>Urgent Tasks</p>
              </h2>
              <figure className="orange">
                <ReportProblemIcon />
              </figure>
            </div>
          </a>

          <a className="cards">
            <div className="data_top">
              <h2>
                1<p>Overdue</p>
              </h2>
              <figure className="red">
                <AccessTimeIcon />
              </figure>
            </div>
          </a>
        </div>
        <div className="table_flex mt_20">
          <div className="lt">
            <div className="cards">
              {/* Header stays SAME */}
              <div className="table_header">
                <div className="left_s">
                  <Box className="search_box">
                    <SearchBar
                      searchTerm={searchTerm}
                      setDebouncedSearchTerm={setSearchTerm}
                      placeholder="Search vendors..."
                    />
                  </Box>
                  <div className="ai_priority_toggle">
                    <Button
                      variant={sortByAI ? "contained" : "outlined"}
                      onClick={() => setSortByAI(!sortByAI)}
                      size="small"
                    >
                      Sort by AI Priority
                    </Button>
                  </div>
                </div>
                <div className="right_s">
                  <div className="form">
                    <div className="control_group">
                      <input type="date" />
                    </div>
                    <Select value="Pending" size="small" fullWidth>
                      <MenuItem value="Pending">All Status</MenuItem>
                      <MenuItem value="Submitted">Pending</MenuItem>
                      <MenuItem value="Review">In Progress</MenuItem>
                      <MenuItem value="Approved">Completed</MenuItem>
                      <MenuItem value="Rejected">Blocked</MenuItem>
                    </Select>
                  </div>
                  <div className="form">
                    <Select value="Pending" size="small" fullWidth>
                      <MenuItem value="Pending">All Stages</MenuItem>
                      <MenuItem value="Submitted">Product Training</MenuItem>
                      <MenuItem value="Review">In Progress</MenuItem>
                    </Select>
                  </div>
                </div>
              </div>

              {/* AI Priority Section */}
              {sortByAI && (
                <div className="ai_priority_section">
                  <h4>What should I do first today?</h4>
                  <div className="priority_vendor">
                    <div className="priority_icon">🔴</div>
                    <div className="priority_details">
                      <h5>
                        {
                          vendorData.sort((a, b) => b.aiScore - a.aiScore)[0]
                            ?.name
                        }
                      </h5>
                      <p>
                        Overdue by{" "}
                        {
                          vendorData.sort((a, b) => b.aiScore - a.aiScore)[0]
                            ?.pendingDays
                        }{" "}
                        days
                      </p>
                      <p>
                        Revenue potential:{" "}
                        {
                          vendorData.sort((a, b) => b.aiScore - a.aiScore)[0]
                            ?.revenuePotential
                        }
                      </p>
                      <p>Blocks vendor activation</p>
                      <p>
                        Priority Score:{" "}
                        {
                          vendorData.sort((a, b) => b.aiScore - a.aiScore)[0]
                            ?.aiScore
                        }
                        /100
                      </p>
                      <p>
                        Recommended Action: Escalate training reminder + assign
                        support
                      </p>
                    </div>
                  </div>
                </div>
              )}

              {/* 🔹 Vendor Cards */}
              <div className="vendor_list">
                {vendorData.map((vendor) => (
                  <div
                    className={`vendor_card modern ${vendor.status === "Blocked" ? "blocked" : ""}`}
                  >
                    {/* LEFT SECTION */}
                    <div className="vendor_left">
                      <div className="vendor_avatar">
                        {vendor.name.charAt(0)}
                      </div>

                      <div className="vendor_info">
                        {/* HEADER */}
                        <div className="vendor_header">
                          <h4>{vendor.name}</h4>

                          <span
                            className={`status_badge ${vendor.status.toLowerCase()}`}
                          >
                            {vendor.status}
                          </span>
                        </div>

                        {/* META */}
                        <div className="vendor_meta">
                          <span>{vendor.email}</span>
                          <span>•</span>
                          <span>{vendor.phone}</span>
                        </div>

                        {/* AI PRIORITY */}
                        <div className="ai_priority">
                          <span className="score">
                            Priority Score: <b>{vendor.aiScore}/100</b>
                          </span>
                          <span
                            className={`risk ${vendor.pendingDays > 7 ? "high" : "medium"}`}
                          >
                            {vendor.pendingDays} days pending
                          </span>
                        </div>

                        {/* AI INSIGHTS */}
                        <div className="ai_insights">
                          <p>
                            <b>Why onboarding is delayed</b>
                          </p>
                          <ul>
                            {!vendor.documentsVerified && (
                              <li>Documents not verified</li>
                            )}
                            {!vendor.complianceReady && (
                              <li>Platform training incomplete</li>
                            )}
                            {vendor.pendingDays > 5 && (
                              <li>
                                Vendor inactive for {vendor.pendingDays} days
                              </li>
                            )}
                          </ul>

                          <div className="risk_note">
                            ⚠ Risk: Vendor may drop off
                          </div>
                        </div>

                        {/* RECOMMENDED ACTION */}
                        <div className="ai_action">
                          <b>Recommended Action:</b>
                          <span>
                            Escalate reminder + assign onboarding support
                          </span>
                        </div>

                        {/* TIME TO ACTIVATION */}
                        <div className="activation_eta">
                          ⏳ Estimated activation: <b>2–3 days</b> (if tasks
                          completed)
                        </div>
                      </div>
                    </div>

                    {/* RIGHT SECTION */}
                    <div className="vendor_right">
                      <div className="ai_prediction">
                        <span>Drop-off Risk</span>
                        <b
                          className={vendor.aiScore < 70 ? "danger" : "success"}
                        >
                          {vendor.aiScore < 70 ? "63%" : "Low"}
                        </b>
                      </div>

                      <div className="action_buttons">
                        <button className="secondary">Remind Vendor</button>

                        <button
                          className="primary"
                          onClick={() => setOpen7(true)}
                        >
                          Assign Support
                        </button>
                      </div>

                      <IconButton onClick={() => navigate("view-onboarding")}>
                        <img src="/static/images/eye_icon.svg" />
                      </IconButton>
                    </div>
                  </div>
                ))}
              </div>
            </div>
            <Menu
              anchorEl={menuAnchor}
              open={Boolean(menuAnchor)}
              onClose={() => setMenuAnchor(null)}
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "right",
              }}
              transformOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
            >
              <MenuItem>
                <ListItemIcon>
                  <ArrowForwardIcon fontSize="small" />
                </ListItemIcon>
                Move to Next Stage
              </MenuItem>
              <MenuItem>
                <ListItemIcon>
                  <BlockIcon fontSize="small" />
                </ListItemIcon>
                Block
              </MenuItem>
              <MenuItem>
                <ListItemIcon>
                  <CheckCircleIcon fontSize="small" />
                </ListItemIcon>
                Complete Onboarding
              </MenuItem>
            </Menu>
          </div>
          <div className="rt">
            <div className="ai_panel">
              <h4>AI Insights</h4>

              <div className="ai_alert warning">
                <span className="icon">⚠️</span>
                <p>
                  <b>7 SKUs</b> need immediate attention
                </p>
              </div>

              <div className="ai_alert danger">
                <span className="icon">⛔</span>
                <p>
                  <b>3 SKUs</b> have zero sales in 30 days
                </p>
              </div>

              <small className="ai_update">
                Next updated ETA: <b>May 5, 2024</b>
              </small>

              <div className="ai_sku_list">
                <div className="ai_sku_row">
                  <div className="ai_sku_info">
                    <h5>#PRD_002</h5>
                    <p>Likely to go out of stock by May</p>
                  </div>
                  <button className="ai_action_btn">Actions ▾</button>
                </div>

                <div className="ai_sku_row">
                  <div className="ai_sku_info">
                    <h5>#PRD_010</h5>
                    <p>Likely to go out of stock by May</p>
                  </div>
                  <button className="ai_action_btn">Actions ▾</button>
                </div>
              </div>

              {/* <div className="ai_create">
                                    + Create AI Insights
                                </div> */}
            </div>
          </div>
        </div>
      </CustomTabPanel>
      <CustomTabPanel value={valueTabs1} index={3}>
        <div className="main_title d_flex">
          <div className="left_s">
            <h1>Legal & Documents</h1>
            <p>
              <button onClick={() => navigate("/dashboard")}>Dashboard</button>{" "}
              - Legal & Documents
            </p>
          </div>
          <div className="right_s form">
            <input type="date" />
            <Button className="btn btn_primary sm br_15">Refresh Data</Button>
          </div>
        </div>
        <div className="stats_boxes gap_m">
          {/* TOTAL PAYOUTS */}
          <a className="cards">
            <div className="data_top">
              <h2>
                100
                <p>Total Documents</p>
              </h2>
              <figure className="blue">
                <AttachMoneyOutlinedIcon fontSize="large" />
              </figure>
            </div>
          </a>
        </div>
        <div className="cards mt_20">
          <div className="table_header">
            <div className="left_s">
              <SearchBar
                searchTerm={searchTerm}
                setDebouncedSearchTerm={setSearchTerm}
                placeholder="Search..."
              />
              <div className="form ml_10">
                <Select
                  multiple
                  displayEmpty
                  value={visibleDocumentColumns}
                  onChange={(e) =>
                    setVisibleDocumentColumns(e.target.value as string[])
                  }
                  size="small"
                  renderValue={(selected) =>
                    selected.length === documentColumns.length
                      ? "All Columns Selected"
                      : `${selected.length} columns visible`
                  }
                  sx={{ minWidth: 200 }}
                >
                  {documentColumns.map((col) => (
                    <MenuItem key={col} value={col}>
                      <Checkbox checked={visibleDocumentColumns.includes(col)} />
                      <ListItemText primary={col} />
                    </MenuItem>
                  ))}
                </Select>
              </div>
            </div>
          </div>
          <TableContainer className="table_container">
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>Sr. No.</TableCell>
                  <TableCell>Business Details</TableCell>
                  <TableCell>Vendor Details</TableCell>
                  <TableCell>Document Name</TableCell>
                  <TableCell>Document Upload Date</TableCell>
                  <TableCell>View Document</TableCell>
                  <TableCell>Document Expiry Date</TableCell>
                  <TableCell>Suspend Document</TableCell>
                </TableRow>
              </TableHead>

              <TableBody>
                {documentsData.map((item, index) => (
                  <TableRow hover key={item.id}>
                    <TableCell>{index + 1}</TableCell>
                    {/* BUSINESS INFO */}
                    <TableCell>
                      <div className="user_block">
                        <p>
                          <b>{item.businessName}</b>
                          <span>{item.email}</span>
                          <span
                            className="badge1 neutral"
                            style={{ fontSize: "10px", marginTop: "4px" }}
                          >
                            {item.type} • {item.stores} Stores
                          </span>
                        </p>
                      </div>
                    </TableCell>

                    {/* VENDOR DETAILS */}
                    <TableCell>
                      <div className="user_block">
                        <p>
                          <b>Authorized Rep</b>
                          <span>{item.phone}</span>
                          <small className="vendor_id">{item.vendorId}</small>
                        </p>
                      </div>
                    </TableCell>

                    <TableCell>{item.licenseName}</TableCell>

                    <TableCell>{item.uploadedDate}</TableCell>

                    <TableCell>
                      <Button className="btn btn_primary sm">
                        View Document
                      </Button>
                    </TableCell>

                    <TableCell>{item.expiryDate}</TableCell>
                    <TableCell>
                      <SwitchToggle
                        checked={enabled}
                        onChange={(e) => {
                          const isChecked = e.target.checked;
                          setEnabled(isChecked);

                          if (isChecked) {
                            setOpen1(true); // open modal when ON
                          }
                        }}
                      />
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </div>
      </CustomTabPanel>
      <CustomTabPanel value={valueTabs1} index={4}>
        <div className="main_title d_flex">
          <div className="left_s">
            <h1>Vendor Lifecycle</h1>
            <p>
              <button onClick={() => navigate("/dashboard")}>Dashboard</button>{" "}
              - Vendor Performance
            </p>
          </div>
          <div className="right_s form">
            <input type="date" />
            <Button className="btn btn_primary sm br_15">Refersh Data</Button>
          </div>
        </div>
        <div className="stats_boxes gap_m onboarding_stats">
          {/* New Vendors This Month */}
          <a className="cards">
            <div className="data_top">
              <h2>
                0<p>New Vendors This Month</p>
              </h2>
              <figure className="success">
                <TrendingUpIcon />
              </figure>
            </div>

            <div className="ai_insight positive">
              <span>This month</span>
            </div>
          </a>

          {/* Active Vendors */}
          <a className="cards">
            <div className="data_top">
              <h2>
                3<p>Active Vendors</p>
              </h2>
              <figure className="info">
                <CheckCircleOutlineIcon />
              </figure>
            </div>

            <div className="ai_insight info">
              <span>Currently active</span>
            </div>
          </a>

          {/* At Risk Vendors */}
          <a className="cards">
            <div className="data_top">
              <h2>
                2<p>At Risk Vendors</p>
              </h2>
              <figure className="warning">
                <WarningAmberIcon />
              </figure>
            </div>

            <div className="ai_insight warning">
              <span>Needs attention</span>
            </div>
          </a>

          {/* Churned This Month */}
          <a className="cards">
            <div className="data_top">
              <h2>
                1<p>Churned This Month</p>
              </h2>
              <figure className="danger">
                <PersonOffIcon />
              </figure>
            </div>

            <div className="ai_insight negative">
              <span>Lost vendors</span>
            </div>
          </a>
        </div>
        <div className="cards mt_20">
          <h3>Lifecycle Stages</h3>
          <div className="stats_boxes gap_m onboarding_stats">
            {/* Prospect */}
            <a className="cards">
              <div className="data_top">
                <h2>
                  0<p>Prospect</p>
                </h2>
                <figure className="neutral">
                  <PersonSearchIcon />
                </figure>
              </div>
            </a>

            {/* Onboarding */}
            <a className="cards">
              <div className="data_top">
                <h2>
                  3<p>Onboarding</p>
                </h2>
                <figure className="info">
                  <AutorenewIcon />
                </figure>
              </div>
            </a>

            {/* Active */}
            <a className="cards">
              <div className="data_top">
                <h2>
                  3<p>Active</p>
                </h2>
                <figure className="success">
                  <CheckCircleIcon />
                </figure>
              </div>
            </a>

            {/* Growing */}
            <a className="cards">
              <div className="data_top">
                <h2>
                  2<p>Growing</p>
                </h2>
                <figure className="purple">
                  <TrendingUpIcon />
                </figure>
              </div>
            </a>

            {/* Established */}
            <a className="cards">
              <div className="data_top">
                <h2>
                  1<p>Established</p>
                </h2>
                <figure className="blue">
                  <WorkspacePremiumIcon />
                </figure>
              </div>
            </a>

            {/* At Risk */}
            <a className="cards">
              <div className="data_top">
                <h2>
                  2<p>At Risk</p>
                </h2>
                <figure className="warning">
                  <WarningAmberIcon />
                </figure>
              </div>
            </a>

            {/* Churned */}
            <a className="cards">
              <div className="data_top">
                <h2>
                  1<p>Churned</p>
                </h2>
                <figure className="danger">
                  <PersonOffIcon />
                </figure>
              </div>
            </a>

            {/* Suspended */}
            <a className="cards">
              <div className="data_top">
                <h2>
                  1<p>Suspended</p>
                </h2>
                <figure className="red">
                  <BlockIcon />
                </figure>
              </div>
            </a>
          </div>
        </div>
        <div className="table_flex mt_20">
          <div className="lt">
            <div className="cards">
              <Box className="custom_tabs">
                <Tabs
                  value={valueTabs}
                  onChange={handleChangeTabs}
                  className="custom_tabs_links"
                >
                  <Tab label="Overview" {...a11yProps(0)} />
                  <Tab label="Transaction History" {...a11yProps(1)} />
                  <Tab label="Milestone" {...a11yProps(2)} />
                  <Tab label="Engagement" {...a11yProps(3)} />
                  <Tab label="Governance Rules" {...a11yProps(4)} />
                </Tabs>
              </Box>
              <CustomTabPanel value={valueTabs} index={0}>
                <div className="table_header">
                  <div className="left_s">
                    <Box className="search_box">
                      <SearchBar
                        searchTerm={searchTerm}
                        setDebouncedSearchTerm={setSearchTerm}
                        placeholder="Search vendors..."
                      />
                    </Box>
                    <div className=" form">
                      <Select value="Pending" size="small" fullWidth>
                        <MenuItem value="Pending">All Stages</MenuItem>
                        <MenuItem value="Accepted">Prospect</MenuItem>
                        <MenuItem value="Rejected">Onboarding</MenuItem>
                        <MenuItem value="Rejected">Active</MenuItem>
                        <MenuItem value="Rejected">Growing</MenuItem>
                        <MenuItem value="Rejected">At Risk</MenuItem>
                      </Select>
                    </div>
                  </div>
                  <div className="right_s form">
                    <input type="date" />
                  </div>
                </div>
                <div className="lifecycle_overview_cards">
                  {lifecycleData.map((item, index) => (
                    <div className={`lifecycle_card ${item.level}`} key={index}>
                      <div className="card_header">
                        <div className="header_left">
                          <span className={`status_icon ${item.level}`}>
                            {item.icon}
                          </span>
                          <div>
                            <h4 className="vendor_name">{item.name}</h4>
                            <div className="transition_badge">
                              <span className="from">{item.from}</span>
                              <ArrowForwardIcon
                                fontSize="small"
                                className="arrow"
                              />
                              <span className="to">{item.to}</span>
                            </div>
                          </div>
                        </div>
                        <div className="header_right">
                          {item.healthIndicator && (
                            <span
                              className={`health_badge ${item.healthIndicator.toLowerCase()}`}
                            >
                              {item.healthIndicator === "Stable" && "🟢"}
                              {item.healthIndicator === "Watch" && "🟡"}
                              {item.healthIndicator === "Critical" && "🔴"}
                              {item.healthIndicator}
                            </span>
                          )}
                        </div>
                      </div>

                      <div className="card_drivers">
                        <div className="driver_item">
                          <label htmlFor={`hs_${index}`}>Health Score</label>
                          <div className="value" id={`hs_${index}`}>
                            {item.keyDrivers?.health || 0}
                            <small>/100</small>
                          </div>
                        </div>
                        <div className="driver_item">
                          <label htmlFor={`rev_${index}`}>Revenue</label>
                          <div className="value" id={`rev_${index}`}>
                            {item.keyDrivers?.revenue || "0"}
                          </div>
                        </div>
                        <div className="driver_item">
                          <label htmlFor={`comp_${index}`}>Complaints</label>
                          <div className="value" id={`comp_${index}`}>
                            {item.keyDrivers?.complaints || 0}
                          </div>
                        </div>
                      </div>

                      {item.aiDecision && (
                        <div className="ai_decision_box">
                          <div className="ai_header">
                            <h5>AI Decision Summary</h5>
                            <span
                              className={`confidence ${item.aiDecision.confidence.toLowerCase()}`}
                            >
                              {item.aiDecision.confidence} Confidence
                            </span>
                          </div>
                          <ul className="decision_points">
                            <li>{item.aiDecision.summary}</li>
                            <li>Reason: {item.aiDecision.reason}</li>
                          </ul>
                          <div className="recommendation">
                            <strong>Recommended:</strong>{" "}
                            {item.aiDecision.recommendedAction}
                          </div>
                        </div>
                      )}

                      {item.prediction && (
                        <div className="prediction_box">
                          <div className="pred_title">
                            “What Happens If No Action Is Taken?”
                          </div>
                          <p>{item.prediction}</p>
                        </div>
                      )}

                      {item.suggestedActions && (
                        <div className="action_suggestions">
                          <label htmlFor={`rec_act_${index}`}>Recommended Actions:</label>
                          <div className="action_buttons" id={`rec_act_${index}`}>
                            {item.suggestedActions.map((action, i) => (
                              <button key={i} className="action_chip">
                                {action}
                              </button>
                            ))}
                          </div>
                        </div>
                      )}
                    </div>
                  ))}
                </div>
              </CustomTabPanel>
              <CustomTabPanel value={valueTabs} index={1}>
                <div className="table_header">
                  <div className="left_s">
                    <Box className="search_box">
                      <SearchBar
                        searchTerm={searchTerm}
                        setDebouncedSearchTerm={setSearchTerm}
                        placeholder="Search vendors..."
                      />
                    </Box>
                  </div>
                  <div className="right_s form">
                    <Select
                      multiple
                      displayEmpty
                      value={visibleLifecycleColumns}
                      onChange={(e) =>
                        setVisibleLifecycleColumns(e.target.value as string[])
                      }
                      size="small"
                      renderValue={(selected) =>
                        selected.length === lifecycleColumns.length
                          ? "All Columns Selected"
                          : `${selected.length} columns visible`
                      }
                      sx={{ minWidth: 200 }}
                    >
                      {lifecycleColumns.map((col) => (
                        <MenuItem key={col} value={col}>
                          <Checkbox
                            checked={visibleLifecycleColumns.includes(col)}
                          />
                          <ListItemText primary={col} />
                        </MenuItem>
                      ))}
                    </Select>
                    <input type="date" />
                  </div>
                </div>
                <TableContainer className="table_container">
                  <Table>
                    <TableHead>
                      <TableRow>
                        {lifecycleColumns.map((col, i) => (
                          <TableCell key={i}>{col}</TableCell>
                        ))}
                      </TableRow>
                    </TableHead>

                    <TableBody>
                      {lifecycleTableData.map((row) => (
                        <TableRow key={row.id} hover>
                          {/* Vendor */}
                          <TableCell>
                            <b>{row.name}</b>
                          </TableCell>

                          {/* From */}
                          <TableCell>
                            <span className="stage_text">{row.from}</span>
                          </TableCell>

                          {/* To */}
                          <TableCell>
                            <span
                              className={`status_chip ${row.to.toLowerCase().replace(" ", "_")}`}
                            >
                              {row.to}
                            </span>
                          </TableCell>

                          {/* Reason */}
                          <TableCell>
                            <span className="reason_text">{row.reason}</span>
                          </TableCell>

                          {/* Trigger */}
                          <TableCell>
                            <span className={`trigger_chip ${row.trigger}`}>
                              {row.trigger}
                            </span>
                          </TableCell>

                          {/* Date */}
                          <TableCell>{row.date}</TableCell>

                          {/* Actions */}
                          <TableCell>
                            <div className="table_actions v2">
                              <IconButton onClick={() => setOpen(true)}>
                                <img src="/static/images/eye_icon.svg" />
                              </IconButton>
                            </div>
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </CustomTabPanel>
              <CustomTabPanel value={valueTabs} index={2}>
                <div className="table_header">
                  <div className="left_s">
                    <Box className="search_box">
                      <SearchBar
                        searchTerm={searchTerm}
                        setDebouncedSearchTerm={setSearchTerm}
                        placeholder="Search vendors..."
                      />
                    </Box>
                  </div>
                  <div className="right_s form">
                    <input type="date" />
                    <Button
                      className="btn btn_primary"
                      onClick={() => setOpen2(true)}
                    >
                      Add Milestone
                    </Button>
                  </div>
                </div>
                <div className="milestones">
                  {milestoneData.map((item, index) => (
                    <div
                      className="milestone_card"
                      key={index}
                      onClick={() => navigate("view-milestone")}
                    >
                      <div className="card_top">
                        <div className="icon_wrap">{item.icon}</div>
                        <span className="badge">{item.type}</span>
                      </div>

                      <h4 className="title">{item.title}</h4>
                      <p className="vendor">{item.vendor}</p>

                      <p className="description">{item.description}</p>

                      <div className="card_bottom">
                        <span className="value">{item.value}</span>
                        <span className="date">{item.date}</span>
                      </div>
                    </div>
                  ))}
                </div>
              </CustomTabPanel>
              <CustomTabPanel value={valueTabs} index={3}>
                <div className="table_header">
                  <div className="left_s">
                    <Box className="search_box">
                      <SearchBar
                        searchTerm={searchTerm}
                        setDebouncedSearchTerm={setSearchTerm}
                        placeholder="Search vendors..."
                      />
                    </Box>
                  </div>
                  <div className="right_s form">
                    <input type="date" />
                    <Button className="btn btn_primary">Log Engagement</Button>
                  </div>
                </div>
                <div className="milestones">
                  {engagementData.map((item, index) => (
                    <div className="milestone_card" key={index}>
                      <div className="card_top">
                        <div className="icon_wrap">{item.icon}</div>
                        <span className="badge">{item.type}</span>
                      </div>

                      <h4 className="title">{item.title}</h4>
                      <p className="vendor">{item.vendor}</p>

                      <p className="description">{item.description}</p>

                      <div className="card_bottom">
                        <span className="value">{item.value}</span>
                        <span className="date">{item.date}</span>
                      </div>
                    </div>
                  ))}
                </div>
              </CustomTabPanel>
              <CustomTabPanel value={valueTabs} index={4}>
                <div className="governance_rules_panel">
                  <h3>Lifecycle Governance Rules</h3>
                  <p className="subtitle">
                    Configure how vendors move through lifecycle stages and AI
                    automation rules.
                  </p>

                  <div className="rules_section">
                    <h4>Health Score Thresholds</h4>
                    <div className="threshold_grid">
                      <div className="threshold_item stable">
                        <label htmlFor="score_stable">🟢 Stable Vendor</label>
                        <div className="input_group">
                          <span>Score &gt;</span>
                          <input id="score_stable" type="number" defaultValue={80} />
                        </div>
                      </div>
                      <div className="threshold_item watch">
                        <label htmlFor="score_watch_from">🟡 Watch List</label>
                        <div className="input_group">
                          <span>Score between</span>
                          <input id="score_watch_from" type="number" defaultValue={60} />
                          <span>and</span>
                          <input id="score_watch_to" type="number" defaultValue={79} />
                        </div>
                      </div>
                      <div className="threshold_item critical">
                        <label htmlFor="score_critical">🔴 Critical (At Risk)</label>
                        <div className="input_group">
                          <span>Score &lt;</span>
                          <input id="score_critical" type="number" defaultValue={60} />
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="rules_section">
                    <h4>Evaluation Time Windows</h4>
                    <div className="form_row">
                      <label htmlFor="review_freq">Review Frequency</label>
                      <select id="review_freq" defaultValue="7">
                        <option value="7">Every 7 Days</option>
                        <option value="14">Every 14 Days</option>
                        <option value="30">Every 30 Days</option>
                      </select>
                    </div>
                    <div className="form_row">
                      <label htmlFor="probation_period">Probation Period for New Vendors</label>
                      <select id="probation_period" defaultValue="30">
                        <option value="30">30 Days</option>
                        <option value="60">60 Days</option>
                        <option value="90">90 Days</option>
                      </select>
                    </div>
                  </div>

                  <div className="rules_section">
                    <h4>Auto-Transition Rules</h4>
                    <div className="checklist">
                      <label htmlFor="auto_trans_1" className="check_item">
                        <input id="auto_trans_1" type="checkbox" defaultChecked />
                        <div>
                          <strong>Onboarding → Active</strong>
                          <p>When documents verified and training complete</p>
                        </div>
                      </label>
                      <label htmlFor="auto_trans_2" className="check_item">
                        <input id="auto_trans_2" type="checkbox" defaultChecked />
                        <div>
                          <strong>Active → At Risk</strong>
                          <p>
                            When health score drops below threshold for 7 days
                          </p>
                        </div>
                      </label>
                      <label htmlFor="auto_trans_3" className="check_item">
                        <input id="auto_trans_3" type="checkbox" defaultChecked />
                        <div>
                          <strong>Growing → Established</strong>
                          <p>
                            When revenue targets met for 3 consecutive months
                          </p>
                        </div>
                      </label>
                      <label htmlFor="auto_trans_4" className="check_item">
                        <input id="auto_trans_4" type="checkbox" />
                        <div>
                          <strong>At Risk → Suspended</strong>
                          <p>
                            Allow AI to auto-suspend critical vendors (Not
                            Recommended)
                          </p>
                        </div>
                      </label>
                    </div>
                  </div>

                 
                </div>
              </CustomTabPanel>
            </div>
          </div>
          {valueTabs !== 4 && (
            <div className="rt">
              <div className="ai_panel">
                <h4>AI Insights</h4>

                <div className="ai_alert warning">
                  <span className="icon">⚠️</span>
                  <p>
                    <b>7 SKUs</b> need immediate attention
                  </p>
                </div>

                <div className="ai_alert danger">
                  <span className="icon">⛔</span>
                  <p>
                    <b>3 SKUs</b> have zero sales in 30 days
                  </p>
                </div>

                <small className="ai_update">
                  Next updated ETA: <b>May 5, 2024</b>
                </small>

                <div className="ai_sku_list">
                  <div className="ai_sku_row">
                    <div className="ai_sku_info">
                      <h5>#PRD_002</h5>
                      <p>Likely to go out of stock by May</p>
                    </div>
                    <button className="ai_action_btn">Actions ▾</button>
                  </div>

                  <div className="ai_sku_row">
                    <div className="ai_sku_info">
                      <h5>#PRD_010</h5>
                      <p>Likely to go out of stock by May</p>
                    </div>
                    <button className="ai_action_btn">Actions ▾</button>
                  </div>
                </div>

                {/* <div className="ai_create">
                                      + Create AI Insights
                                  </div> */}
              </div>
            </div>
          )}
        </div>
      </CustomTabPanel>
      <CustomTabPanel value={valueTabs1} index={5}>
        <div className="main_title d_flex">
          <div className="left_s">
            <h1>Vendor Performance</h1>
            <p>
              <button onClick={() => navigate("/dashboard")}>Dashboard</button>{" "}
              - Vendor Performance
            </p>
          </div>
          <div className="right_s form">
            <input type="date" />
          </div>
        </div>
        <div className="stats_boxes gap_m onboarding_stats">
          {/* Avg Health Score */}
          <a className="cards">
            <div className="data_top">
              <h2>
                88
                <p>Avg Health Score</p>
              </h2>
              <figure className="info">
                <FavoriteIcon />
              </figure>
            </div>

            <div className="ai_insight info">
              <span>Out of 100</span>
            </div>
          </a>

          {/* Total Orders */}
          <a className="cards">
            <div className="data_top">
              <h2>
                1,641
                <p>Total Orders</p>
              </h2>
              <figure className="success">
                <ShoppingCartIcon />
              </figure>
            </div>

            <div className="ai_insight positive">
              <span>+15% last month</span>
            </div>
          </a>

          {/* Avg Rating */}
          <a className="cards">
            <div className="data_top">
              <h2>
                0.0
                <p>Avg Rating</p>
              </h2>
              <figure className="warning">
                <StarIcon />
              </figure>
            </div>

            <div className="ai_insight neutral">
              <span>Out of 5</span>
            </div>
          </a>

          {/* Total Revenue */}
          <a className="cards">
            <div className="data_top">
              <h2>
                AED 0<p>Total Revenue</p>
              </h2>
              <figure className="orange">
                <CurrencyExchangeIcon />
              </figure>
            </div>

            <div className="ai_insight info">
              <span>+0% last month</span>
            </div>
          </a>
        </div>
        <div className="table_flex mt_20">
          <div className="lt">
            <div className="cards">
              <div className="table_header">
                <div className="left_s">
                  <Box className="search_box">
                    <SearchBar
                      searchTerm={searchTerm}
                      setDebouncedSearchTerm={setSearchTerm}
                      placeholder="Search vendors..."
                    />
                  </Box>
                  <div className="form">
                    <div className="control_group">
                      <input type="date" />
                    </div>
                  </div>
                </div>
                <div className="right_s">
                  <div className="form">
                    <Select
                      multiple
                      displayEmpty
                      value={visiblePerformanceColumns}
                      onChange={(e) =>
                        setVisiblePerformanceColumns(e.target.value as string[])
                      }
                      size="small"
                      renderValue={(selected) =>
                        selected.length === performanceColumns.length
                          ? "All Columns Selected"
                          : `${selected.length} columns visible`
                      }
                      sx={{ minWidth: 200 }}
                    >
                      {performanceColumns.map((col) => (
                        <MenuItem key={col} value={col}>
                          <Checkbox
                            checked={visiblePerformanceColumns.includes(col)}
                          />
                          <ListItemText primary={col} />
                        </MenuItem>
                      ))}
                    </Select>
                  </div>
                </div>
              </div>
              <TableContainer className="table_container">
                <Table>
                  <TableHead>
                    <TableRow>
                      {performanceColumns.map((col, i) => (
                        <TableCell key={i}>{col}</TableCell>
                      ))}
                    </TableRow>
                  </TableHead>

                  <TableBody>
                    {vendorPerformanceData.map((vendor: any, index) => (
                      <TableRow key={vendor.id} hover>
                        {/* Vendor Details */}
                        <TableCell>
                          <div className="vendor_cell">
                            <b>{vendor.name} Contact</b>
                            <br />
                            <small>{vendor.id}</small>
                          </div>
                        </TableCell>
                        <TableCell>
                          <div className="business_cell">
                            <b>{vendor.name}</b>
                            <br />
                            <span
                              className="badge1 neutral"
                              style={{ fontSize: "10px", marginTop: "4px" }}
                            >
                              Verified Partner
                            </span>
                          </div>
                        </TableCell>

                        {/* Period */}
                        <TableCell>
                          {vendor.periodStart} – {vendor.periodEnd}
                        </TableCell>

                        {/* Orders */}
                        <TableCell>{vendor.orders}</TableCell>

                        {/* Completed */}
                        <TableCell>
                          <Tooltip
                            title={
                              <Box sx={{ p: 1 }}>
                                <Typography variant="subtitle2" mb={1}>
                                  Completion Breakdown
                                </Typography>
                                <Typography variant="caption" display="block">
                                  Delivered:{" "}
                                  {
                                    vendor.performanceBreakdown?.completed
                                      .delivered
                                  }
                                </Typography>
                                <Typography variant="caption" display="block">
                                  Cancelled:{" "}
                                  {
                                    vendor.performanceBreakdown?.completed
                                      .cancelled
                                  }
                                </Typography>
                                <Typography variant="caption" display="block">
                                  Returned:{" "}
                                  {
                                    vendor.performanceBreakdown?.completed
                                      .returned
                                  }
                                </Typography>
                              </Box>
                            }
                            arrow
                          >
                            <span>
                              {vendor.completed}/{vendor.orders}
                            </span>
                          </Tooltip>
                        </TableCell>

                        {/* GMV */}
                        <TableCell>
                          <Tooltip
                            title={
                              <Box sx={{ p: 1 }}>
                                <Typography variant="subtitle2" mb={1}>
                                  GMV Breakdown
                                </Typography>
                                <Typography variant="caption" display="block">
                                  Product Sales:{" "}
                                  {vendor.performanceBreakdown?.gmv.products}
                                </Typography>
                                <Typography variant="caption" display="block">
                                  Shipping:{" "}
                                  {vendor.performanceBreakdown?.gmv.shipping}
                                </Typography>
                                <Typography variant="caption" display="block">
                                  VAT (Collectable):{" "}
                                  {vendor.performanceBreakdown?.gmv.vat}
                                </Typography>
                              </Box>
                            }
                            arrow
                          >
                            <span>{vendor.gmv}</span>
                          </Tooltip>
                        </TableCell>

                        {/* Commission */}
                        <TableCell>
                          <Tooltip
                            title={
                              <Box sx={{ p: 1 }}>
                                <Typography variant="subtitle2" mb={1}>
                                  Commission Breakdown
                                </Typography>
                                <Typography variant="caption" display="block">
                                  Base %:{" "}
                                  {vendor.performanceBreakdown?.commission.base}
                                </Typography>
                                <Typography variant="caption" display="block">
                                  Adjustments:{" "}
                                  {
                                    vendor.performanceBreakdown?.commission
                                      .adjust
                                  }
                                </Typography>
                              </Box>
                            }
                            arrow
                          >
                            <span>{vendor.commission}</span>
                          </Tooltip>
                        </TableCell>

                        {/* Net to Vendor */}
                        <TableCell>
                          <Tooltip
                            title={
                              <Box sx={{ p: 1 }}>
                                <Typography variant="subtitle2" mb={1}>
                                  Payout Calculation
                                </Typography>
                                <Typography variant="caption" display="block">
                                  Gross GMV:{" "}
                                  {vendor.performanceBreakdown?.netToVendor.gmv}
                                </Typography>
                                <Typography variant="caption" display="block">
                                  Total Deductions:{" "}
                                  {
                                    vendor.performanceBreakdown?.netToVendor
                                      .deductions
                                  }
                                </Typography>
                                <hr
                                  style={{
                                    margin: "4px 0",
                                    borderColor: "rgba(255,255,255,0.1)",
                                  }}
                                />
                                <Typography variant="caption" display="block">
                                  <b>Payable: {vendor.netToVendor}</b>
                                </Typography>
                              </Box>
                            }
                            arrow
                          >
                            <span>{vendor.netToVendor}</span>
                          </Tooltip>
                        </TableCell>

                        {/* Revenue */}
                        <TableCell>
                          <Tooltip
                            title={
                              <Box sx={{ p: 1 }}>
                                <Typography variant="subtitle2" mb={1}>
                                  Platform Revenue
                                </Typography>
                                <Typography variant="caption" display="block">
                                  Commission:{" "}
                                  {vendor.performanceBreakdown?.revenue.base}
                                </Typography>
                                <Typography variant="caption" display="block">
                                  Ad Revenue:{" "}
                                  {vendor.performanceBreakdown?.revenue.ads}
                                </Typography>
                              </Box>
                            }
                            arrow
                          >
                            <span>{vendor.revenue}</span>
                          </Tooltip>
                        </TableCell>

                        {/* Rating */}
                        <TableCell>⭐ {vendor.rating}</TableCell>

                        {/* On Time % */}
                        <TableCell>
                          <Tooltip
                            title={
                              <Box sx={{ p: 1 }}>
                                <Typography variant="subtitle2" mb={1}>
                                  Shipping Performance
                                </Typography>
                                <Typography
                                  variant="caption"
                                  display="block"
                                  sx={{ color: "#4caf50" }}
                                >
                                  Early:{" "}
                                  {vendor.performanceBreakdown?.onTime.early}
                                </Typography>
                                <Typography variant="caption" display="block">
                                  On-Time:{" "}
                                  {
                                    vendor.performanceBreakdown?.onTime
                                      .justInTime
                                  }
                                </Typography>
                                <Typography
                                  variant="caption"
                                  display="block"
                                  sx={{ color: "#f44336" }}
                                >
                                  Delayed:{" "}
                                  {vendor.performanceBreakdown?.onTime.delayed}
                                </Typography>
                              </Box>
                            }
                            arrow
                          >
                            <span
                              className={`ontime ${vendor.onTime >= 90 ? "good" : "avg"}`}
                            >
                              {vendor.onTime}%
                            </span>
                          </Tooltip>
                        </TableCell>

                        {/* Health */}
                        <TableCell
                          className="cr_pt"
                          onClick={() => setOpen6(true)}
                        >
                          <Tooltip
                            title={
                              <Box sx={{ p: 1 }}>
                                <Typography variant="subtitle2">
                                  AI Risk Score: {vendor.riskScore}
                                </Typography>
                                <hr />
                                <Typography variant="caption" display="block">
                                  Fulfillment:{" "}
                                  {vendor.healthMetrics?.fulfillment || 0}%
                                </Typography>
                                <Typography variant="caption" display="block">
                                  On-time: {vendor.healthMetrics?.onTime || 0}%
                                </Typography>
                                <Typography variant="caption" display="block">
                                  Completion:{" "}
                                  {vendor.healthMetrics?.completion || 0}%
                                </Typography>
                                <Typography variant="caption" display="block">
                                  Complaints:{" "}
                                  {vendor.healthMetrics?.complaints || 0}
                                </Typography>
                                <Typography variant="caption" display="block">
                                  Return Rate:{" "}
                                  {vendor.healthMetrics?.returnRate || 0}%
                                </Typography>
                              </Box>
                            }
                            arrow
                          >
                            <Box>
                              <HealthBar value={vendor.health} />
                              <small>{vendor.health}</small>
                            </Box>
                          </Tooltip>
                        </TableCell>

                        {/* AI Insights */}
                        <TableCell>
                          {vendor.aiInsight && (
                            <Tooltip title={vendor.aiInsight} arrow>
                              <IconButton size="small">
                                <SmartToyOutlinedIcon
                                  color="primary"
                                  fontSize="small"
                                />
                              </IconButton>
                            </Tooltip>
                          )}
                        </TableCell>

                        {/* Actions */}
                        <TableCell>
                          <div className="table_actions v2">
                            <IconButton
                              onClick={() =>
                                navigate("/manage-vendors/view-vendor")
                              }
                              title="View Vendor"
                            >
                              <img src="/static/images/eye_icon.svg" />
                            </IconButton>
                            <IconButton title="Edit Vendor">
                              <img src="/static/images/edit2_icon.svg" />
                            </IconButton>
                            {vendor.aiRecommendation && (
                              <Tooltip
                                title={
                                  <Box sx={{ p: 1 }}>
                                    <Typography variant="subtitle2">
                                      AI Recommendation
                                    </Typography>
                                    <Typography variant="body2">
                                      Action: {vendor.aiRecommendation.action}
                                    </Typography>
                                    <Typography
                                      variant="caption"
                                      display="block"
                                    >
                                      Reason: {vendor.aiRecommendation.reason}
                                    </Typography>
                                  </Box>
                                }
                                arrow
                              >
                                <IconButton size="small">
                                  <TrendingUpIcon color="secondary" />
                                </IconButton>
                              </Tooltip>
                            )}
                          </div>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </div>
          </div>
          <div className="rt">
            <div className="ai_panel">
              <h4>Automated Workflows</h4>

              <div className="ai_alert danger">
                <span className="icon">🔴</span>
                <p>
                  <b>At-Risk Vendor</b> (Health &lt; 75%)
                </p>
                <ul
                  className="mt_5"
                  style={{ fontSize: "11px", listStyle: "none", padding: 0 }}
                >
                  <li>• Notify Admin & Send Warning</li>
                  <li>• Suggest Performance Plan (PIP)</li>
                </ul>
              </div>

              <div className="ai_alert positive">
                <span className="icon">🟢</span>
                <p>
                  <b>Preferred Vendor</b> (Health &gt; 90%)
                </p>
                <ul
                  className="mt_5"
                  style={{ fontSize: "11px", listStyle: "none", padding: 0 }}
                >
                  <li>• Mark as "Preferred" status</li>
                  <li>• AI Recommends: Faster Payouts</li>
                </ul>
              </div>

              <small className="ai_update">
                AI Real-time Monitoring Active
              </small>

              <div className="ai_sku_list">
                <div className="ai_sku_row">
                  <div className="ai_sku_info">
                    <h5>Workflow Trigger</h5>
                    <p>On-time &lt; 85% for 2 periods</p>
                  </div>
                  <button className="ai_action_btn">View AI PIP</button>
                </div>

                <div className="ai_sku_row">
                  <div className="ai_sku_info">
                    <h5>High Performance</h5>
                    <p>Completion &gt; 98% (30d)</p>
                  </div>
                  <button className="ai_action_btn">Auto-Approve</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </CustomTabPanel>
      <CustomTabPanel value={valueTabs1} index={6}>
        <div className="main_title d_flex">
          <div className="left_s">
            <h1>Vendor Products</h1>
            <p>
              <button onClick={() => navigate("/dashboard")}>Dashboard</button>{" "}
              - Vendor Products
            </p>
          </div>
          <div className="right_s form">
            <input type="date" />
          </div>
        </div>
        <div className="stats_boxes gap_m">
          {/* TOTAL PRODUCTS */}
          <a className="cards">
            <div className="data_top">
              <h2>
                {totalProducts}
                <p>Total Products</p>
              </h2>
              <figure className="blue">
                <Inventory2Icon fontSize="large" />
              </figure>
            </div>

            <div className="ai_insight info">
              <span>All products</span>
            </div>
          </a>

          {/* ACTIVE PRODUCTS */}
          <a className="cards">
            <div className="data_top">
              <h2>
                {activeProducts}
                <p>Active</p>
              </h2>
              <figure className="success">
                <CheckCircleOutlineIcon fontSize="large" />
              </figure>
            </div>

            <div className="ai_insight positive">
              <span>Available for sale</span>
            </div>
          </a>

          {/* OUT OF STOCK */}
          <a className="cards">
            <div className="data_top">
              <h2>
                {outOfStock}
                <p>Out of Stock</p>
              </h2>
              <figure className="danger">
                <RemoveCircleOutlineIcon fontSize="large" />
              </figure>
            </div>

            <div className="ai_insight negative">
              <span>Needs restock</span>
            </div>
          </a>

          {/* LOW STOCK */}
          <a className="cards">
            <div className="data_top">
              <h2>
                {lowStock}
                <p>Low Stock Alert</p>
              </h2>
              <figure className="warning">
                <WarningAmberIcon fontSize="large" />
              </figure>
            </div>

            <div className="ai_insight warning">
              <span>Running low</span>
            </div>
          </a>
        </div>

        <div className="table_flex mt_20">
          <div className="lt">
            <div className="cards">
              <div className="table_header">
                <div className="left_s">
                  <Box className="search_box">
                    <SearchBar
                      searchTerm={searchTerm}
                      setDebouncedSearchTerm={setSearchTerm}
                      placeholder="Search products..."
                    />
                  </Box>
                  <div className="form">
                    <Select
                      multiple
                      displayEmpty
                      value={visibleProductColumns}
                      onChange={(e) =>
                        setVisibleProductColumns(e.target.value as string[])
                      }
                      size="small"
                      renderValue={(selected) =>
                        selected.length === productColumns.length
                          ? "All Columns Selected"
                          : `${selected.length} columns visible`
                      }
                      sx={{ minWidth: 200 }}
                    >
                      {productColumns.map((col) => (
                        <MenuItem key={col} value={col}>
                          <Checkbox
                            checked={visibleProductColumns.includes(col)}
                          />
                          <ListItemText primary={col} />
                        </MenuItem>
                      ))}
                    </Select>
                  </div>

                  <div className="form">
                    <Select value="All" size="small" fullWidth>
                      <MenuItem value="All">All Listing Status</MenuItem>
                      <MenuItem value="Pending">Pending Review</MenuItem>
                      <MenuItem value="Approved">Approved</MenuItem>
                      <MenuItem value="Rejected">Rejected</MenuItem>
                    </Select>
                  </div>
                </div>
                {selectedProducts.length > 0 && (
                  <div className="right_s">
                    <div className="bulk_actions_bar d_flex gap_10 align-center">
                      <span className="info_label">
                        {selectedProducts.length} selected
                      </span>
                      <Button
                        className="btn btn_success btn_small"
                        startIcon={<CheckCircleOutlineIcon />}
                      >
                        Approve
                      </Button>
                      <Button
                        className="btn btn_warning btn_small"
                        startIcon={<AutorenewIcon />}
                      >
                        Request Changes
                      </Button>
                      <Button
                        className="btn btn_danger btn_small"
                        startIcon={<BlockIcon />}
                      >
                        Reject
                      </Button>
                      <Button
                        className="btn btn_grey btn_small"
                        startIcon={<HourglassTopOutlinedIcon />}
                      >
                        Pause
                      </Button>
                    </div>
                  </div>
                )}
              </div>

              <TableContainer className="table_container">
                <Table>
                  <TableHead>
                    <TableRow>
                      {productColumns.map((col, i) => (
                        <TableCell key={i}>{col}</TableCell>
                      ))}
                    </TableRow>
                  </TableHead>

                  <TableBody>
                    {productData.map((item) => (
                      <TableRow key={item.id} hover>
                        <TableCell>
                          <Checkbox
                            checked={selectedProducts.includes(item.id)}
                            onChange={() => toggleProductSelect(item.id)}
                          />
                        </TableCell>
                        <TableCell>
                          <b>{item.productName}</b>
                          <br />
                          <small>{item.productId}</small>
                        </TableCell>

                        <TableCell>
                          <div className="vendor_cell">
                            <b>{item.vendorName}</b>
                            <br />
                            <small>VND-00{item.id}</small>
                          </div>
                        </TableCell>
                        <TableCell>
                          <div className="business_cell">
                            <b>{item.vendorName} Stores</b>
                            <br />
                            <span
                              className="badge1 neutral"
                              style={{ fontSize: "10px", marginTop: "4px" }}
                            >
                              Verified Business
                            </span>
                          </div>
                        </TableCell>
                        <TableCell>{item.category}</TableCell>
                        <TableCell>AED {item.price}</TableCell>

                        <TableCell>
                          <span
                            className={`stock ${item.stock < 10 ? "low" : "ok"}`}
                          >
                            {item.stock}
                          </span>
                        </TableCell>

                        <TableCell>{item.sales}</TableCell>

                        <TableCell>
                          <span
                            className={`status_chip ${(item.listingStatus || "Pending").toLowerCase().replace(" ", "_")}`}
                          >
                            {item.listingStatus || "Pending"}
                          </span>
                        </TableCell>

                        <TableCell>
                          <span
                            className={`status_chip ${(item.saleStatus || "Active").toLowerCase()}`}
                          >
                            {item.saleStatus || "Active"}
                          </span>
                        </TableCell>

                        <TableCell>
                          <span
                            className={`risk_tag ${(item.aiRiskLevel || "Low").toLowerCase()}`}
                          >
                            {item.aiRiskLevel === "Low"
                              ? "🟢"
                              : item.aiRiskLevel === "Medium"
                                ? "🟡"
                                : "🔴"}{" "}
                            {item.aiRiskLevel || "Low"}
                          </span>
                        </TableCell>

                        <TableCell>
                          <div className="form">
                            <Select
                              value={item.aiaction}
                              size="small"
                              fullWidth
                              className={`action_select ${item.aiaction === "Reject" ? "danger" : item.aiaction === "Accept" ? "success" : "warning"}`}
                            >
                              <MenuItem value="Accept">✅ Approve</MenuItem>
                              <MenuItem value="Request Changes">
                                ✏️ Changes
                              </MenuItem>
                              <MenuItem value="Reject">❌ Reject</MenuItem>
                              <MenuItem value="Flag for Review">
                                🚩 Flag
                              </MenuItem>
                            </Select>
                          </div>
                        </TableCell>

                        <TableCell>
                          <Tooltip title={item.aiWhy} arrow>
                            <span
                              className="info_text_truncate"
                              style={{ fontSize: "12px", color: "#666" }}
                            >
                              {item.aiWhy}
                            </span>
                          </Tooltip>
                        </TableCell>

                        <TableCell>
                          <div className="table_actions v2">
                            <IconButton
                              onClick={() => {
                                setSelectedProductDetails(item);
                                setOpenProductDrawer(true);
                              }}
                            >
                              <img src="/static/images/eye_icon.svg" />
                            </IconButton>
                            <IconButton>
                              <img src="/static/images/edit2_icon.svg" />
                            </IconButton>
                          </div>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </div>
          </div>
          <div className="rt">
            <div className="ai_panel">
              <h4>AI Insights</h4>

              <div className="ai_alert warning">
                <span className="icon">⚠️</span>
                <p>
                  <b>7 SKUs</b> need immediate attention
                </p>
              </div>

              <div className="ai_alert danger">
                <span className="icon">⛔</span>
                <p>
                  <b>3 SKUs</b> have zero sales in 30 days
                </p>
              </div>

              <small className="ai_update">
                Next updated ETA: <b>May 5, 2024</b>
              </small>

              <div className="ai_sku_list">
                <div className="ai_sku_row">
                  <div className="ai_sku_info">
                    <h5>#PRD_002</h5>
                    <p>Likely to go out of stock by May</p>
                  </div>
                  <button className="ai_action_btn">Actions ▾</button>
                </div>

                <div className="ai_sku_row">
                  <div className="ai_sku_info">
                    <h5>#PRD_010</h5>
                    <p>Likely to go out of stock by May</p>
                  </div>
                  <button className="ai_action_btn">Actions ▾</button>
                </div>
              </div>

              {/* <div className="ai_create">
                                    + Create AI Insights
                                </div> */}
            </div>
          </div>
        </div>
      </CustomTabPanel>
      <CustomTabPanel value={valueTabs1} index={7}>
        <div className="main_title d_flex">
          <div className="left_s">
            <h1>Vendor Payouts</h1>
            <p>
              <button onClick={() => navigate("/dashboard")}>Dashboard</button>{" "}
              - Vendor Payouts
            </p>
          </div>
          <div className="right_s form">
            <input type="date" />
          </div>
        </div>
        <div className="stats_boxes gap_m">
          {/* TOTAL PAYOUTS */}
          <a className="cards">
            <div className="data_top">
              <h2>
                AED {totalPayoutAmount.toLocaleString()}
                <p>Total Payouts</p>
              </h2>
              <figure className="blue">
                <AttachMoneyOutlinedIcon fontSize="large" />
              </figure>
            </div>
          </a>

          {/* COMPLETED */}
          <a className="cards">
            <div className="data_top">
              <h2>
                {completedPayoutsCount}
                <p>Completed</p>
              </h2>
              <figure className="sucess">
                <CheckCircleOutlineIcon fontSize="large" />
              </figure>
            </div>
          </a>

          {/* PENDING */}
          <a className="cards">
            <div className="data_top">
              <h2>
                {pendingPayoutsCount}
                <p>Pending Review/Hold</p>
              </h2>
              <figure className="warning">
                <AccessTimeOutlinedIcon fontSize="large" />
              </figure>
            </div>
          </a>

          {/* ACTIVE SCHEDULES */}
          <a className="cards">
            <div className="data_top">
              <h2>
                0<p>Active Schedules</p>
              </h2>
              <figure className="purple">
                <EventOutlinedIcon fontSize="large" />
              </figure>
            </div>
          </a>
        </div>
        <Box className="custom_tabs mt_20">
          <Tabs
            value={valueTabs2}
            onChange={handleChangeTabs2}
            className="custom_tabs_links"
          >
            <Tab label="Payout History" {...a11yProps(0)} />
            <Tab label="Schedules" {...a11yProps(1)} />
            <Tab label="Balances" {...a11yProps(2)} />
          </Tabs>
        </Box>
        <CustomTabPanel value={valueTabs2} index={0}>
          <div className="cards mt_20">
            <div className="table_header">
              <div className="left_s">
                <Box className="search_box">
                  <SearchBar
                    searchTerm={payoutSearchTerm}
                    setDebouncedSearchTerm={setPayoutSearchTerm}
                    placeholder="Search vendor or ID..."
                  />
                </Box>
                <div className="form">
                  <Select
                    value={payoutStatusFilter}
                    onChange={(e) => setPayoutStatusFilter(e.target.value)}
                    size="small"
                  >
                    <MenuItem value="All">All Status</MenuItem>
                    <MenuItem value="Pending Review">Pending Review</MenuItem>
                    <MenuItem value="Approved">Approved</MenuItem>
                    <MenuItem value="Hold">Hold</MenuItem>
                    <MenuItem value="Completed">Completed</MenuItem>
                    <MenuItem value="Failed">Failed</MenuItem>
                  </Select>

                  <Select
                    value={payoutRiskFilter}
                    onChange={(e) => setPayoutRiskFilter(e.target.value)}
                    size="small"
                  >
                    <MenuItem value="All">All Risk</MenuItem>
                    <MenuItem value="Low Safe">
                      Low Risk (Auto-Approve)
                    </MenuItem>
                    <MenuItem value="Medium Review">
                      Medium Risk (Review)
                    </MenuItem>
                    <MenuItem value="High Hold">High Risk (Hold)</MenuItem>
                  </Select>
                </div>
              </div>
              <div className="right_s">
                <div className="form mr_10">
                  <Select
                    multiple
                    displayEmpty
                    value={visiblePayoutColumns}
                    onChange={(e) =>
                      setVisiblePayoutColumns(e.target.value as string[])
                    }
                    size="small"
                    renderValue={(selected) =>
                      selected.length === payoutColumns.length
                        ? "All Columns Selected"
                        : `${selected.length} columns visible`
                    }
                    sx={{ minWidth: 200 }}
                  >
                    {payoutColumns.map((col) => (
                      <MenuItem key={col} value={col}>
                        <Checkbox checked={visiblePayoutColumns.includes(col)} />
                        <ListItemText primary={col} />
                      </MenuItem>
                    ))}
                  </Select>
                </div>
                <Button className="btn btn_primary" startIcon={<GetAppIcon />}>
                  Export Reports
                </Button>
              </div>
            </div>

            <TableContainer className="table_container">
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell>Vendor Details</TableCell>
                    <TableCell>Business Details</TableCell>
                    <TableCell>Period</TableCell>
                    <TableCell>Net Amount</TableCell>
                    <TableCell>Status</TableCell>
                    <TableCell>AI Recommendation</TableCell>
                    <TableCell>Why AI recommends this</TableCell>
                    <TableCell>Action</TableCell>
                  </TableRow>
                </TableHead>

                <TableBody>
                  {payoutData.map((row, index) => (
                    <TableRow key={index} hover>
                      <TableCell>
                        <div className="vendor_cell">
                          <b>{row.vendorName} Manager</b>
                          <br />
                          <small>{row.vendorId}</small>
                        </div>
                      </TableCell>
                      <TableCell>
                        <div className="business_cell">
                          <b>{row.vendorName}</b>
                          <br />
                          <span
                            className="badge1 neutral"
                            style={{ fontSize: "10px", marginTop: "4px" }}
                          >
                            Verified Business
                          </span>
                        </div>
                      </TableCell>

                      <TableCell>{row.period}</TableCell>

                      <TableCell>
                        <b style={{ fontSize: "15px" }}>
                          AED {row.netAmount.toLocaleString()}
                        </b>
                        {row.previousBalance > 0 && (
                          <div style={{ fontSize: "10px", color: "#666" }}>
                            Incl. AED {row.previousBalance} carryover
                          </div>
                        )}
                      </TableCell>

                      <TableCell>
                        <span className={`badge1 ${row.statusClass}`}>
                          {row.status}
                        </span>
                      </TableCell>

                      <TableCell>
                        <span
                          className={`risk_tag ${row.aiRecommendation.toLowerCase()}`}
                        >
                          {row.aiRecommendation === "Approve"
                            ? "✅"
                            : row.aiRecommendation === "Review"
                              ? "🟡"
                              : "🔴"}{" "}
                          {row.aiRecommendation}
                        </span>
                        <div
                          style={{
                            fontSize: "10px",
                            marginTop: "2px",
                            fontWeight: "bold",
                          }}
                        >
                          Risk Score: {row.aiRiskScore}/100
                        </div>
                      </TableCell>

                      <TableCell>
                        <Tooltip title={row.aiWhy} arrow>
                          <span
                            className="info_text_truncate"
                            style={{
                              fontSize: "12px",
                              color: "#666",
                              maxWidth: "200px",
                              display: "block",
                            }}
                          >
                            {row.aiWhy}
                          </span>
                        </Tooltip>
                      </TableCell>

                      <TableCell>
                        <Button
                          className="btn btn_primary btn_small"
                          onClick={() => {
                            setSelectedPayout(row);
                            setOpenPayoutDrawer(true);
                          }}
                        >
                          Review & Approve
                        </Button>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </div>
        </CustomTabPanel>

        <CustomTabPanel value={valueTabs2} index={1}>
          <div className="cards form">
            <div className="table_header">
              <div className="left_s">
                <Box className="search_box">
                  <SearchBar
                    searchTerm={searchTerm}
                    setDebouncedSearchTerm={setSearchTerm}
                    placeholder="Search vendors..."
                  />
                </Box>
              </div>
            </div>

            <TableContainer className="table_container">
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell>Sr. No</TableCell>
                    <TableCell>Vendor Name</TableCell>
                    <TableCell>Payout Schedule</TableCell>
                    <TableCell>Subscription</TableCell>

                    <TableCell>Commission Rate (%)</TableCell>
                    <TableCell>Amount</TableCell>
                    <TableCell>Expiry Date</TableCell>
                    <TableCell>Status</TableCell>
                    <TableCell>Action</TableCell>
                  </TableRow>
                </TableHead>

                <TableBody>
                  {scheduledPayouts.map((item, index) => (
                    <TableRow key={item.id} hover>
                      {/* Sr No */}
                      <TableCell>{index + 1}</TableCell>

                      {/* Vendor */}
                      <TableCell>
                        <b>{item.vendor}</b>
                      </TableCell>

                      {/* Schedule Type */}
                      <TableCell>
                        <span className="badge1 info">{item.plan}</span>
                      </TableCell>
                      <TableCell>{item.subscriptionType}</TableCell>
                      {/* Commission Rate */}
                      <TableCell>{item.commissionRate}</TableCell>

                      <TableCell>{item.amount}</TableCell>

                      {/* Expiry */}
                      <TableCell className="form">
                        <TextField
                          type="date"
                          defaultValue={item.expiry}
                          fullWidth
                          hiddenLabel
                          size="small"
                        />
                      </TableCell>

                      {/* Actions */}
                      <TableCell>{item.status}</TableCell>
                      <TableCell>
                        <div className="table_actions v2">
                          <Box>
                            <IconButton
                              onClick={() =>
                                navigate("/vendor-payouts/view-payout")
                              }
                            >
                              <img
                                src="/static/images/eye_icon.svg"
                                alt="View"
                              />
                            </IconButton>
                          </Box>
                        </div>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </div>
        </CustomTabPanel>

        <CustomTabPanel value={valueTabs2} index={2}>
          <div className="cards">
            <div className="table_header">
              <div className="left_s">
                <Box className="search_box">
                  <SearchBar
                    searchTerm={searchTerm}
                    setDebouncedSearchTerm={setSearchTerm}
                    placeholder="Search vendor or vendor ID..."
                  />
                </Box>
              </div>
            </div>

            <TableContainer className="table_container">
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell>Vendor ID</TableCell>
                    <TableCell>Vendor Name</TableCell>
                    <TableCell>Pending Amount</TableCell>
                    <TableCell>Subscription</TableCell>
                    <TableCell>Commission (%)</TableCell>

                    <TableCell>Last Payout</TableCell>
                    <TableCell>Last Payout Date</TableCell>

                    <TableCell>Action</TableCell>
                  </TableRow>
                </TableHead>

                <TableBody>
                  {vendorBalances.map((item) => (
                    <TableRow key={item.id} hover>
                      {/* Vendor ID */}
                      <TableCell>
                        <b>{item.vendorId}</b>
                      </TableCell>

                      {/* Vendor Name */}
                      <TableCell>
                        <b>{item.vendorName}</b>
                      </TableCell>

                      {/* Pending Amount */}
                      <TableCell>
                        <b className="text_warning">{item.pendingAmount}</b>
                      </TableCell>
                      <TableCell>{item.subscriptionType}</TableCell>

                      <TableCell>{item.commissionRate}</TableCell>

                      {/* Last Payout */}
                      <TableCell>{item.lastPayout}</TableCell>

                      {/* Last Payout Date */}
                      <TableCell>{item.lastPayoutDate}</TableCell>

                      {/* Status */}

                      <TableCell>
                        <div className="table_actions v2">
                          <Box>
                            <IconButton
                              onClick={() =>
                                navigate("/vendor-payouts/view-payout")
                              }
                            >
                              <img
                                src="/static/images/eye_icon.svg"
                                alt="View"
                              />
                            </IconButton>
                          </Box>
                          <Box>
                            <IconButton onClick={() => setOpen3(true)}>
                              <PaymentIcon />
                            </IconButton>
                          </Box>
                        </div>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </div>
        </CustomTabPanel>
      </CustomTabPanel>
      <CustomTabPanel value={valueTabs1} index={8}>
        <div className="main_title d_flex">
          <div className="left_s">
            <h1>Vendor Segments</h1>
            <p>
              <button onClick={() => navigate("/dashboard")}>Dashboard</button>{" "}
              - Vendor Segments
            </p>
          </div>
          <div className="right_s form">
            <input type="date" />
          </div>
        </div>

        <div className="stats_boxes gap_m">
          {/* TOTAL VENDOR SEGMENTS */}
          <a className="cards">
            <div className="data_top">
              <h2>
                14
                <p>Total Vendor Segments</p>
              </h2>
              <figure className="blue">
                <GpsFixedIcon fontSize="large" />
              </figure>
            </div>

            <div className="ai_insight info">
              <span>All segments</span>
            </div>
          </a>

          {/* ACTIVE SEGMENTS */}
          <a className="cards">
            <div className="data_top">
              <h2>
                14
                <p>Active Segments</p>
              </h2>
              <figure className="success">
                <CheckCircleIcon fontSize="large" />
              </figure>
            </div>

            <div className="ai_insight positive">
              <span>Currently in use</span>
            </div>
          </a>

          {/* VENDORS SEGMENTED */}
          <a className="cards">
            <div className="data_top">
              <h2>
                23,718
                <p>Vendors Segmented</p>
              </h2>
              <figure className="warning">
                <GroupsIcon fontSize="large" />
              </figure>
            </div>

            <div className="ai_insight info">
              <span>Total vendors</span>
            </div>
          </a>

          {/* AVG SEGMENT SIZE */}
          <a className="cards">
            <div className="data_top">
              <h2>
                1,694
                <p>Avg Segment Size</p>
              </h2>
              <figure className="info">
                <TagIcon fontSize="large" />
              </figure>
            </div>

            <div className="ai_insight neutral">
              <span>Vendors per segment</span>
            </div>
          </a>
        </div>

        <div className="table_flex mt_20">
          <div className="lt">
            <div className="cards">
              <div className="table_header">
                <div className="left_s">
                  <Box className="search_box">
                    <SearchBar
                      searchTerm={searchTerm}
                      setDebouncedSearchTerm={setSearchTerm}
                      placeholder="Search vendors..."
                    />
                  </Box>
                </div>
                <div className="right_s">
                  <Button
                    className="btn btn_primary"
                    onClick={() => setOpen5(true)}
                  >
                    <AddIcon />
                    Create Segment{" "}
                  </Button>
                </div>
              </div>
              {/* AI Suggested Segments Section */}
              <div className="segments_section">
                <h3 className="section_title">
                  <SmartToyOutlinedIcon /> AI Suggested Segments
                </h3>
                <div className="segments">
                  {aiSuggestedSegments.map((item, index) => (
                    <div
                      className="segment_card predictive"
                      key={`ai-${index}`}
                      onClick={() =>
                        navigate(
                          `/manage-vendors/view-segment/${item.title.replace(/\s+/g, "-").toLowerCase()}`,
                        )
                      }
                      style={{ cursor: "pointer" }}
                      onMouseEnter={() =>
                        setExpandedAI((prev) => ({
                          ...prev,
                          [`ai-${index}`]: true,
                        }))
                      }
                      onMouseLeave={() =>
                        setExpandedAI((prev) => ({
                          ...prev,
                          [`ai-${index}`]: false,
                        }))
                      }
                    >
                      <div className="card_header">
                        <div className="icon">{item.icon}</div>
                        <span className={`type ${item.type.toLowerCase()}`}>
                          {item.type}
                        </span>
                      </div>

                      <h4>{item.title}</h4>
                      <p className="desc">{item.description}</p>

                      {/* Primary Use Case */}
                      <div className="use_case">
                        <strong>Primary Use Case:</strong> {item.useCase}
                      </div>

                      {/* AI Info (shown on hover/expand) */}
                      {expandedAI[`ai-${index}`] && item.isPredictive && (
                        <div className="ai_info">
                          <div className="ai_reason">
                            <strong>Prediction Reason:</strong>{" "}
                            {item.aiReason || "N/A"}
                          </div>
                          <div className="ai_confidence">
                            <strong>Confidence:</strong>{" "}
                            <span
                              className={`confidence ${(item.confidence || "medium").toLowerCase()}`}
                            >
                              {item.confidence || "Medium"}
                            </span>
                          </div>
                          <div className="ai_action">
                            <strong>Suggested Action:</strong>{" "}
                            {item.suggestedAction || "N/A"}
                          </div>
                        </div>
                      )}

                      {/* Quick Actions */}
                      <div className="quick_actions">
                        <Button
                          size="small"
                          className="action_btn"
                          onClick={() => {
                            // Message vendors action
                          }}
                        >
                          <MessageOutlinedIcon fontSize="small" />
                          Message
                        </Button>
                        <Button
                          size="small"
                          className="action_btn"
                          onClick={() => {
                            // Apply incentive action
                          }}
                        >
                          <AttachMoneyOutlinedIcon fontSize="small" />
                          Incentive
                        </Button>
                        <Button
                          size="small"
                          className="action_btn"
                          onClick={() => {
                            // Flag for review action
                          }}
                        >
                          <FlagOutlinedIcon fontSize="small" />
                          Flag
                        </Button>
                        <Button
                          size="small"
                          className="action_btn"
                          onClick={() => {
                            // Assign account manager action
                          }}
                        >
                          <PersonAddAltIcon fontSize="small" />
                          Assign AM
                        </Button>
                      </div>

                      <div className="card_footer">
                        <span className="count">
                          👥 {item.count.toLocaleString()}
                        </span>
                        <span className="status">{item.status}</span>
                      </div>
                    </div>
                  ))}
                </div>
              </div>

              {/* Risk & Compliance Segments */}
              <div className="segments_section">
                <h3 className="section_title critical">
                  <WarningAmberIcon /> Risk & Compliance Segments (CRITICAL)
                </h3>
                <div className="segments">
                  {segmentData
                    .filter((item) => item.category === "Risk & Compliance")
                    .map((item, index) => (
                      <div
                        className="segment_card"
                        key={`risk-${index}`}
                        onClick={() =>
                          navigate(
                            `/manage-vendors/view-segment/${item.title.replace(/\s+/g, "-").toLowerCase()}`,
                          )
                        }
                        style={{ cursor: "pointer" }}
                      >
                        <div className="card_header">
                          <div className="icon">{item.icon}</div>
                          <span className={`type ${item.type.toLowerCase()}`}>
                            {item.type}
                          </span>
                        </div>

                        <h4>{item.title}</h4>
                        <p className="desc">{item.description}</p>

                        {/* Primary Use Case */}
                        <div className="use_case">
                          <strong>Primary Use Case:</strong> {item.useCase}
                        </div>

                        {/* Quick Actions */}
                        <div className="quick_actions">
                          <Button
                            size="small"
                            className="action_btn"
                            onClick={() => {
                              // Message vendors action
                            }}
                          >
                            <MessageOutlinedIcon fontSize="small" />
                            Message
                          </Button>
                          <Button
                            size="small"
                            className="action_btn"
                            onClick={() => {
                              // Apply incentive action
                            }}
                          >
                            <AttachMoneyOutlinedIcon fontSize="small" />
                            Incentive
                          </Button>
                          <Button
                            size="small"
                            className="action_btn"
                            onClick={() => {
                              // Flag for review action
                            }}
                          >
                            <FlagOutlinedIcon fontSize="small" />
                            Flag
                          </Button>
                          <Button
                            size="small"
                            className="action_btn"
                            onClick={() => {
                              // Assign account manager action
                            }}
                          >
                            <PersonAddAltIcon fontSize="small" />
                            Assign AM
                          </Button>
                        </div>

                        <div className="card_footer">
                          <span className="count">
                            👥 {item.count.toLocaleString()}
                          </span>
                          <span className="status">{item.status}</span>
                        </div>
                      </div>
                    ))}
                </div>
              </div>

              {/* Revenue & Growth Segments */}
              <div className="segments_section">
                <h3 className="section_title">
                  <TrendingUpIcon /> Revenue & Growth Segments
                </h3>
                <div className="segments">
                  {segmentData
                    .filter((item) => item.category === "Revenue & Growth")
                    .map((item, index) => (
                      <div
                        className="segment_card"
                        key={`revenue-${index}`}
                        onClick={() =>
                          navigate(
                            `/manage-vendors/view-segment/${item.title.replace(/\s+/g, "-").toLowerCase()}`,
                          )
                        }
                        style={{ cursor: "pointer" }}
                      >
                        <div className="card_header">
                          <div className="icon">{item.icon}</div>
                          <span className={`type ${item.type.toLowerCase()}`}>
                            {item.type}
                          </span>
                        </div>

                        <h4>{item.title}</h4>
                        <p className="desc">{item.description}</p>

                        {/* Primary Use Case */}
                        <div className="use_case">
                          <strong>Primary Use Case:</strong> {item.useCase}
                        </div>

                        {/* Quick Actions */}
                        <div className="quick_actions">
                          <Button
                            size="small"
                            className="action_btn"
                            onClick={() => {
                              // Message vendors action
                            }}
                          >
                            <MessageOutlinedIcon fontSize="small" />
                            Message
                          </Button>
                          <Button
                            size="small"
                            className="action_btn"
                            onClick={() => {
                              // Apply incentive action
                            }}
                          >
                            <AttachMoneyOutlinedIcon fontSize="small" />
                            Incentive
                          </Button>
                          <Button
                            size="small"
                            className="action_btn"
                            onClick={() => {
                              // Flag for review action
                            }}
                          >
                            <FlagOutlinedIcon fontSize="small" />
                            Flag
                          </Button>
                          <Button
                            size="small"
                            className="action_btn"
                            onClick={() => {
                              // Assign account manager action
                            }}
                          >
                            <PersonAddAltIcon fontSize="small" />
                            Assign AM
                          </Button>
                        </div>

                        <div className="card_footer">
                          <span className="count">
                            👥 {item.count.toLocaleString()}
                          </span>
                          <span className="status">{item.status}</span>
                        </div>
                      </div>
                    ))}
                </div>
              </div>

              {/* Operational Quality Segments */}
              <div className="segments_section">
                <h3 className="section_title">
                  <CheckCircleOutlineIcon /> Operational Quality Segments
                </h3>
                <div className="segments">
                  {segmentData
                    .filter((item) => item.category === "Operational Quality")
                    .map((item, index) => (
                      <div
                        className="segment_card"
                        key={`operational-${index}`}
                        onClick={() =>
                          navigate(
                            `/manage-vendors/view-segment/${item.title.replace(/\s+/g, "-").toLowerCase()}`,
                          )
                        }
                        style={{ cursor: "pointer" }}
                      >
                        <div className="card_header">
                          <div className="icon">{item.icon}</div>
                          <span className={`type ${item.type.toLowerCase()}`}>
                            {item.type}
                          </span>
                        </div>

                        <h4>{item.title}</h4>
                        <p className="desc">{item.description}</p>

                        {/* Primary Use Case */}
                        <div className="use_case">
                          <strong>Primary Use Case:</strong> {item.useCase}
                        </div>

                        {/* Quick Actions */}
                        <div className="quick_actions">
                          <Button
                            size="small"
                            className="action_btn"
                            onClick={() => {
                              // Message vendors action
                            }}
                          >
                            <MessageOutlinedIcon fontSize="small" />
                            Message
                          </Button>
                          <Button
                            size="small"
                            className="action_btn"
                            onClick={() => {
                              // Apply incentive action
                            }}
                          >
                            <AttachMoneyOutlinedIcon fontSize="small" />
                            Incentive
                          </Button>
                          <Button
                            size="small"
                            className="action_btn"
                            onClick={() => {
                              // Flag for review action
                            }}
                          >
                            <FlagOutlinedIcon fontSize="small" />
                            Flag
                          </Button>
                          <Button
                            size="small"
                            className="action_btn"
                            onClick={() => {
                              // Assign account manager action
                            }}
                          >
                            <PersonAddAltIcon fontSize="small" />
                            Assign AM
                          </Button>
                        </div>

                        <div className="card_footer">
                          <span className="count">
                            👥 {item.count.toLocaleString()}
                          </span>
                          <span className="status">{item.status}</span>
                        </div>
                      </div>
                    ))}
                </div>
              </div>

              {/* Other Segments */}
              <div className="segments_section">
                <h3 className="section_title">
                  <TagIcon /> Other Segments
                </h3>
                <div className="segments">
                  {segmentData
                    .filter(
                      (item) =>
                        item.category !== "Risk & Compliance" &&
                        item.category !== "Revenue & Growth" &&
                        item.category !== "Operational Quality",
                    )
                    .map((item, index) => (
                      <div
                        className={`segment_card ${item.isPredictive ? "predictive" : ""}`}
                        key={`other-${index}`}
                        onClick={() =>
                          navigate(
                            `/manage-vendors/view-segment/${item.title.replace(/\s+/g, "-").toLowerCase()}`,
                          )
                        }
                        style={{ cursor: "pointer" }}
                        onMouseEnter={() =>
                          setExpandedAI((prev) => ({
                            ...prev,
                            [`other-${index}`]: true,
                          }))
                        }
                        onMouseLeave={() =>
                          setExpandedAI((prev) => ({
                            ...prev,
                            [`other-${index}`]: false,
                          }))
                        }
                      >
                        <div className="card_header">
                          <div className="icon">{item.icon}</div>
                          <span className={`type ${item.type.toLowerCase()}`}>
                            {item.type}
                          </span>
                        </div>

                        <h4>{item.title}</h4>
                        <p className="desc">{item.description}</p>

                        {/* Primary Use Case */}
                        <div className="use_case">
                          <strong>Primary Use Case:</strong> {item.useCase}
                        </div>

                        {/* AI Info (shown on hover/expand for predictive) */}
                        {expandedAI[`other-${index}`] && item.isPredictive && (
                          <div className="ai_info">
                            <div className="ai_reason">
                              <strong>Prediction Reason:</strong>{" "}
                              {item.aiReason || "N/A"}
                            </div>
                            <div className="ai_confidence">
                              <strong>Confidence:</strong>{" "}
                              <span
                                className={`confidence ${(item.confidence || "medium").toLowerCase()}`}
                              >
                                {item.confidence || "Medium"}
                              </span>
                            </div>
                            <div className="ai_action">
                              <strong>Suggested Action:</strong>{" "}
                              {item.suggestedAction || "N/A"}
                            </div>
                          </div>
                        )}

                        {/* Quick Actions */}
                        <div className="quick_actions">
                          <Button
                            size="small"
                            className="action_btn"
                            onClick={() => {
                              // Message vendors action
                            }}
                          >
                            <MessageOutlinedIcon fontSize="small" />
                            Message
                          </Button>
                          <Button
                            size="small"
                            className="action_btn"
                            onClick={() => {
                              // Apply incentive action
                            }}
                          >
                            <AttachMoneyOutlinedIcon fontSize="small" />
                            Incentive
                          </Button>
                          <Button
                            size="small"
                            className="action_btn"
                            onClick={() => {
                              // Flag for review action
                            }}
                          >
                            <FlagOutlinedIcon fontSize="small" />
                            Flag
                          </Button>
                          <Button
                            size="small"
                            className="action_btn"
                            onClick={() => {
                              // Assign account manager action
                            }}
                          >
                            <PersonAddAltIcon fontSize="small" />
                            Assign AM
                          </Button>
                        </div>

                        <div className="card_footer">
                          <span className="count">
                            👥 {item.count.toLocaleString()}
                          </span>
                          <span className="status">{item.status}</span>
                        </div>
                      </div>
                    ))}
                </div>
              </div>
            </div>
          </div>
          <div className="rt">
            <div className="ai_panel">
              <h4>AI Insights</h4>

              <div className="ai_alert warning">
                <span className="icon">⚠️</span>
                <p>
                  <b>7 SKUs</b> need immediate attention
                </p>
              </div>

              <div className="ai_alert danger">
                <span className="icon">⛔</span>
                <p>
                  <b>3 SKUs</b> have zero sales in 30 days
                </p>
              </div>

              <small className="ai_update">
                Next updated ETA: <b>May 5, 2024</b>
              </small>

              <div className="ai_sku_list">
                <div className="ai_sku_row">
                  <div className="ai_sku_info">
                    <h5>#PRD_002</h5>
                    <p>Likely to go out of stock by May</p>
                  </div>
                  <button className="ai_action_btn">Actions ▾</button>
                </div>

                <div className="ai_sku_row">
                  <div className="ai_sku_info">
                    <h5>#PRD_010</h5>
                    <p>Likely to go out of stock by May</p>
                  </div>
                  <button className="ai_action_btn">Actions ▾</button>
                </div>
              </div>

              {/* <div className="ai_create">
                                    + Create AI Insights
                                </div> */}
            </div>
          </div>
        </div>
      </CustomTabPanel>
      <CustomTabPanel value={valueTabs1} index={9}>
        <div className="main_title d_flex">
          <div className="left_s">
            <h1>Vendor Analytics</h1>
            <p>
              <button onClick={() => navigate("/dashboard")}>Dashboard</button>{" "}
              - Vendor Analytics
            </p>
          </div>
          <div className="right_s form">
            <div className="form">
              <FormControl size="small" sx={{ minWidth: 150 }}>
                <InputLabel id="category-filter-label">Category</InputLabel>
                <Select
                  labelId="category-filter-label"
                  value={selectedCategory}
                  label="Category"
                  onChange={(e) => setSelectedCategory(e.target.value)}
                >
                  <MenuItem value="All">All Categories</MenuItem>
                  <MenuItem value="Fashion">Fashion</MenuItem>
                  <MenuItem value="Electronics">Electronics</MenuItem>
                  <MenuItem value="Beauty">Beauty</MenuItem>
                  <MenuItem value="Home">Home</MenuItem>
                  <MenuItem value="Sports">Sports</MenuItem>
                  <MenuItem value="Grocery">Grocery</MenuItem>
                </Select>
              </FormControl></div>
            <div className="form">
              <FormControl size="small" sx={{ minWidth: 150 }}>
                <InputLabel id="tier-filter-label">Tier</InputLabel>
                <Select
                  labelId="tier-filter-label"
                  value={selectedTier}
                  label="Tier"
                  onChange={(e) => setSelectedTier(e.target.value)}
                >
                  <MenuItem value="All">All Tiers</MenuItem>
                  <MenuItem value="Enterprise">Enterprise</MenuItem>
                  <MenuItem value="Pro">Pro</MenuItem>
                  <MenuItem value="Standard">Standard</MenuItem>
                  <MenuItem value="Free">Free</MenuItem>
                </Select>
              </FormControl>
            </div>
            <div className="d_flex align-center gap_15">


              <div className="time_filter">
                <Button
                  className={`time_filter_btn ${timeFilter === "30d" ? "active" : ""}`}
                  onClick={() => setTimeFilter("30d")}
                  size="small"
                >
                  Last 30 days
                </Button>
                <Button
                  className={`time_filter_btn ${timeFilter === "90d" ? "active" : ""}`}
                  onClick={() => setTimeFilter("90d")}
                  size="small"
                >
                  Last 90 days
                </Button>
                <Button
                  className={`time_filter_btn ${timeFilter === "custom" ? "active" : ""}`}
                  onClick={() => setTimeFilter("custom")}
                  size="small"
                >
                  Custom
                </Button>
                {timeFilter === "custom" && (
                  <div className="custom_date_range">
                    <TextField
                      type="date"
                      size="small"
                      label="From"
                      value={customDateRange.from}
                      onChange={(e) =>
                        setCustomDateRange({
                          ...customDateRange,
                          from: e.target.value,
                        })
                      }
                    />
                    <TextField
                      type="date"
                      size="small"
                      label="To"
                      value={customDateRange.to}
                      onChange={(e) =>
                        setCustomDateRange({
                          ...customDateRange,
                          to: e.target.value,
                        })
                      }
                    />
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>

        {/* TOP ROW - Score Cards */}
        <div className="stats_boxes gap_m vendor_analytics_top">
          {/* TOTAL VENDORS */}
          <a className="cards">
            <div className="data_top">
              <h2>
                1,250
                <p>Total Vendors</p>
              </h2>
              <figure className="blue">
                <GroupsIcon fontSize="large" />
              </figure>
            </div>
            <div className="ai_insight info">
              <span>All vendors onboarded</span>
            </div>
          </a>

          {/* ACTIVE VENDORS */}
          <a className="cards">
            <div className="data_top">
              <h2>
                980
                <p>Active Vendors</p>
              </h2>
              <figure className="sucess">
                <CheckCircleIcon fontSize="large" />
              </figure>
            </div>
            <div className="ai_insight positive">
              <span>78.4% active rate</span>
            </div>
          </a>

          {/* TOTAL VENDOR REVENUE */}
          <a className="cards">
            <div className="data_top">
              <h2>
                AED 3.2M
                <p>Revenue</p>
              </h2>
              <figure className="warning">
                <AccountBalanceWalletOutlinedIcon fontSize="large" />
              </figure>
            </div>
            <div className="ai_insight positive">
              <span>
                Last{" "}
                {timeFilter === "30d"
                  ? "30"
                  : timeFilter === "90d"
                    ? "90"
                    : "custom"}{" "}
                days
              </span>
            </div>
          </a>

          {/* AVG REVENUE PER VENDOR */}
          <a className="cards">
            <div className="data_top">
              <h2>
                AED 3,265
                <p>Avg Revenue per Vendor</p>
              </h2>
              <figure className="info">
                <TrendingUpIcon fontSize="large" />
              </figure>
            </div>
            <div className="ai_insight positive">
              <span>▲ +12.5% vs last period</span>
            </div>
          </a>

          {/* VENDOR CHURN (30D) */}
          <a className="cards">
            <div className="data_top">
              <h2>
                2.4%
                <p>Vendor Churn (30d)</p>
              </h2>
              <figure className="danger">
                <PersonOffIcon fontSize="large" />
              </figure>
            </div>
            <div className="ai_insight negative">
              <span>▼ +0.8% vs last period</span>
            </div>
          </a>
        </div>

        {/* MIDDLE ROW - Top Vendors & Revenue Distribution */}
        <div className="dashboard_cards mt_20 vendor_analytics_middle">
          <div className="row row_2">
            {/* Top Vendors by Revenue Table */}
            <div className="card_block full_width">
              <div className="table_header">
                <h4>Top Vendors by Revenue</h4>
                <p className="subtitle">Who are my best vendors?</p>
              </div>
              <TableContainer>
                <Table size="small">
                  <TableHead>
                    <TableRow>
                      <TableCell>Rank</TableCell>
                      <TableCell>Vendor Name</TableCell>
                      <TableCell>Total Revenue</TableCell>
                      <TableCell>Orders Count</TableCell>
                      <TableCell>Avg Order Value</TableCell>
                      <TableCell>Tier / Plan</TableCell>
                      <TableCell>Health Score</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {topVendorsByRevenue.map((vendor, index) => (
                      <TableRow key={vendor.id} hover>
                        <TableCell>
                          <span className="rank_badge">{index + 1}</span>
                        </TableCell>
                        <TableCell>
                          <b>{vendor.name}</b>
                          <br />
                          <small>{vendor.id}</small>
                        </TableCell>
                        <TableCell>
                          <b>{vendor.revenue}</b>
                        </TableCell>
                        <TableCell>{vendor.orders.toLocaleString()}</TableCell>
                        <TableCell>{vendor.avgOrderValue}</TableCell>
                        <TableCell>
                          <span className="badge1">{vendor.tier}</span>
                        </TableCell>
                        <TableCell>
                          <div className="health_score_inline">
                            <span>{vendor.health}</span>
                          </div>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </div>
          </div>

          {/* Revenue Distribution Row */}
          <div className="row row_3 mt_20">
            {/* Revenue by Tier */}
            <div className="card_block">
              <h4>Revenue Distribution by Tier</h4>
              <p className="subtitle">% of total revenue by vendor tier</p>
              <div className="revenue_distribution">
                <div className="dist_item">
                  <div className="dist_label">
                    <span className="dot enterprise"></span> Enterprise
                  </div>
                  <div className="dist_bar">
                    <div
                      className="dist_fill enterprise"
                      style={{ width: "45%" }}
                    ></div>
                    <span className="dist_value">45%</span>
                  </div>
                </div>
                <div className="dist_item">
                  <div className="dist_label">
                    <span className="dot pro"></span> Pro
                  </div>
                  <div className="dist_bar">
                    <div
                      className="dist_fill pro"
                      style={{ width: "30%" }}
                    ></div>
                    <span className="dist_value">30%</span>
                  </div>
                </div>
                <div className="dist_item">
                  <div className="dist_label">
                    <span className="dot standard"></span> Standard
                  </div>
                  <div className="dist_bar">
                    <div
                      className="dist_fill standard"
                      style={{ width: "20%" }}
                    ></div>
                    <span className="dist_value">20%</span>
                  </div>
                </div>
                <div className="dist_item">
                  <div className="dist_label">
                    <span className="dot free"></span> Free
                  </div>
                  <div className="dist_bar">
                    <div
                      className="dist_fill free"
                      style={{ width: "5%" }}
                    ></div>
                    <span className="dist_value">5%</span>
                  </div>
                </div>
              </div>
            </div>

            {/* Revenue by Category */}
            <div className="card_block">
              <h4>Revenue Distribution by Category</h4>
              <p className="subtitle">
                % by category (Fashion, Electronics, etc.)
              </p>
              <div className="revenue_distribution">
                <div className="dist_item">
                  <div className="dist_label">
                    <span className="dot fashion"></span> Fashion
                  </div>
                  <div className="dist_bar">
                    <div
                      className="dist_fill fashion"
                      style={{ width: "35%" }}
                    ></div>
                    <span className="dist_value">35%</span>
                  </div>
                </div>
                <div className="dist_item">
                  <div className="dist_label">
                    <span className="dot electronics"></span> Electronics
                  </div>
                  <div className="dist_bar">
                    <div
                      className="dist_fill electronics"
                      style={{ width: "25%" }}
                    ></div>
                    <span className="dist_value">25%</span>
                  </div>
                </div>
                <div className="dist_item">
                  <div className="dist_label">
                    <span className="dot beauty"></span> Beauty
                  </div>
                  <div className="dist_bar">
                    <div
                      className="dist_fill beauty"
                      style={{ width: "20%" }}
                    ></div>
                    <span className="dist_value">20%</span>
                  </div>
                </div>
                <div className="dist_item">
                  <div className="dist_label">
                    <span className="dot home"></span> Home
                  </div>
                  <div className="dist_bar">
                    <div
                      className="dist_fill home"
                      style={{ width: "20%" }}
                    ></div>
                    <span className="dist_value">20%</span>
                  </div>
                </div>
              </div>
            </div>

            {/* Revenue by Geography */}
            <div className="card_block">
              <h4>Revenue Distribution by Geography</h4>
              <p className="subtitle">% by geography (UAE regions)</p>
              <div className="revenue_distribution">
                <div className="dist_item">
                  <div className="dist_label">
                    <span className="dot dubai"></span> Dubai
                  </div>
                  <div className="dist_bar">
                    <div
                      className="dist_fill dubai"
                      style={{ width: "50%" }}
                    ></div>
                    <span className="dist_value">50%</span>
                  </div>
                </div>
                <div className="dist_item">
                  <div className="dist_label">
                    <span className="dot abu_dhabi"></span> Abu Dhabi
                  </div>
                  <div className="dist_bar">
                    <div
                      className="dist_fill abu_dhabi"
                      style={{ width: "30%" }}
                    ></div>
                    <span className="dist_value">30%</span>
                  </div>
                </div>
                <div className="dist_item">
                  <div className="dist_label">
                    <span className="dot sharjah"></span> Sharjah
                  </div>
                  <div className="dist_bar">
                    <div
                      className="dist_fill sharjah"
                      style={{ width: "15%" }}
                    ></div>
                    <span className="dist_value">15%</span>
                  </div>
                </div>
                <div className="dist_item">
                  <div className="dist_label">
                    <span className="dot other"></span> Other
                  </div>
                  <div className="dist_bar">
                    <div
                      className="dist_fill other"
                      style={{ width: "5%" }}
                    ></div>
                    <span className="dist_value">5%</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* BOTTOM ROW - Vendor Health Breakdown & AI Insights */}
        <div className="dashboard_cards mt_20 vendor_analytics_bottom">
          <div className="row row_2">
            {/* Vendor Health Breakdown */}
            <div className="card_block health_breakdown">
              <h4>Vendor Health Breakdown</h4>
              <div className="health_metrics">
                <div className="health_metric_item">
                  <div className="metric_label">Avg Vendor Health Score</div>
                  <div className="metric_value">82</div>
                  <div className="metric_trend positive">
                    ▲ +2.5 vs last period
                  </div>
                </div>
                <div className="health_distribution">
                  <div className="health_item">
                    <span className="health_dot healthy"></span>
                    <span className="health_label">Healthy</span>
                    <span className="health_count">720 (72%)</span>
                  </div>
                  <div className="health_item">
                    <span className="health_dot at_risk"></span>
                    <span className="health_label">At Risk</span>
                    <span className="health_count">65 (6.5%)</span>
                  </div>
                  <div className="health_item">
                    <span className="health_dot growing"></span>
                    <span className="health_label">Growing</span>
                    <span className="health_count">180 (18%)</span>
                  </div>
                  <div className="health_item">
                    <span className="health_dot churned"></span>
                    <span className="health_label">Churned (30d)</span>
                    <span className="health_count">35 (3.5%)</span>
                  </div>
                </div>
                <div className="churn_breakdown">
                  <h5>Churn Breakdown</h5>
                  <div className="churn_items">
                    <div className="churn_item">
                      <span>30 days:</span> <b>35 vendors (3.5%)</b>
                    </div>
                    <div className="churn_item">
                      <span>60 days:</span> <b>58 vendors (5.8%)</b>
                    </div>
                    <div className="churn_item">
                      <span>90 days:</span> <b>82 vendors (8.2%)</b>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Additional Metrics */}
            <div className="card_block additional_metrics">
              <h4>Additional Metrics & Insights</h4>
              <div className="metrics_grid">
                <div className="metric_card">
                  <div className="metric_icon">💰</div>
                  <div className="metric_info">
                    <div className="metric_title">Revenue per Vendor</div>
                    <div className="metric_number">AED 3,265</div>
                    <div className="metric_change positive">▲ +12.5%</div>
                  </div>
                </div>
                <div className="metric_card">
                  <div className="metric_icon">📊</div>
                  <div className="metric_info">
                    <div className="metric_title">Avg Orders per Vendor</div>
                    <div className="metric_number">125</div>
                    <div className="metric_change positive">▲ +8.2%</div>
                  </div>
                </div>
                <div className="metric_card">
                  <div className="metric_icon">💵</div>
                  <div className="metric_info">
                    <div className="metric_title">Avg Vendor Commission</div>
                    <div className="metric_number">AED 326</div>
                    <div className="metric_change positive">▲ +10.1%</div>
                  </div>
                </div>
                <div className="metric_card">
                  <div className="metric_icon">✅</div>
                  <div className="metric_info">
                    <div className="metric_title">Vendor Activation Rate</div>
                    <div className="metric_number">78.4%</div>
                    <div className="metric_change positive">▲ +2.3%</div>
                  </div>
                </div>
                <div className="metric_card">
                  <div className="metric_icon">⭐</div>
                  <div className="metric_info">
                    <div className="metric_title">Customer Satisfaction</div>
                    <div className="metric_number">4.2/5</div>
                    <div className="metric_change neutral">→ 0%</div>
                  </div>
                </div>
                <div className="metric_card">
                  <div className="metric_icon">📈</div>
                  <div className="metric_info">
                    <div className="metric_title">
                      Avg Vendor Lifetime Revenue
                    </div>
                    <div className="metric_number">AED 45,200</div>
                    <div className="metric_change positive">▲ +15.8%</div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Smart Actions & AI Insights Row */}
          <div className="row row_2 mt_20">
            {/* Smart Actions */}
            <div className="card_block smart_actions">
              <h4>Smart Actions</h4>
              <div className="actions_grid">
                <Button
                  className="action_card"
                  onClick={() => navigate("/manage-vendors?filter=at-risk")}
                >
                  <WarningAmberIcon />
                  <div>
                    <div className="action_title">View At-Risk Vendors</div>
                    <div className="action_count">
                      65 vendors need attention
                    </div>
                  </div>
                </Button>
                <Button
                  className="action_card"
                  onClick={() => navigate("/manage-vendors?filter=top")}
                >
                  <StarIcon />
                  <div>
                    <div className="action_title">Contact Top Vendors</div>
                    <div className="action_count">Top 10% performers</div>
                  </div>
                </Button>
                <Button
                  className="action_card"
                  onClick={() =>
                    navigate("/manage-vendors?filter=low-performers")
                  }
                >
                  <AttachMoneyOutlinedIcon />
                  <div>
                    <div className="action_title">
                      Apply Incentives to Low Performers
                    </div>
                    <div className="action_count">120 vendors eligible</div>
                  </div>
                </Button>
                <Button
                  className="action_card"
                  onClick={() =>
                    navigate("/manage-vendors?filter=high-performers")
                  }
                >
                  <TrendingUpIcon />
                  <div>
                    <div className="action_title">
                      Promote High-Performing Vendors
                    </div>
                    <div className="action_count">45 vendors ready</div>
                  </div>
                </Button>
              </div>
            </div>

            {/* AI Insights Panel */}
            <div className="card_block ai_insights_panel">
              <h4>
                <SmartToyOutlinedIcon /> AI Insights & Alerts
              </h4>
              <div className="ai_insights_list">
                <div className="ai_insight_item warning">
                  <div className="insight_icon">⚠️</div>
                  <div className="insight_content">
                    <div className="insight_title">
                      Concentration Risk Detected
                    </div>
                    <div className="insight_text">
                      3 vendors generated 42% of total revenue → concentration
                      risk
                    </div>
                    <div className="insight_action">
                      <Button size="small" className="btn btn_secondary">
                        View Details
                      </Button>
                    </div>
                  </div>
                </div>
                <div className="ai_insight_item info">
                  <div className="insight_icon">📊</div>
                  <div className="insight_content">
                    <div className="insight_title">Category Performance</div>
                    <div className="insight_text">
                      Fashion vendors outperform Electronics by 18% this month
                    </div>
                    <div className="insight_action">
                      <Button size="small" className="btn btn_secondary">
                        Analyze
                      </Button>
                    </div>
                  </div>
                </div>
                <div className="ai_insight_item danger">
                  <div className="insight_icon">🚨</div>
                  <div className="insight_content">
                    <div className="insight_title">
                      At-Risk High-Value Vendors
                    </div>
                    <div className="insight_text">
                      2 high-value vendors at risk due to declining fulfillment
                      rates
                    </div>
                    <div className="insight_action">
                      <Button size="small" className="btn btn_primary">
                        Take Action
                      </Button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </CustomTabPanel>

      {/* Vendor Communications (mirrors Customer Communications) */}
      <CustomTabPanel value={valueTabs1} index={10}>
        <div className="main_title">
          <h1>Vendor Communications</h1>
          <p>
            <button onClick={() => navigate("/dashboard")}>Dashboard</button> -
            Vendor Communications
          </p>
        </div>

        <div className="stats_boxes gap_m">
          {/* TOTAL SENT */}
          <a href="#" className="cards">
            <div className="data_top">
              <h2>
                25
                <p>Total Sent</p>
              </h2>
              <figure className="blue">
                <SendIcon fontSize="large" />
              </figure>
            </div>
            <div className="ai_insight info">
              <span>All channels</span>
              <small>emails, sms, push</small>
            </div>
          </a>

          {/* EMAIL */}
          <a href="#" className="cards">
            <div className="data_top">
              <h2>
                8<p>Email</p>
              </h2>
              <figure className="sucess">
                <MailOutlineIcon fontSize="large" />
              </figure>
            </div>
            <div className="ai_insight positive">
              <span>Opened</span>
              <small>email campaigns</small>
            </div>
          </a>

          {/* SMS */}
          <a href="#" className="cards">
            <div className="data_top">
              <h2>
                12
                <p>SMS</p>
              </h2>
              <figure className="warning">
                <SmsOutlinedIcon fontSize="large" />
              </figure>
            </div>
            <div className="ai_insight warning">
              <span>High reach</span>
              <small>text messages</small>
            </div>
          </a>

          {/* PUSH */}
          <a href="#" className="cards">
            <div className="data_top">
              <h2>
                5<p>Push</p>
              </h2>
              <figure className="active_order">
                <NotificationsNoneIcon fontSize="large" />
              </figure>
            </div>
            <div className="ai_insight info">
              <span>App notifications</span>
              <small>real-time alerts</small>
            </div>
          </a>

          {/* DELIVERED */}
          <a href="#" className="cards">
            <div className="data_top">
              <h2>
                21
                <p>Delivered</p>
              </h2>
              <figure className="sucess">
                <CheckCircleIcon fontSize="large" />
              </figure>
            </div>
            <div className="ai_insight positive">
              <span>Successfully sent</span>
              <small>delivery confirmed</small>
            </div>
          </a>
        </div>

        <div className="table_flex mt_20">
          <div className="lt">
            <Box className="custom_tabs1">
              <Tabs
                value={vendorChannelTab}
                onChange={handleVendorChannelTab}
                className="custom_tabs_links"
              >
                <Tab label="All" />
                <Tab label="Email" />
                <Tab label="SMS" />
                <Tab label="Push" />
                <Tab label="In-App" />
              </Tabs>
            </Box>

            <div className="cards mt_20">
              <div className="table_header">
                <div className="left_s">
                  <Box className="search_box">
                    <SearchBar
                      searchTerm={searchTerm}
                      setDebouncedSearchTerm={setSearchTerm}
                      placeholder="Search..."
                    />
                  </Box>
                  <div className="form">
                    <div className="control_group">
                      <input type="date" />
                    </div>
                  </div>
                </div>
                <div className="right_s">
                  <div className="form mr_10">
                    <Select
                      multiple
                      displayEmpty
                      value={visibleCommColumns}
                      onChange={(e) =>
                        setVisibleCommColumns(e.target.value as string[])
                      }
                      size="small"
                      renderValue={(selected) =>
                        selected.length === vendorCommunicationColumns.length
                          ? "All Columns Selected"
                          : `${selected.length} columns visible`
                      }
                      sx={{ minWidth: 200 }}
                    >
                      {vendorCommunicationColumns.map((col) => (
                        <MenuItem key={col} value={col}>
                          <Checkbox checked={visibleCommColumns.includes(col)} />
                          <ListItemText primary={col} />
                        </MenuItem>
                      ))}
                    </Select>
                  </div>
                  <Button
                    className="btn btn_primary"
                    onClick={() => setOpenVendorComm(true)}
                  >
                    Send Message
                  </Button>
                </div>
              </div>

              <TableContainer className="table_container">
                <Table>
                  <TableHead>
                    <TableRow>
                      {vendorCommunicationColumns.map((col, i) => (
                        <TableCell key={i}>{col}</TableCell>
                      ))}
                    </TableRow>
                  </TableHead>

                  <TableBody>
                    {vendorCommunicationData
                      .filter((row) => {
                        if (vendorChannelTab === 0) return true;
                        const tabToChannel: Record<number, string> = {
                          1: "Email",
                          2: "SMS",
                          3: "Push",
                          4: "In-App",
                        };
                        return row.channel === tabToChannel[vendorChannelTab];
                      })
                      .map((row) => (
                        <TableRow key={row.id} hover>
                          <TableCell>{row.channel}</TableCell>

                          <TableCell>
                            <b>{row.subject}</b>
                          </TableCell>

                          <TableCell>{row.type}</TableCell>

                          <TableCell>{row.segment}</TableCell>

                          <TableCell>
                            {row.recipients.toLocaleString()}
                          </TableCell>

                          <TableCell>
                            <span
                              className={`status_chip ${row.delivered / row.recipients >= 0.95
                                ? "active"
                                : "warning"
                                }`}
                            >
                              {((row.delivered / row.recipients) * 100).toFixed(
                                1,
                              )}
                              %
                            </span>
                          </TableCell>

                          <TableCell>
                            <span className="info_label">{row.ctr}</span>
                          </TableCell>

                          <TableCell>
                            <span className={`status_chip ${row.status}`}>
                              {row.status}
                            </span>
                          </TableCell>

                          <TableCell>{row.sentAt}</TableCell>

                          <TableCell>
                            <Button
                              size="small"
                              variant="text"
                              startIcon={<TrendingUpIcon />}
                              onClick={() => {
                                setSelectedVendorComm(row);
                                setOpenVendorCommDetails(true);
                              }}
                            >
                              Drill-down
                            </Button>
                          </TableCell>
                        </TableRow>
                      ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </div>
          </div>

          <div className="rt">
            <div className="ai_panel">
              <h4>Communication Insights</h4>

              <div className="ai_alert danger">
                <span className="icon">📉</span>
                <p>
                  <b>Underperformed:</b> This campaign underperformed vs average
                </p>
              </div>

              <div className="ai_alert warning">
                <span className="icon">⚠️</span>
                <p>
                  <b>Consent Issues:</b> Some vendors blocked due to missing
                  consent
                </p>
              </div>

              <div className="ai_alert success">
                <span className="icon">✅</span>
                <p>
                  <b>Best Channel:</b> Email performs best for Tier upgrade
                  offers
                </p>
              </div>
            </div>
          </div>
        </div>
      </CustomTabPanel>

      <CustomTabPanel value={valueTabs1} index={11}>
        <div className="main_title d_flex">
          <h1>Bulk Export Vendors</h1>
          <p>
            <button onClick={() => navigate("/dashboard")}>Dashboard</button> -
            Bulk Export Vendors
          </p>
        </div>
        <div className="stats_boxes gap_m">
          {/* NEW VENDORS */}
          <a href="/manage-customers?filter=new" className="cards">
            <div className="data_top">
              <h2>
                56
                <p>New Vendors</p>
              </h2>
              <figure className="active_order">
                <PersonAddAltIcon fontSize="large" />
              </figure>
            </div>

            <div className="ai_insight positive">
              <span>▲ +12%</span>
              <small>from last month</small>
            </div>
          </a>

          {/* ACTIVE VENDORS */}
          <a href="/manage-customers?filter=active" className="cards">
            <div className="data_top">
              <h2>
                1,120
                <p>Active Vendors</p>
              </h2>
              <figure className="sucess">
                <CheckCircleIcon fontSize="large" />
              </figure>
            </div>

            <div className="ai_insight info">
              <span>84.0%</span>
              <small>of total vendors</small>
            </div>
          </a>

          {/* INACTIVE VENDORS */}
          <a href="/manage-customers?filter=inactive" className="cards">
            <div className="data_top">
              <h2>
                125
                <p>Inactive Vendors</p>
              </h2>
              <figure className="danger">
                <BlockIcon fontSize="large" />
              </figure>
            </div>

            <div className="ai_insight negative">
              <span>▼ -6%</span>
              <small>from last month</small>
            </div>
          </a>

          {/* PENDING APPROVAL */}
          <a href="/manage-customers" className="cards">
            <div className="data_top">
              <h2>
                92
                <p>Pending Approval Vendors</p>
              </h2>
              <figure className="blue">
                <GroupsIcon fontSize="large" />
              </figure>
            </div>

            <div className="ai_insight warning">
              <span>▲ +8%</span>
              <small>from last month</small>
            </div>
          </a>

          {/* TOTAL VENDORS */}
          <a href="/manage-customers" className="cards">
            <div className="data_top">
              <h2>
                1,301
                <p>Total Vendors</p>
              </h2>
              <figure className="blue">
                <GroupsIcon fontSize="large" />
              </figure>
            </div>

            <div className="ai_insight info">
              <span>100%</span>
              <small>vendor base</small>
            </div>
          </a>
        </div>

        <div className="cards mt_20">
          <div className="table_header table_header_bulk form">
            <h4>Enter Date Range -</h4>
            <input type="date" />
            <input type="date" />
            <Select
              fullWidth
              size="small"
              multiple
              displayEmpty
              value={selectedFields}
              onChange={(e) => setSelectedFields(e.target.value as string[])}
              renderValue={(selected) =>
                selected.length === 0
                  ? "Select Fields To Export"
                  : selected.join(", ")
              }
            >
              {exportFields.map((field) => (
                <MenuItem key={field} value={field}>
                  <Checkbox checked={selectedFields.indexOf(field) > -1} />
                  <ListItemText primary={field} />
                </MenuItem>
              ))}
            </Select>
            <Button className="btn " variant="outlined">
              <GetAppIcon />
              Export
            </Button>
          </div>

          <TableContainer className="table_container">
            <Table>
              <TableHead>
                <TableRow>
                  {exportFields.map((col, i) => (
                    <TableCell key={i}>{col}</TableCell>
                  ))}
                </TableRow>
              </TableHead>

              <TableBody>
                {bulkData.map((vendor, index) => (
                  <TableRow key={vendor.id} hover>
                    {/* Business Details */}
                    <TableCell>
                      <strong>{vendor.businessName}</strong>
                    </TableCell>

                    {/* Vendor Details */}
                    <TableCell>
                      <div>
                        <p>{vendor.email}</p>
                        <small>{vendor.phone}</small>
                      </div>
                    </TableCell>

                    {/* Short Name */}
                    <TableCell>{vendor.shortName}</TableCell>

                    {/* Status */}
                    <TableCell>
                      <span
                        className={`status_chip ${vendor.status.toLowerCase()}`}
                      >
                        {vendor.status}
                      </span>
                    </TableCell>

                    {/* Age */}
                    <TableCell>{vendor.age} yrs</TableCell>

                    {/* Nationality */}
                    <TableCell>{vendor.nationality}</TableCell>

                    {/* No of Stores */}
                    <TableCell>{vendor.storesCount}</TableCell>

                    {/* Store Names */}
                    <TableCell>{vendor.storeNames}</TableCell>

                    {/* License */}
                    <TableCell>{vendor.licenseNumber}</TableCell>

                    {/* Bio */}
                    <TableCell className="truncate">{vendor.bio}</TableCell>

                    {/* Health */}
                    <TableCell>
                      <HealthBar value={vendor.health} />
                    </TableCell>

                    {/* Subscription */}
                    <TableCell>
                      <span
                        className={`tier_chip ${vendor.tier.toLowerCase()}`}
                      >
                        {vendor.tier}
                      </span>
                    </TableCell>

                    {/* Onboarding Date */}
                    <TableCell>{vendor.onboardingDate}</TableCell>

                    {/* Revenue */}
                    <TableCell>{vendor.revenue}</TableCell>

                    {/* Last Order */}
                    <TableCell>{vendor.lastOrder}</TableCell>

                    {/* Suspend */}
                    <TableCell>
                      <SwitchToggle />
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </div>
      </CustomTabPanel>
      <CustomTabPanel value={valueTabs1} index={12}>
        <div className="main_title d_flex">
          <h1>Subscription Management</h1>
          <p>
            <button onClick={() => navigate("/dashboard")}>Dashboard</button> -
            Subscription Management
          </p>
        </div>

        <div className="stats_boxes gap_m">
          <div className="cards">
            <div className="data_top">
              <h2>
                AED 8.4M
                <p>Total Revenue</p>
              </h2>
              <figure className="blue">
                <AttachMoneyOutlinedIcon fontSize="large" />
              </figure>
            </div>
            <div className="ai_insight positive">
              <span>▲ +15%</span>
              <small>from last quarter</small>
            </div>
          </div>

          <div className="cards">
            <div className="data_top">
              <h2>
                1,120
                <p>Active Subscriptions</p>
              </h2>
              <figure className="sucess">
                <CheckCircleOutlineIcon fontSize="large" />
              </figure>
            </div>
            <div className="ai_insight info">
              <span>84.0%</span>
              <small>retention rate</small>
            </div>
          </div>

          <div className="cards">
            <div className="data_top">
              <h2>
                45
                <p>Near Limit</p>
              </h2>
              <figure className="warning">
                <WarningAmberIcon fontSize="large" />
              </figure>
            </div>
            <div className="ai_insight negative">
              <span>▲ +8%</span>
              <small>vs last week</small>
            </div>
          </div>

          <div className="cards">
            <div className="data_top">
              <h2>
                92
                <p>Trialing Vendors</p>
              </h2>
              <figure className="blue">
                <GroupsIcon fontSize="large" />
              </figure>
            </div>
            <div className="ai_insight info">
              <span>12.5%</span>
              <small>conversion potential</small>
            </div>
          </div>
        </div>
        <div className="table_flex mt_20">
          <div className="lt">
            <div className="cards ">
              <div className="table_header">
                <div className="left_s">
                  <Box className="search_box">
                    <SearchBar
                      searchTerm={searchTerm}
                      setDebouncedSearchTerm={setSearchTerm}
                      placeholder="Search Vendors, Plans..."
                    />
                  </Box>
                  <div className="form">
                    <div className="control_group">
                      <Select
                        size="small"
                        value={timeFilter}
                        onChange={(e) => setTimeFilter(e.target.value)}
                        sx={{ minWidth: 120 }}
                      >
                        <MenuItem value="all">Plans</MenuItem>
                        <MenuItem value="scale">Scale+</MenuItem>
                        <MenuItem value="pro">Pro</MenuItem>
                        <MenuItem value="standard">Standard</MenuItem>
                      </Select>
                    </div>
                    <div className="control_group">
                      <Select
                        size="small"
                        value={usageFilter}
                        onChange={(e) => setUsageFilter(e.target.value)}
                        sx={{ minWidth: 120 }}
                      >
                        <MenuItem value="all">Usage</MenuItem>
                        <MenuItem value="high">High</MenuItem>
                        <MenuItem value="medium">Medium</MenuItem>
                        <MenuItem value="low">Low</MenuItem>
                      </Select>
                    </div>
                    <div className="control_group">
                      <Select
                        size="small"
                        value={revenueFilter}
                        onChange={(e) => setRevenueFilter(e.target.value)}
                        sx={{ minWidth: 120 }}
                      >
                        <MenuItem value="all">Revenue</MenuItem>
                        <MenuItem value="high">High</MenuItem>
                        <MenuItem value="medium">Medium</MenuItem>
                        <MenuItem value="low">Low</MenuItem>
                      </Select>
                    </div>
                    <div className="control_group">
                      <Select
                        size="small"
                        value={subStatusFilter}
                        onChange={(e) => setSubStatusFilter(e.target.value)}
                        sx={{ minWidth: 120 }}
                      >
                        <MenuItem value="all">Status</MenuItem>
                        <MenuItem value="active">Active</MenuItem>
                        <MenuItem value="trial">Trial</MenuItem>
                        <MenuItem value="expired">Expired</MenuItem>
                      </Select>
                    </div>
                    <div className="control_group">
                      <Select
                        size="small"
                        value={aiCostFilter}
                        onChange={(e) => setAiCostFilter(e.target.value)}
                        sx={{ minWidth: 120 }}
                      >
                        <MenuItem value="all">AI Cost</MenuItem>
                        <MenuItem value="high">High</MenuItem>
                        <MenuItem value="medium">Medium</MenuItem>
                        <MenuItem value="low">Low</MenuItem>
                      </Select>
                    </div>
                  </div>
                </div>
                <div className="right_s">
                  <Stack direction="row" spacing={1}>
                    <Button
                      variant="outlined"
                      size="small"
                      className="btn btn_grey"
                      startIcon={<GetAppIcon />}
                    >
                      Export 
                    </Button>
                  
                  </Stack>
                </div>
              </div>

              <TableContainer className="table_container">
                <Table>
                  <TableHead>
                    <TableRow>
                      {subscriptionManagementColumns.map((col, i) => (
                        <TableCell key={i}>{col}</TableCell>
                      ))}
                    </TableRow>
                  </TableHead>

                  <TableBody>
                    {subscriptionManagementData.map((row) => (
                        <TableRow key={row.id} hover>
                          <TableCell>
                            <Checkbox
                              checked={selected.includes(row.id)}
                              onChange={() => toggleSelect(row.id)}
                            />
                          </TableCell>
                          <TableCell>
                            <strong>{row.businessName}</strong>
                          </TableCell>
                          <TableCell>
                            <div>
                              <p>{row.vendorEmail}</p>
                              <small>{row.vendorPhone}</small>
                            </div>
                          </TableCell>
                          <TableCell>
                            <span
                              className={`tier_chip ${row.subscriptionName.toLowerCase().replace("+", "_plus")}`}
                            >
                              {row.subscriptionName}
                            </span>
                          </TableCell>
                          <TableCell>
                            <span
                              className={`status_chip ${row.status.toLowerCase()}`}
                            >
                              {row.status}
                            </span>
                          </TableCell>

                          <TableCell>
                            <HealthBar value={row.usageLevel} />
                          </TableCell>

                          <TableCell>
                            <span className={`status_chip ${row.revenueContribution.toLowerCase() === 'high' ? 'active' : row.revenueContribution.toLowerCase() === 'medium' ? 'warning' : 'danger'}`}>
                              {row.revenueContribution}
                            </span>
                          </TableCell>

                          <TableCell>
                            <span className={`status_chip ${row.aiCostImpact.toLowerCase() === 'high' ? 'danger' : row.aiCostImpact.toLowerCase() === 'medium' ? 'warning' : 'active'}`}>
                              {row.aiCostImpact}
                            </span>
                          </TableCell>

                          <TableCell>
                            <Button
                              size="small"
                              variant="text"
                              startIcon={<ArrowForwardIcon />}
                              onClick={() =>
                                navigate(
                                  "/manage-vendors/view-vendor/view-subscription",
                                )
                              }
                            >
                              View Details
                            </Button>
                          </TableCell>
                        </TableRow>
                      ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </div>
          </div>
          <div className="rt">
            <div className="ai_panel d_flex gap_20 overflow-x-auto pb_10">
              <div
                className="ai_alert success flex-grow-1"
                style={{ minWidth: "300px" }}
              >
                <div className="d_flex align-center">
                  <span className="icon">🚀</span>
                  <p>
                    <b>High-Growth Alert:</b> 12 Vendors in 'Pro' hitting 90% AI
                    limits.
                    <Button
                      size="small"
                      variant="text"
                      sx={{ ml: 1, textTransform: "none" }}
                    >
                      Bulk Upgrade
                    </Button>
                  </p>
                </div>
              </div>

              <div
                className="ai_alert danger flex-grow-1"
                style={{ minWidth: "300px" }}
              >
                <div className="d_flex align-center">
                  <span className="icon">⚠️</span>
                  <p>
                    <b>Churn Risk:</b> 5 Enterprise vendors inactive for 14+
                    days.
                    <Button
                      size="small"
                      variant="text"
                      sx={{ ml: 1, textTransform: "none" }}
                    >
                      View List
                    </Button>
                  </p>
                </div>
              </div>

              <div
                className="ai_alert warning flex-grow-1"
                style={{ minWidth: "300px" }}
              >
                <div className="d_flex align-center">
                  <span className="icon">💡</span>
                  <p>
                    <b>Optimization:</b> "Scale+" segment has 40% higher GMV.
                    <Button
                      size="small"
                      variant="text"
                      sx={{ ml: 1, textTransform: "none" }}
                    >
                      Compare Plans
                    </Button>
                  </p>
                </div>
              </div>
            </div>
          </div>{" "}
        </div>
      </CustomTabPanel>
      <LifecycleOverview
        open={open}
        onClose={handleCloseModal}
        setOpen={setOpen}
      />
      <RejectReasonModal
        open={open1}
        onClose={handleCloseModal1}
        setOpen={setOpen1}
      />
      <AddMilestone
        open={open2}
        onClose={handleCloseModal2}
        setOpen={setOpen2}
      />
      <SendPayout open={open3} onClose={handleCloseModal3} setOpen={setOpen3} />
      <CreateSegment
        open={open5}
        onClose={handleCloseModal5}
        setOpen={setOpen5}
      />
      <ViewHealthScores
        open={open6}
        onClose={handleCloseModal6}
        setOpen={setOpen6}
      />
      <BulkNotify open={open7} onClose={handleCloseModal7} setOpen={setOpen7} />
      <VendorCommunicationDetails
        open={openVendorCommDetails}
        onClose={handleCloseVendorCommDetails}
        data={selectedVendorComm}
      />
      <AddVendorCommunications
        open={openVendorComm}
        onClose={() => setOpenVendorComm(false)}
        setOpen={setOpenVendorComm}
      />
      <ProductReviewDrawer
        open={openProductDrawer}
        onClose={() => setOpenProductDrawer(false)}
        data={selectedProductDetails}
      />
      <PayoutDetailDrawer
        open={openPayoutDrawer}
        onClose={() => setOpenPayoutDrawer(false)}
        data={selectedPayout}
      />
      <Drawer
        anchor="right"
        open={openDrawer}
        onClose={toggleDrawer(false)}
        className="filter_drawer"
      >
        <div className="drawer_inner">
          <h3>Filters</h3>

          <div className="form">
            <div className="gap_p">
              {/* Tier */}
              <div className="control_group">
                <label htmlFor="tier_filter">Tier</label>
                <Select
                  id="tier_filter"
                  fullWidth
                  value={tierFilter}
                  onChange={(e) => setTierFilter(e.target.value)}
                >
                  <MenuItem value="">All Tiers</MenuItem>
                  <MenuItem value="Enterprise">Enterprise</MenuItem>
                  <MenuItem value="Pro">Pro</MenuItem>
                  <MenuItem value="Standard">Standard</MenuItem>
                </Select>
              </div>

              {/* Health Score Range */}
              <div className="control_group">
                <label htmlFor="hs_min">Health Score Range</label>
                <div className="d_flex gap_10">
                  <TextField
                    id="hs_min"
                    type="number"
                    placeholder="Min"
                    value={healthScoreMin}
                    onChange={(e) => setHealthScoreMin(e.target.value)}
                    size="small"
                  />
                  <TextField
                    id="hs_max"
                    type="number"
                    placeholder="Max"
                    value={healthScoreMax}
                    onChange={(e) => setHealthScoreMax(e.target.value)}
                    size="small"
                    inputProps={{ 'aria-label': 'Health Score Max' }}
                  />
                </div>
              </div>

              {/* Revenue Range */}
              <div className="control_group">
                <label htmlFor="rev_min">Revenue Range (AED)</label>
                <div className="d_flex gap_10">
                  <TextField
                    id="rev_min"
                    type="number"
                    placeholder="Min"
                    value={revenueMin}
                    onChange={(e) => setRevenueMin(e.target.value)}
                    size="small"
                  />
                  <TextField
                    id="rev_max"
                    type="number"
                    placeholder="Max"
                    value={revenueMax}
                    onChange={(e) => setRevenueMax(e.target.value)}
                    size="small"
                    inputProps={{ 'aria-label': 'Revenue Max' }}
                  />
                </div>
              </div>

              {/* Status */}
              <div className="control_group">
                <label htmlFor="status_filter">Status</label>
                <Select
                  id="status_filter"
                  fullWidth
                  value={statusFilter}
                  onChange={(e) => setStatusFilter(e.target.value)}
                >
                  <MenuItem value="">All Statuses</MenuItem>
                  <MenuItem value="Active">🟢 Active</MenuItem>
                  <MenuItem value="Under Review">🟠 Under Review</MenuItem>
                  <MenuItem value="Probation">🟡 Probation</MenuItem>
                  <MenuItem value="Suspended">🔴 Suspended</MenuItem>
                  <MenuItem value="Inactive">
                    ⚪ Inactive (vendor-chosen)
                  </MenuItem>
                </Select>
              </div>

              {/* Vendor Type */}
              <div className="control_group">
                <label htmlFor="vendor_type_filter">Vendor Type</label>
                <Select
                  id="vendor_type_filter"
                  fullWidth
                  value={vendorTypeFilter}
                  onChange={(e) => setVendorTypeFilter(e.target.value)}
                >
                  <MenuItem value="">All Types</MenuItem>
                  <MenuItem value="Fashion">Fashion</MenuItem>
                  <MenuItem value="Electronics">Electronics</MenuItem>
                  <MenuItem value="Home & Garden">Home & Garden</MenuItem>
                  <MenuItem value="Beauty">Beauty</MenuItem>
                </Select>
              </div>
            </div>

            <div className="btn_flex mt_20">
              <Button className="btn btn_grey" onClick={toggleDrawer(false)}>
                Cancel
              </Button>
              <Button className="btn btn_primary" onClick={toggleDrawer(false)}>
                Apply
              </Button>
            </div>
          </div>
        </div>
      </Drawer>
    </>
  );
};

const ProductReviewDrawer = ({
  open,
  onClose,
  data,
}: {
  open: boolean;
  onClose: () => void;
  data: any;
}) => {
  if (!data) return null;

  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={onClose}
      className="review_drawer"
    >
      <div className="drawer_inner" style={{ width: "500px" }}>
        <div className="d_flex justify-between align-center mb_20">
          <h3>Product Review</h3>
          <IconButton onClick={onClose}>
            <CloseIcon />
          </IconButton>
        </div>

        <div className="preview_section mb_20">
          <img
            src={data.images[0]}
            style={{
              width: "100%",
              borderRadius: "12px",
              height: "240px",
              objectFit: "cover",
            }}
            alt="Product"
          />
          <h2 className="mt_10">{data.productName}</h2>
          <p className="text_grey">
            {data.productId} | {data.category}
          </p>
        </div>

        <div
          className="score_section cards p_15 mb_20"
          style={{ background: "#f8fafc" }}
        >
          <div className="d_flex justify-between align-center mb_10">
            <Typography variant="h6">Approval Score</Typography>
            <span
              className={`score_badge ${data.approvalScore >= 80 ? "success" : data.approvalScore >= 60 ? "warning" : "danger"}`}
            >
              {data.approvalScore}/100
            </span>
          </div>
          <div className="progress_container mb_15">
            <div
              className="progress_bar"
              style={{
                width: `${data.approvalScore}%`,
                background:
                  data.approvalScore >= 80
                    ? "#22c55e"
                    : data.approvalScore >= 60
                      ? "#f59e0b"
                      : "#ef4444",
              }}
            ></div>
          </div>
          <div className="grid_2_col gap_10">
            {Object.entries(data.scoreBreakdown).map(
              ([key, value]: [string, any]) => (
                <div key={key} className="score_item">
                  <small className="text_capitalize">
                    {key}: {value}%
                  </small>
                </div>
              ),
            )}
          </div>
        </div>

        <div className="ai_analysis cards p_15 mb_20">
          <Typography variant="h6" className="mb_10">
            AI Risk Highlights
          </Typography>
          <div className={`risk_alert ${data.aiRiskLevel.toLowerCase()}`}>
            <SmartToyOutlinedIcon sx={{ mr: 1 }} />
            <p>
              <b>{data.aiRiskLevel} Risk:</b> {data.aiWhy}
            </p>
          </div>

          {data.listingStatus === "Pending Review" && (
            <div className="ai_suggestion mt_15">
              <Typography variant="subtitle2" color="primary">
                AI Suggests Requesting:
              </Typography>
              <ul className="suggestion_list mt_5">
                <li>• Better resolution images (&gt;800px)</li>
                <li>• Add technical specifications</li>
                <li>• Verify pricing (15% &gt; category median)</li>
              </ul>
            </div>
          )}
        </div>

        <div className="vendor_context cards p_15 mb_20">
          <Typography variant="subtitle2" className="text_grey mb_5">
            Vendor Performance
          </Typography>
          <div className="d_flex align-center">
            <Typography variant="body1">
              <b>{data.vendorName}</b>
            </Typography>
            <span
              className="status_chip active ml_10"
              style={{ fontSize: "10px" }}
            >
              Trusted Tier
            </span>
          </div>
          <p className="mt_5 text_grey" style={{ fontSize: "12px" }}>
            Past Issues: 0 copyright strikes, 1 pricing warning (resolved)
          </p>
        </div>

        <div className="moderation_actions mt_auto pt_20">
          <div className="d_flex gap_10">
            <Button
              fullWidth
              className="btn btn_success"
              startIcon={<CheckCircleOutlineIcon />}
            >
              Approve
            </Button>
            <Button
              fullWidth
              className="btn btn_warning"
              startIcon={<AutorenewIcon />}
            >
              Request Changes
            </Button>
          </div>
          <Button
            fullWidth
            className="btn btn_danger mt_10"
            startIcon={<BlockIcon />}
          >
            Reject Product
          </Button>
        </div>
      </div>
    </Drawer>
  );
};

const PayoutDetailDrawer = ({
  open,
  onClose,
  data,
}: {
  open: boolean;
  onClose: () => void;
  data: any;
}) => {
  if (!data) return null;

  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={onClose}
      className="review_drawer"
    >
      <div className="drawer_inner" style={{ width: "550px" }}>
        <div className="d_flex justify-between align-center mb_20">
          <div>
            <h3 style={{ margin: 0 }}>Payout Summary</h3>
            <p className="text_grey" style={{ fontSize: "12px" }}>
              ID: {data.id} | {data.period}
            </p>
          </div>
          <IconButton onClick={onClose}>
            <CloseIcon />
          </IconButton>
        </div>

        {/* AI RISK INSIGHTS */}
        <div
          className="ai_analysis cards p_15 mb_20"
          style={{ border: "1px solid #e2e8f0", background: "#f8fafc" }}
        >
          <div className="d_flex align-center mb_10">
            <SmartToyOutlinedIcon color="primary" sx={{ mr: 1 }} />
            <Typography variant="h6">AI Risk Assessment</Typography>
          </div>

          <div
            className={`risk_alert ${data.aiRecommendation.toLowerCase()}`}
            style={{
              padding: "12px",
              borderRadius: "8px",
              marginBottom: "12px",
            }}
          >
            <div className="d_flex justify-between align-center">
              <Typography variant="subtitle1">
                <b>{data.aiRecommendation} Recommendation</b>
              </Typography>
              <span
                className={`score_badge ${data.aiRiskScore < 30 ? "success" : data.aiRiskScore < 70 ? "warning" : "danger"}`}
              >
                Risk Score: {data.aiRiskScore}/100
              </span>
            </div>
            <p className="mt_5" style={{ fontSize: "13px" }}>
              {data.aiWhy}
            </p>
          </div>

          <div className="grid_2_col gap_10">
            <div className="info_card">
              <small>Refund Trend</small>
              <p>
                <b>{data.aiRiskScore > 50 ? "High (+12%)" : "Stable"}</b>
              </p>
            </div>
            <div className="info_card">
              <small>Vendor Health</small>
              <p>
                <b>{data.aiRiskScore > 50 ? "Declining" : "Excellent"}</b>
              </p>
            </div>
          </div>
        </div>

        {/* FINANCIAL BREAKDOWN */}
        <div className="cards p_15 mb_20">
          <Typography variant="h6" className="mb_15">
            Financial Breakdown
          </Typography>

          <div className="payout_breakdown_list">
            <div className="item d_flex justify-between mb_10">
              <span>Gross Sales ({data.orders} orders)</span>
              <b>AED {data.grossAmount.toLocaleString()}</b>
            </div>

            <div className="divider mb_10"></div>

            <div
              className="item d_flex justify-between text_danger mb_5"
              style={{ fontSize: "13px" }}
            >
              <span>Refund Deductions</span>
              <span>- AED {data.refundDeductions.toLocaleString()}</span>
            </div>
            <div
              className="item d_flex justify-between text_danger mb_5"
              style={{ fontSize: "13px" }}
            >
              <span>Chargebacks</span>
              <span>- AED {data.chargebacks.toLocaleString()}</span>
            </div>
            <div
              className="item d_flex justify-between text_warning mb_5"
              style={{ fontSize: "13px" }}
            >
              <span>Disputes Held</span>
              <span>- AED {data.disputesHeld.toLocaleString()}</span>
            </div>
            {data.manualAdjustments !== 0 && (
              <div
                className="item d_flex justify-between mb_5"
                style={{
                  fontSize: "13px",
                  color: data.manualAdjustments > 0 ? "#16a34a" : "#ef4444",
                }}
              >
                <Tooltip
                  title={data.adjustmentNote || "Admin adjustment"}
                  arrow
                >
                  <span
                    style={{ borderBottom: "1px dashed #ccc", cursor: "help" }}
                  >
                    Manual Adjustment
                  </span>
                </Tooltip>
                <span>
                  {data.manualAdjustments > 0 ? "+" : "-"} AED{" "}
                  {Math.abs(data.manualAdjustments).toLocaleString()}
                </span>
              </div>
            )}
            {data.previousBalance > 0 && (
              <div
                className="item d_flex justify-between text_success mb_5"
                style={{ fontSize: "13px" }}
              >
                <span>Previous Balance Carryover</span>
                <span>+ AED {data.previousBalance.toLocaleString()}</span>
              </div>
            )}

            <div className="divider mt_10 mb_10"></div>

            <div
              className="item d_flex justify-between mb_5"
              style={{ fontSize: "13px", color: "#666" }}
            >
              <span>Commission ({data.commissionRate}%)</span>
              <span>- AED {data.commissionValue.toLocaleString()}</span>
            </div>
            <div
              className="item d_flex justify-between mb_5"
              style={{ fontSize: "13px", color: "#666" }}
            >
              <span>VAT on Sale (5%)</span>
              <span>+ AED {data.vatOnSale.toLocaleString()}</span>
            </div>
            <div
              className="item d_flex justify-between mb_5"
              style={{ fontSize: "13px", color: "#666" }}
            >
              <span>VAT on Commission (5%)</span>
              <span>- AED {data.vatOnCommission.toLocaleString()}</span>
            </div>

            <div className="divider mt_10 mb_10"></div>

            <div className="item d_flex justify-between pt_5">
              <Typography variant="h5">Final Payable Amount</Typography>
              <Typography variant="h5" color="primary">
                AED {data.netAmount.toLocaleString()}
              </Typography>
            </div>
          </div>
        </div>

        {/* BANK DETAILS */}
        <div className="cards p_15 mb_20" style={{ background: "#fffbeb" }}>
          <div className="d_flex align-center mb_10">
            <AccountBalanceIcon color="warning" sx={{ mr: 1 }} />
            <Typography variant="subtitle1">
              <b>Bank Details (Compliance Verified)</b>
            </Typography>
          </div>
          <div className="grid_2_col gap_15" style={{ fontSize: "13px" }}>
            <div>
              <span className="text_grey">Bank Name</span>
              <p>
                <b>{data.bankDetails.bankName}</b>
              </p>
            </div>
            <div>
              <span className="text_grey">Beneficiary</span>
              <p>
                <b>{data.bankDetails.beneficiary}</b>
              </p>
            </div>
            <div style={{ gridColumn: "span 2" }}>
              <span className="text_grey">IBAN</span>
              <p style={{ letterSpacing: "1px" }}>
                <b>{data.bankDetails.iban}</b>
              </p>
            </div>
          </div>
          <div className="compliance_tag mt_10">
            <CheckCircleOutlineIcon
              sx={{ fontSize: "14px", mr: 0.5, color: "#16a34a" }}
            />
            <span style={{ fontSize: "11px", color: "#16a34a" }}>
              VAT Registered: {data.isVatRegistered ? "Yes" : "No"}
            </span>
          </div>
        </div>

        {/* AUDIT TRAIL */}
        <div className="mb_20">
          <Typography
            variant="subtitle2"
            className="text_grey mb_10 d_flex align-center"
          >
            <HistoryIcon sx={{ fontSize: "16px", mr: 0.5 }} /> Audit Trail &
            Logs
          </Typography>
          <div className="audit_list">
            {data.auditTrail.map((log: any, i: number) => (
              <div
                key={i}
                className="audit_item d_flex gap_10 mb_10"
                style={{ fontSize: "12px" }}
              >
                <div className="dot_line">
                  <div className="dot"></div>
                  {i < data.auditTrail.length - 1 && (
                    <div className="line"></div>
                  )}
                </div>
                <div>
                  <p>
                    <b>{log.action}</b> by {log.by}{" "}
                    {log.note && (
                      <span className="text_grey">- {log.note}</span>
                    )}
                  </p>
                  <small className="text_grey">{log.date}</small>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* RECOMMENDATION & ACTIONS */}
        <div
          className="moderation_actions mt_auto pt_20"
          style={{ borderTop: "1px solid #eee" }}
        >
          {data.holdReason && (
            <div
              className="hold_warning mb_15 p_10"
              style={{
                background: "#fef2f2",
                border: "1px solid #fee2e2",
                borderRadius: "8px",
              }}
            >
              <Typography variant="caption" color="error" display="block">
                <b>Hold Reason:</b> {data.holdReason}
              </Typography>
              <Typography variant="caption" color="error">
                <b>Release Condition:</b> {data.releaseConditions}
              </Typography>
            </div>
          )}

          <div className="d_flex gap_10">
            <Button
              fullWidth
              className="btn btn_success"
              startIcon={<CheckCircleOutlineIcon />}
            >
              Approve Payout
            </Button>
            <Button
              fullWidth
              className="btn btn_warning"
              startIcon={<BlockIcon />}
            >
              Hold Payout
            </Button>
          </div>
          <div className="d_flex gap_10 mt_10">
            <Button fullWidth variant="outlined" className="btn_grey">
              Request Revision
            </Button>
            <Button fullWidth variant="outlined" className="btn_grey">
              Add Comment
            </Button>
          </div>
        </div>
      </div>
    </Drawer>
  );
};

const VendorCommunicationDetails = ({
  open,
  onClose,
  data,
}: {
  open: boolean;
  onClose: () => void;
  data: any;
}) => {
  if (!data) return null;

  return (
    <Modal className="modal rejectReason_modal" open={open} onClose={onClose}>
      <div className="modal-dialog take_action_modal">
        <div className="modal-body">
          <div className="modal_title">
            <h2>Campaign Drill-down</h2>
            <button className="btn-close" onClick={onClose}>
              <CloseIcon />
            </button>
          </div>

          <div className="gap_p">
            <div className="preview_box mt_20">
              <h4>{data.subject}</h4>
              <p>
                <b>Channel:</b> {data.channel}
              </p>
              <p>
                <b>Type:</b> {data.type}
              </p>
              <p>
                <b>Sent At:</b> {data.sentAt}
              </p>
            </div>

            <div className="stats_grid mt_20">
              <div className="insight blue">
                <small>Sent</small>
                <h3>{data.recipients.toLocaleString()}</h3>
              </div>
              <div className="insight green">
                <small>Delivered</small>
                <h3>{data.delivered.toLocaleString()}</h3>
              </div>
              <div className="insight red">
                <small>Failed</small>
                <h3>{(data.failed || 0).toLocaleString()}</h3>
              </div>
            </div>

            <div className="stats_grid mt_10">
              <div className="insight purple">
                <small>CTR</small>
                <h3>{data.ctr}</h3>
              </div>
              <div className="insight yellow">
                <small>Consent issues</small>
                <h3>{(data.consentIssues || 0).toLocaleString()}</h3>
              </div>
              <div className="insight info">
                <small>Revenue influenced</small>
                <h3>{data.revenueInfluenced || "—"}</h3>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default ManageVendors;
